/*
  Polish interface strings. Keys are the English source (see ./index.js);
  a key missing here falls back to English. Generated from the Russian/Spanish key set
  and checked for placeholders and markup; edit by hand like any other map.
*/

const pl = {
  "White pages": "White pages",
  "Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)": "Statyczne strony dla botów/weryfikacji reklam — hostowane tutaj, serwowane z tej samej domeny co Twoja (cloaking bezpieczny dla Google)",
  "White pages (hosted, same-origin)": "White pages (hostowane, ten sam origin)",
  "Safe page URL (external)": "URL bezpiecznej strony (zewnętrzny)",
  "External safe page — the tracker proxies it same-origin (identity tags stripped). Used when no white page is selected. Must be an absolute http(s) URL. This method already passes Google review on its own; a hosted white page is just an extra-robust alternative served fully on your domain.": "Zewnętrzna bezpieczna strona — tracker proxuje ją z tej samej domeny (tagi identyfikujące są usuwane). Używana, gdy nie wybrano white page. Musi być absolutnym adresem URL http(s). Ta metoda sama w sobie przechodzi weryfikację Google; hostowana white page to po prostu jeszcze solidniejsza alternatywa, serwowana w całości z Twojej domeny.",
  "Optional — the most robust option for Google/Facebook: served from your own campaign domain (/wp/…), so the final URL stays on-domain. Select several to rotate a random one per request, so one white isn’t reused across hundreds of ads. Manage under White pages.": "Opcjonalnie — najbardziej solidna opcja dla Google/Facebook: serwowana z domeny Twojej kampanii (/wp/…), dzięki czemu finalny URL zostaje w domenie. Wybierz kilka, aby losowo rotować przy każdym żądaniu — tak jedna white nie jest używana w setkach reklam. Zarządzaj w sekcji White pages.",
  "selected — rotated per request": "wybrane — rotowane przy każdym żądaniu",
  "No white pages yet. Upload some under White pages, then pick them here.": "Brak white pages. Dodaj je w sekcji White pages, a potem wybierz tutaj.",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Select several to rotate a random one per request — so one white isn’t reused across hundreds of ads. Manage under White pages.": "Zalecane dla Google/Facebook: serwowana z domeny Twojej kampanii (/wp/…), dzięki czemu finalny URL reklamy zostaje w domenie i przechodzi weryfikację. Wybierz kilka, aby losowo rotować przy każdym żądaniu — tak jedna white nie jest używana w setkach reklam. Zarządzaj w sekcji White pages.",
  "Static pages for bots & ad review": "Statyczne strony dla botów i weryfikacji reklam",
  "Compliant static pages served to bots and ad reviewers — same-origin on your campaign domain.": "Zgodne statyczne strony wyświetlane botom i weryfikatorom reklam — z tej samej domeny co Twoja kampania.",
  "These pages are hosted here and served same-origin at /wp/<slug>/ on any of your verified domains. Pick one in a campaign’s Cloaking settings — bots and Google/Facebook reviewers get this page, real users get the offer.": "Te strony są hostowane tutaj i serwowane z tej samej domeny pod /wp/<slug>/ na dowolnej z Twoich zweryfikowanych domen. Wybierz jedną w ustawieniach Cloaking kampanii — boty i weryfikatorzy Google/Facebook widzą tę stronę, a prawdziwi użytkownicy — ofertę.",
  "Upload white page": "Dodaj white page",
  "Upload a static ZIP (index.html + assets). PHP is not allowed. Max 50MB.": "Prześlij statyczne archiwum ZIP (index.html + zasoby). PHP jest niedozwolone. Maks. 50 MB.",
  "My white page": "Moja white page",
  "What this white page is for": "Do czego służy ta white page",
  "Static files only (.html/.css/.js/images). No .php.": "Tylko pliki statyczne (.html/.css/.js/obrazy). Bez .php.",
  "Please enter a name for the white page": "Podaj nazwę dla white page",
  "White page uploaded successfully": "White page przesłana pomyślnie",
  "Error uploading white page": "Błąd podczas przesyłania white page",
  "Error loading white pages": "Błąd podczas ładowania white pages",
  "Error deleting white page": "Błąd podczas usuwania white page",
  "White page deleted": "White page usunięta",
  "No white pages": "Brak white pages",
  "Upload a static white page to use for campaign cloaking": "Prześlij statyczną white page do użycia w cloakingu kampanii",
  "Search white pages…": "Szukaj white page…",
  "Same-origin path": "Ścieżka w tej samej domenie",
  "Delete white page": "Usuń white page",
  "This permanently deletes \"{name}\" and its files. Campaigns still pointing at it will fall back to their Safe page URL (or the offer if none).": "To trwale usunie \"{name}\" i jej pliki. Kampanie, które nadal do niej wskazują, przełączą się na URL bezpiecznej strony (lub na ofertę, jeśli jej nie ma).",
  "Multiple HTML pages detected. Select the main page bots will land on.": "Wykryto wiele stron HTML. Wybierz stronę główną, na którą trafią boty.",
  "White page (hosted, same-origin)": "White page (hostowana, ta sama domena)",
  "None — use Safe page URL below": "Brak — użyj URL bezpiecznej strony poniżej",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Manage these under White pages.": "Zalecane dla Google/Facebook: serwowana z twojej domeny kampanii (/wp/…), dzięki czemu finalny URL reklamy pozostaje w domenie i przechodzi weryfikację. Zarządzaj nimi w sekcji White pages.",
  "Safe page URL (external fallback)": "URL bezpiecznej strony (zewnętrzny fallback)",
  "Optional fallback, used only when no white page is selected above. Must be an absolute http(s) URL. Note: an external URL lives on another domain — exactly what triggers Google’s “destination mismatch”, so prefer a white page for paid search.": "Opcjonalny fallback, używany tylko gdy powyżej nie wybrano żadnej white page. Musi być pełnym URL-em http(s). Uwaga: zewnętrzny URL znajduje się w innej domenie — to właśnie wywołuje błąd „destination mismatch” w Google, więc w płatnym search lepiej wybierz white page.",
  "Select a white page or enter a valid http(s) Safe page URL for cloaking": "Wybierz white page lub wpisz prawidłowy URL http(s) bezpiecznej strony do cloakingu",
  "The ready-to-copy tracking link for this campaign. Swap the domain for any verified workspace domain to run several domains on one campaign; the ad network fills the placeholders at click time.": "Gotowy do skopiowania link trackingowy tej kampanii. Zamień domenę na dowolną zweryfikowaną domenę workspace'u, by uruchomić kilka domen na jednej kampanii; sieć reklamowa uzupełnia placeholdery w momencie kliknięcia.",
  "Secret that authenticates incoming postbacks for this campaign. Paste it as &token=… in the postback URLs you give the network. Keep it private; anyone with it can register conversions.": "Sekret uwierzytelniający przychodzące postbacki tej kampanii. Wklej go jako &token=… w URL-ach postback, które podajesz sieci. Trzymaj go w tajemnicy — każdy, kto go ma, może rejestrować konwersje.",
  "Translate the raw status words a network sends into our buckets. Priority: inline URL param > this campaign map > the affiliate-network preset > custom types > built-in defaults.": "Przetłumacz surowe statusy wysyłane przez sieć na nasze kategorie. Priorytet: parametr w URL > mapa tej kampanii > preset sieci afiliacyjnej > typy niestandardowe > wartości domyślne.",
  "Outbound calls that notify another system (your traffic source, another tracker, Telegram) when a conversion arrives. For ad-platform CAPI (Facebook/Google/TikTok) use Conversion forwarders instead — hashed PII and retries.": "Wywołania wychodzące, które powiadamiają inny system (twoje źródło ruchu, inny tracker, Telegram) o nowej konwersji. Dla CAPI platform reklamowych (Facebook/Google/TikTok) użyj zamiast tego Conversion forwarders — hashowane dane osobowe i ponowne próby.",
  "The query-string parameter name in your tracking link — keep it URL-safe: letters, digits and _ (no spaces). Spaces are auto-converted to _ so the link never shows %20.": "Nazwa parametru w linku trackingowym — musi być bezpieczna dla URL: litery, cyfry i _ (bez spacji). Spacje są automatycznie zamieniane na _, więc link nigdy nie pokaże %20.",
  "UA-pattern bots and UAs that fake a search-crawler identity (failed DNS check) get the safe page.": "Boty wykryte po User-Agent oraz UA podszywające się pod crawlera wyszukiwarki (nieudana weryfikacja DNS) otrzymują bezpieczną stronę.",
  "DNS-verified search crawlers (Googlebot/Bingbot/…) get the safe page. Turn off to let them index the real offer.": "Zweryfikowane przez DNS crawlery wyszukiwarek (Googlebot/Bingbot/…) otrzymują bezpieczną stronę. Wyłącz, aby mogły zaindeksować prawdziwą ofertę.",
  "Visitors from datacenter or Tor-exit IPs get the safe page.": "Odwiedzający z IP centrum danych lub węzła wyjściowego Tor otrzymują bezpieczną stronę.",
  "Visitors behind a proxy/VPN get the safe page.": "Odwiedzający za proxy/VPN otrzymują bezpieczną stronę.",
  "Works only when an active Google Ads forwarder exists (simple mode or with a conversion tag). The AW-…/label can be passed per click via the tm parameter, so one campaign credits conversions to different accounts.": "Działa tylko wtedy, gdy istnieje aktywny forwarder Google Ads (tryb prosty lub z tagiem konwersji). AW-…/label można przekazać per klik za pomocą parametru tm, dzięki czemu jedna kampania zalicza konwersje na różne konta.",
  "Fire Google Ads gtag on redirect (click-time conversion)": "Wysyłaj gtag Google Ads przy przekierowaniu (konwersja w momencie kliknięcia)",
  "Fires a Google Ads conversion at the click moment (on /r/, before the offer) from the AW-…/label in the {tm} parameter — no forwarder needed. This optimizes Google on CLICKS, not on registrations/deposits.": "Wysyła konwersję Google Ads w momencie kliknięcia (na /r/, przed ofertą) na podstawie AW-…/label z parametru {tm} — forwarder nie jest potrzebny. To optymalizuje Google pod kątem KLIKNIĘĆ, a nie rejestracji/depozytów.",
  "Click-time signal: the conversion fires for every clean click, so Google optimizes on clicks. To optimize on real registrations/deposits keep this OFF and use the \"Google Ads\" button under Forwarding — S2S postbacks (fires on the broker postback by {gclid}). Leaving both on double-counts.": "Sygnał w momencie kliknięcia: konwersja zalicza się dla każdego czystego kliknięcia, więc Google optymalizuje pod kliknięcia. Aby optymalizować pod rzeczywiste rejestracje/depozyty, zostaw to WYŁĄCZONE i użyj przycisku „Google Ads” w sekcji Forwarding — postbacki S2S (wysyłane przy postbacku brokera po {gclid}). Włączenie obu podwójnie liczy konwersje.",
  "Bot model": "Model botów",
  "Member access": "Dostęp członków",
  "Scope what each team member can see and edit — per entity, plus which report metrics they may read. Owners and admins are never restricted.": "Określ, co każdy członek zespołu może widzieć i edytować — per encja, oraz które metryki raportów może odczytywać. Właściciele i administratorzy nigdy nie są ograniczani.",
  "Member": "Członek",
  "Choose a member…": "Wybierz członka…",
  "Failed to load members": "Nie udało się załadować członków",
  "Retry": "Spróbuj ponownie",
  "No team members yet": "Brak członków zespołu",
  "Invite teammates from the Workspace page, then configure their access here.": "Zaproś współpracowników ze strony Workspace, a następnie skonfiguruj tu ich dostęp.",
  "Pick a member to configure": "Wybierz członka do skonfigurowania",
  "Their entity access and allowed report metrics will show up here.": "Tutaj pojawi się ich dostęp do encji i dozwolone metryki raportów.",
  "Failed to load member access": "Nie udało się załadować dostępu członka",
  "Owners and admins have full, unrestricted access": "Właściciele i administratorzy mają pełny, nieograniczony dostęp",
  "You can still save these rules, but they stay inert unless the role changes to manager or viewer.": "Nadal możesz zapisać te reguły, ale pozostaną nieaktywne, dopóki rola nie zmieni się na menedżera lub przeglądającego.",
  "Entity access": "Dostęp do encji",
  "Full is the default: no restriction. Read-only blocks edits. To selected limits the member to the listed IDs. Created and selected adds anything the member created themselves.": "Pełny to wartość domyślna: brak ograniczeń. Tylko do odczytu blokuje edycję. Do wybranych ogranicza członka do wskazanych ID. Utworzone i wybrane dodaje wszystko, co członek sam utworzył.",
  "Entity": "Encja",
  "Access mode": "Tryb dostępu",
  "Allowed IDs": "Dozwolone ID",
  "Full": "Pełny",
  "Read-only": "Tylko do odczytu",
  "To selected": "Do wybranych",
  "Created and selected": "Utworzone i wybrane",
  "IDs, comma or space separated": "ID oddzielone przecinkiem lub spacją",
  "IDs of the specific items this member may access": "ID konkretnych elementów, do których ten członek ma dostęp",
  "No IDs yet — the member will only see items they created themselves.": "Brak ID — członek zobaczy tylko elementy, które sam utworzył.",
  "No IDs yet — the member will not see any items of this type.": "Brak ID — członek nie zobaczy żadnych elementów tego typu.",
  "All items": "Wszystkie elementy",
  "Allowed report metrics": "Dozwolone metryki raportów",
  "Toggle the metrics this member may see in reports and dashboards. Leaving every metric off means no restriction.": "Włącz lub wyłącz metryki, które ten członek może widzieć w raportach i panelach. Jeśli żadna nie jest zaznaczona, nie ma ograniczeń.",
  "All metrics (no restriction)": "Wszystkie metryki (bez ograniczeń)",
  "metrics allowed": "dozwolonych metryk",
  "Clear (allow all)": "Wyczyść (zezwól na wszystkie)",
  "Save access": "Zapisz dostęp",
  "Member access saved": "Dostęp członka zapisany",
  "Failed to save member access": "Nie udało się zapisać dostępu członka",
  "Click traces": "Ślady kliknięć",
  "Diagnostics": "Diagnostyka",
  "Sampled real clicks with the full routing decision behind each one — which streams were evaluated and why the winner matched.": "Próbka rzeczywistych kliknięć wraz z pełną decyzją routingu dla każdego z nich — które streamy oceniono i dlaczego wygrał zwycięzca.",
  "Pick a campaign above to inspect where its real clicks were routed and why.": "Wybierz kampanię powyżej, aby sprawdzić, dokąd trafiały jej rzeczywiste kliknięcia i dlaczego.",
  "Live-click tracing": "Śledzenie kliknięć na żywo",
  "Enable live-click tracing": "Włącz śledzenie kliknięć na żywo",
  "Off by default. When enabled, a sampled share of real clicks records its full routing trace. Privacy-safe: no IP addresses or user agents are stored, and traces expire automatically.": "Domyślnie wyłączone. Po włączeniu wybrana próbka rzeczywistych kliknięć zapisuje pełny ślad routingu. Bezpieczne dla prywatności: nie przechowujemy adresów IP ani user agentów, a ślady wygasają automatycznie.",
  "Sample rate (%)": "Częstotliwość próbkowania (%)",
  "Share of clicks to trace, from 0 to 100%. Example: 10% traces roughly one click in ten.": "Udział kliknięć do śledzenia, od 0 do 100%. Przykład: 10% oznacza śledzenie mniej więcej jednego kliknięcia na dziesięć.",
  "Sample rate must be between 0 and 100": "Częstotliwość próbkowania musi być w zakresie od 0 do 100",
  "Trace settings saved": "Ustawienia śledzenia zapisane",
  "Error loading click traces": "Błąd podczas wczytywania śladów kliknięć",
  "Could not load traces": "Nie udało się wczytać śladów",
  "Something went wrong while loading click traces for this campaign.": "Coś poszło nie tak podczas wczytywania śladów kliknięć dla tej kampanii.",
  "No traces yet": "Brak śladów",
  "Enable tracing above; traces of sampled real clicks will appear here.": "Włącz śledzenie powyżej; tutaj pojawią się ślady próbkowanych rzeczywistych kliknięć.",
  "Tracing is on — traces of sampled real clicks will appear here as traffic arrives. If nothing shows up, check the sample rate.": "Śledzenie jest włączone — ślady próbkowanych rzeczywistych kliknięć będą się tu pojawiać wraz z napływającym ruchem. Jeśli nic się nie pojawia, sprawdź częstotliwość próbkowania.",
  "Flags": "Flagi",
  "Show routing trace": "Pokaż ślad routingu",
  "Hide routing trace": "Ukryj ślad routingu",
  "Per-stream verdicts": "Werdykty per stream",
  "No per-stream verdicts were recorded for this click.": "Dla tego kliknięcia nie zapisano żadnych werdyktów per stream.",
  "Not matched": "Brak dopasowania",
  "Filters evaluated": "Sprawdzone filtry",
  "Relation": "Relacja",
  "Page": "Strona",
  "entries": "wpisów",
  "just now": "przed chwilą",
  "{n}m ago": "{n} min temu",
  "{n}h ago": "{n} godz. temu",
  "ML bot model": "Model ML bota",
  "Weak-supervision bot classifier: train it on recent clicks, inspect metrics and score ad-hoc payloads. Shadow-only — it never affects live routing.": "Klasyfikator botów oparty na słabym nadzorze: trenuj go na ostatnich kliknięciach, sprawdzaj metryki i oceniaj dowolne payloady. Działa tylko w trybie cienia — nigdy nie wpływa na routing na żywo.",
  "Admin access required": "Wymagany dostęp administratora",
  "The ML bot-model panel is only available to workspace admins.": "Panel modelu ML bota jest dostępny tylko dla adminów workspace.",
  "Error loading bot-model status": "Błąd wczytywania statusu modelu bota",
  "Model status": "Status modelu",
  "Trained": "Wytrenowany",
  "Not trained": "Niewytrenowany",
  "Inference": "Wnioskowanie",
  "Degenerate": "Zdegenerowany",
  "Trained on a single class or too few samples — metrics are not meaningful.": "Wytrenowany na jednej klasie lub zbyt małej liczbie próbek — metryki nie mają sensu.",
  "Inference is off by default and shadow-only — even when enabled, scores are only recorded on clicks for analysis and never affect routing.": "Wnioskowanie jest domyślnie wyłączone i działa tylko w trybie cienia — nawet po włączeniu, wyniki są zapisywane przy kliknięciach wyłącznie do analizy i nigdy nie wpływają na routing.",
  "Accuracy": "Dokładność",
  "Positive rate": "Odsetek pozytywnych",
  "Log loss": "Log loss",
  "AUC": "AUC",
  "Training samples": "Próbki treningowe",
  "Trained at": "Wytrenowano",
  "No bot model trained yet. Train one on recent clicks below.": "Nie ma jeszcze wytrenowanego modelu bota. Wytrenuj go poniżej na ostatnich kliknięciach.",
  "Train model": "Trenuj model",
  "Training…": "Trenowanie…",
  "Training pulls up to 5,000 recent clicks, weak-labels them with the existing bot heuristics (user agent, uniqueness, behaviour score) and fits a small logistic-regression model. Retraining replaces the stored model.": "Trening pobiera do 5000 ostatnich kliknięć, słabo je etykietuje na podstawie istniejących heurystyk bota (user agent, unikalność, wynik zachowania) i dopasowuje mały model regresji logistycznej. Ponowny trening zastępuje zapisany model.",
  "Model trained on {n} clicks — accuracy {acc}": "Model wytrenowany na {n} kliknięciach — dokładność {acc}",
  "Model trained on {n} clicks": "Model wytrenowany na {n} kliknięciach",
  "No click data to train on yet.": "Brak danych o kliknięciach do treningu.",
  "Training finished": "Trening zakończony",
  "Training failed": "Błąd trenowania modelu",
  "Score a sample": "Oceń próbkę",
  "Developer tool: paste a click-shaped JSON payload and run it through the trained model. Nothing is stored and live traffic is unaffected.": "Narzędzie dla developerów: wklej payload JSON w formacie kliknięcia i przepuść go przez wytrenowany model. Nic nie jest zapisywane, a ruch na żywo pozostaje bez zmian.",
  "Click payload (JSON)": "Payload kliknięcia (JSON)",
  "Score": "Oceń",
  "Scoring…": "Ocenianie…",
  "Reset example": "Przywróć przykład",
  "Invalid JSON — check the payload and try again.": "Nieprawidłowy JSON — sprawdź payload i spróbuj ponownie.",
  "Payload must be a JSON object.": "Payload musi być obiektem JSON.",
  "No trained model — train one first.": "Brak wytrenowanego modelu — najpierw go wytrenuj.",
  "Scoring failed": "Błąd oceniania",
  "Likely bot": "Prawdopodobnie bot",
  "Likely human": "Prawdopodobnie człowiek",
  "Threshold 0.5 — scores above are flagged as bots.": "Próg 0.5 — wyniki powyżej są oznaczane jako boty.",
  "Heuristic weak label": "Słaba etykieta heurystyczna",
  "Human": "Człowiek",
  "Feature": "Cecha",
  "{n} min ago": "{n} min temu",
  "{n} h ago": "{n} godz. temu",
  "{n} d ago": "{n} dni temu",
  "Archive & restore": "Archiwizacja i przywracanie",
  "Access control": "Kontrola dostępu",
  "Offer rotation on daily cap": "Rotacja ofert po osiągnięciu dziennego limitu",
  "No threshold needed. This rule fires when any offer used by the campaign reaches its daily cap and notifies you that traffic is rotating to the fallback / remaining offers. Set the cap and fallback offer on each offer.": "Nie trzeba ustawiać progu. Ta reguła uruchamia się, gdy dowolna oferta używana przez kampanię osiągnie swój dzienny limit, i powiadamia cię, że ruch jest przekierowywany na ofertę zapasową / pozostałe oferty. Ustaw limit i ofertę zapasową dla każdej oferty osobno.",
  "Connection types": "Typy połączenia",
  "Filter by network connection type. 'hosting' (datacenter/cloud) works out of the box; other values like cellular or wifi require the edge proxy to send an X-Connection-Type header.": "Filtruj według typu połączenia sieciowego. 'hosting' (datacenter/chmura) działa od razu; inne wartości, jak cellular czy wifi, wymagają, by proxy edge wysyłało nagłówek X-Connection-Type.",
  "Status mapping": "Mapowanie statusów",
  "Add status": "Dodaj status",
  "No status mappings added": "Nie dodano żadnych mapowań statusów",
  "Network status (e.g. ftd)": "Status sieci (np. ftd)",
  "Map the raw status this network sends to a canonical bucket. Applied to inbound postbacks when the campaign status map does not match.": "Zmapuj surowy status wysyłany przez tę sieć na kanoniczny bucket. Stosowane do przychodzących postbacków, gdy mapa statusów kampanii nie pasuje.",
  "Lead": "Lead",
  "Sale": "Sprzedaż",
  "Reject": "Odrzuć",
  "Upsell": "Upsell",
  "Ignore": "Ignoruj",
  "Split testing": "Split testing",
  "Parameter filters": "Filtry parametrów",
  "Params": "Parametry",
  "Split testing enabled": "Split testing włączony",
  "Split testing disabled": "Split testing wyłączony",
  "Failed to update campaign": "Nie udało się zaktualizować kampanii",
  "Flow rotation. On: Normal streams rotate by weight, position is ignored. Off: streams are checked top-down by position and the first match takes all the traffic. Catch streams always intercept first and never rotate by weight.": "Rotacja flow. Włączone: streamy Normal rotują według wagi, pozycja jest ignorowana. Wyłączone: streamy są sprawdzane od góry do dołu według pozycji, a pierwsze dopasowanie przejmuje cały ruch. Streamy Catch zawsze przechwytują jako pierwsze i nigdy nie rotują według wagi.",
  "Route by URL sub-parameters. One rule per line: name=value1, value2 allows listed values; name!=value1, value2 blocks them (a missing parameter passes a block rule). A rule without values adds no constraint.": "Kieruj ruch na podstawie subparametrów URL. Jedna reguła na linię: name=value1, value2 zezwala na wymienione wartości; name!=value1, value2 je blokuje (brakujący parametr przechodzi regułę blokującą). Reguła bez wartości nie dodaje żadnego ograniczenia.",
  "Regions": "Regiony",
  "GeoIP region / state / oblast names (e.g. California, Bavaria). Masks, /regex/ and @empty are supported.": "Nazwy regionu / stanu / obwodu z GeoIP (np. California, Bavaria). Obsługiwane są maski, /regex/ i @empty.",
  "IP addresses": "Adresy IP",
  "Exact IPs, CIDR blocks (10.0.0.0/8) or masks (192.168.*). Handy for allow-listing your own test IPs or blocking a datacenter range.": "Dokładne IP, bloki CIDR (10.0.0.0/8) lub maski (192.168.*). Przydatne do dodania własnych testowych IP do listy dozwolonych lub zablokowania zakresu datacenter.",
  "User agents": "User-Agenty",
  "Substrings, masks or /regex/ matched against the raw User-Agent — e.g. *Chrome/12* targets Chrome 120+, HeadlessChrome catches headless browsers.": "Podciągi, maski lub /regex/ dopasowywane do surowego User-Agenta — np. *Chrome/12* obejmuje Chrome 120+, HeadlessChrome wykrywa przeglądarki headless.",
  "Clicks per hour": "Kliknięcia na godzinę",
  "Rolling-window limit: the stream stops taking NEW clicks after this many in the last hour, traffic falls through to the next stream. Empty = no limit.": "Limit w ruchomym oknie: stream przestaje przyjmować NOWE kliknięcia po osiągnięciu tej liczby w ciągu ostatniej godziny, ruch przechodzi do kolejnego streamu. Puste = brak limitu.",
  "Clicks per 24h": "Kliknięcia na 24h",
  "Rolling-window limit over the last 24 hours. Empty = no limit.": "Limit w kroczącym oknie 24 godzin. Puste = bez limitu.",
  "Filter relation": "Relacja filtrów",
  "AND: the click must pass every configured filter. OR: any single passing filter admits the click.": "AND: klik musi przejść każdy skonfigurowany filtr. OR: wystarczy, że klik przejdzie jeden filtr.",
  "AND (all)": "AND (wszystkie)",
  "OR (any)": "OR (dowolny)",
  "Is": "Jest",
  "Is not": "Nie jest",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone. 'Is not' inverts the schedule: the stream accepts clicks EXCEPT at the listed times.": "Dni tygodnia i godziny, w których stream jest aktywny. Czas podany jest w strefie czasowej właściciela kampanii. 'Nie jest' odwraca harmonogram: stream przyjmuje kliki WYJĄTEK w podanych godzinach.",
  "A free-text network label for notes and filters only — it has no effect. For a real link use the Affiliate network field or the Affiliate routing block below.": "Dowolna etykieta tekstowa sieci, tylko do notatek i filtrów — nie ma żadnego wpływu. Do prawdziwego powiązania użyj pola Sieć afiliacyjna lub bloku Affiliate routing poniżej.",
  "A reusable partner network from the Affiliate networks section: postback template, offer params and per-network reports. Optional.": "Wielokrotnego użytku sieć partnerska z sekcji Affiliate networks: szablon postbacku, parametry oferty i raporty per sieć. Opcjonalnie.",
  "Where the click goes for a plain redirect offer. Macros work: {click_id}, {country_code}, {gclid} and more. For form offers (lead to CRM) the URL can be anything.": "Dokąd trafia klik przy zwykłej ofercie z przekierowaniem. Działają makra: {click_id}, {country_code}, {gclid} i inne. Przy ofertach z formularzem (lead do CRM) URL może być dowolny.",
  "Max conversions per offer per day. When the cap is hit, traffic goes to the fallback offer. Empty = no limit.": "Maksymalna liczba konwersji na ofertę dziennie. Po osiągnięciu limitu ruch trafia do oferty zapasowej (Fallback). Puste = bez limitu.",
  "Time zone in which the daily cap is counted and the counter resets.": "Strefa czasowa, w której liczony jest dzienny limit i resetowany licznik.",
  "Fallback offer: traffic goes here once the main offer hits its daily cap.": "Oferta zapasowa: ruch trafia tutaj, gdy oferta główna osiągnie dzienny limit.",
  "The partner/CRM the lead is sent to. Set up once in the Integrations section (TrackBox or Custom API).": "Partner/CRM, do którego wysyłany jest lead. Skonfiguruj raz w sekcji Integrations (TrackBox lub Custom API).",
  "The offer's Box/Goal ID at the partner — which product/box receives the lead. The partner provides the value (e.g. 420).": "Box/Goal ID oferty u partnera — który produkt/box otrzymuje lead. Wartość podaje partner (np. 420).",
  "Share of leads to this partner when there are several (split/rotation). E.g. 70 and 30 = 70% and 30%.": "Udział leadów trafiających do tego partnera, gdy jest ich kilku (split/rotacja). Np. 70 i 30 = 70% i 30%.",
  "Off = the partner is temporarily skipped (e.g. until launch is agreed); its settings are kept.": "Wyłączone = partner jest tymczasowo pomijany (np. do czasu ustalenia startu); jego ustawienia zostają zachowane.",
  "A per-offer form endpoint for THIS offer only. Usually NOT needed — use the shared /api/lead (see docs). Only for binding a form to one specific offer.": "Endpoint formularza przypisany wyłącznie do TEJ oferty. Zwykle NIE jest potrzebny — użyj wspólnego /api/lead (patrz dokumentacja). Służy tylko do powiązania formularza z konkretną ofertą.",
  "Telegram notification on EVERY form submit (accepted/rejected/test). Separate from the campaign Telegram postback (that fires on a confirmed conversion). Bot token from @BotFather; group Chat ID starts with -100…": "Powiadomienie Telegram przy KAŻDYM wysłaniu formularza (zaakceptowany/odrzucony/test). Osobne od postbacku Telegram w kampanii (ten odpala się przy potwierdzonej konwersji). Token bota z @BotFather; Chat ID grupy zaczyna się od -100…",
  "Default URL when no stream matched. Routing is usually driven by Streams — this field is a safety net.": "Domyślny URL, gdy żaden stream nie pasuje. Routing zwykle ustalają Streamy — to pole jest zabezpieczeniem awaryjnym.",
  "The ad platform (Google Ads, Facebook…). Defines the set of macros/subs appended to the tracking link to pass click data.": "Platforma reklamowa (Google Ads, Facebook…). Określa zestaw makr/subów dodawanych do linku trackingowego, żeby przekazać dane kliknięcia.",
  "How cost is counted: CPC — per click, CPM — per 1000 impressions, CPA — per conversion. Affects Cost / ROI / CPC / CPA in reports.": "Jak liczony jest koszt: CPC — za klik, CPM — za 1000 wyświetleń, CPA — za konwersję. Wpływa na Koszt / ROI / CPC / CPA w raportach.",
  "The GET parameter name the tracker uses to append click_id to the offer URL (e.g. click_id → ?click_id=…). Needed so the partner returns this click_id in the postback. Form snippets read both click_id and clickid.": "Nazwa parametru GET, którym tracker dodaje click_id do URL oferty (np. click_id → ?click_id=…). Potrzebne, żeby partner zwrócił ten click_id w postbacku. Snippety formularzy odczytują zarówno click_id, jak i clickid.",
  "Do not set the xpnsr_vid cookie (for networks that forbid cookies). Uniqueness is then by IP+User Agent, and click_id is passed via URL — the Click ID forward parameter field above.": "Nie ustawiaj ciasteczka xpnsr_vid (dla sieci, które zabraniają cookies). Unikalność liczona jest wtedy po IP+User Agent, a click_id przekazywany jest przez URL — pole Click ID forward parameter powyżej.",
  "Hash the IP before storing (for GDPR). GEO is resolved BEFORE hashing, so country/city targeting is unaffected.": "Hashuj IP przed zapisaniem (dla RODO). GEO jest ustalane PRZED hashowaniem, więc targetowanie po kraju/mieście nie jest zakłócone.",
  "How to redirect: 302 — a plain fast redirect; Meta refresh / JS — when the network does not follow 302 or gtag is needed; Cloaked (iframe) — hide the offer URL in the address bar.": "Sposób przekierowania: 302 — zwykłe szybkie przekierowanie; Meta refresh / JS — gdy sieć nie podąża za 302 albo potrzebny jest gtag; Cloaked (iframe) — ukrywa URL oferty w pasku adresu.",
  "Normal — a regular stream with filters; Catch — catches traffic that matched no Normal stream; Default — the last-resort stream when nothing matched.": "Normal — zwykły stream z filtrami; Catch — łapie ruch, który nie pasował do żadnego Normal; Default — stream ostatniej szansy, gdy nic nie pasuje.",
  "Check priority. The lower the number, the earlier the stream is checked. Traffic goes to the first matching one.": "Priorytet sprawdzania. Im niższa liczba, tym wcześniej sprawdzany jest stream. Ruch trafia do pierwszego pasującego.",
  "When several streams share a type — the split of traffic between them. E.g. 70 and 30 = 70% and 30%.": "Gdy kilka streamów ma ten sam typ — podział ruchu między nimi (split). Np. 70 i 30 = 70% i 30%.",
  "Max clicks for this stream. Once reached, the stream stops taking traffic. Empty = no limit.": "Maksymalna liczba kliknięć dla tego streamu. Po jej osiągnięciu stream przestaje przyjmować ruch. Puste = bez limitu.",
  "Redirect — send to the stream's landing/offer; Action — a special response (e.g. 404 / empty response for anti-fraud); Split test — split between variants.": "Redirect — przekierowanie do landinga/oferty streamu; Action — specjalna odpowiedź (np. 404 / pusta odpowiedź dla anti-fraud); Split test — podział między warianty.",
  "Filter by visit uniqueness: unique only / repeat only / do not filter.": "Filtruj według unikalności wizyty: tylko unikalne / tylko powtórne / nie filtruj.",
  "How to handle bots (detected by User-Agent): do not filter / bots only / exclude bots. Handy for an anti-fraud stream.": "Jak traktować boty (wykrywane po User-Agent): nie filtruj / tylko boty / wyklucz boty. Przydatne w streamie anti-fraud.",
  "Proxy/VPN filter (datacenter/Tor): do not filter / proxy only / exclude proxy.": "Filtr proxy/VPN (datacenter/Tor): nie filtruj / tylko proxy / wyklucz proxy.",
  "Allow only IPv4 or only IPv6, or do not filter.": "Zezwól tylko na IPv4 lub tylko na IPv6, albo nie filtruj.",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone.": "Dni tygodnia i godziny, kiedy stream jest aktywny. Czas podany w strefie czasowej właściciela kampanii.",
  "A ready platform preset (Google Ads, Facebook…) — fills in the name, the standard macros/subs and the S2S postback for this source.": "Gotowy preset platformy (Google Ads, Facebook…) — uzupełnia nazwę, standardowe makra/suby oraz postback S2S dla tego źródła.",
  "Search templates…": "Szukaj szablonów…",
  "All categories": "Wszystkie kategorie",
  "Templates in catalog": "Szablony w katalogu",
  "Optional. An outbound postback TO the ad network on conversion — so the platform can optimize campaigns on its side (e.g. legacy Facebook CAPI).": "Opcjonalnie. Wychodzący postback DO sieci reklamowej przy konwersji — żeby platforma mogła optymalizować kampanie po swojej stronie (np. stary Facebook CAPI).",
  "Parameters the platform passes into the click (sub1…subN, gclid, tm, etc.). They become macros, appear in reports and are added to the tracking link.": "Parametry, które platforma przekazuje w kliknięciu (sub1…subN, gclid, tm itd.). Stają się makrami, pojawiają się w raportach i są dodawane do linku trackingowego.",
  "TrackBox / Tigloo — a typed adapter for their API. Custom API — for any other CRM: you configure the request yourself (URL, headers, body, where to read the redirect).": "TrackBox / Tigloo — dedykowany adapter do ich API. Custom API — dla dowolnego innego CRM: sam konfigurujesz zapytanie (URL, nagłówki, body, skąd odczytać redirect).",
  "The partner's secret Push/Registration key. Get it in the partner dashboard (API / API Testing section) or from your affiliate manager.": "Tajny klucz Push/Registration partnera. Znajdziesz go w panelu partnera (sekcja API / API Testing) albo poproś affiliate managera.",
  "Your Affiliate ID at the partner. Provided by the partner.": "Twój Affiliate ID u partnera. Podaje go partner.",
  "Campaign ID at the partner. Usually 1 unless told otherwise.": "Campaign ID u partnera. Zwykle 1, chyba że wskazano inaczej.",
  "Raw network statuses to treat as a LEAD (registration). Comma-separated. E.g. new, reg, registration.": "Surowe statusy sieci traktowane jako LEAD (rejestracja). Oddziel przecinkami. Np. new, reg, registration.",
  "Raw statuses to treat as a SALE/deposit. E.g. ftd, deposit, approved.": "Surowe statusy traktowane jako SALE/depozyt. Np. ftd, deposit, approved.",
  "Rejection/bad statuses. E.g. bl, fake, rejected.": "Statusy odrzucenia/złej jakości. Np. bl, fake, rejected.",
  "These statuses are silently dropped — not recorded as conversions. E.g. spam, junk, test.": "Te statusy są po cichu odrzucane — nie są zapisywane jako konwersje. Np. spam, junk, test.",
  "Dashboard": "Panel",
  "Campaigns": "Kampanie",
  "Landing pages": "Landing page'e",
  "Offers": "Oferty",
  "Sources": "Źródła",
  "Report": "Raport",
  "Group clicks and conversions by any dimension with full metrics.": "Grupuj kliknięcia i konwersje według dowolnego wymiaru z pełnymi metrykami.",
  "Grouped by": "Grupowanie wg",
  "No data for this period.": "Brak danych dla tego okresu.",
  "Empty ref.": "Pusty ref.",
  "Group": "Grupa",
  "— no level —": "— brak poziomu —",
  "Click a row to drill in": "Kliknij wiersz, aby zobaczyć szczegóły",
  "Expand": "Rozwiń",
  "Collapse": "Zwiń",
  "Open in clicks log": "Otwórz w logu kliknięć",
  "Failed to load": "Nie udało się załadować",
  "Card view": "Widok kart",
  "Table view": "Widok tabeli",
  "Save view": "Zapisz widok",
  "Save current view": "Zapisz bieżący widok",
  "Saved views": "Zapisane widoki",
  "Delete view": "Usuń widok",
  "View saved": "Widok zapisany",
  "View name": "Nazwa widoku",
  "Remember the current filters, sort and layout under a name for one-click recall.": "Zapamiętaj bieżące filtry, sortowanie i układ pod nazwą, by przywołać je jednym kliknięciem.",
  "e.g. Tier-1 by revenue": "np. Tier-1 wg przychodu",
  "Upload pre-landing (ZIP)": "Prześlij prelander (ZIP)",
  "Upload a ZIP with your warm-up page. index.html is auto-detected.": "Prześlij ZIP ze swoim prelanderem. index.html jest wykrywany automatycznie.",
  "ZIP file": "Plik ZIP",
  "Pre-landing uploaded": "Prelander przesłany",
  "Upload failed": "Błąd przesyłania",
  "Choose a ZIP file": "Wybierz plik ZIP",
  "Uploaded": "Przesłano",
  "Uploading…": "Przesyłanie…",
  "Columns": "Kolumny",
  "Receiving conversions (incoming postback)": "Odbieranie konwersji (postback przychodzący)",
  "Paste these URLs into your affiliate network (e.g. TrackBox) so it notifies this campaign on conversions. Pass your click_id in the network parameter and it comes back here.": "Wklej te adresy URL w swojej sieci afiliacyjnej (np. TrackBox), aby powiadamiała tę kampanię o konwersjach. Przekaż swój click_id w parametrze sieci, a wróci on tutaj.",
  "Map the network raw statuses to ours (comma-separated). Works for any network and applies to every inbound postback of this campaign. Inline URL params take priority.": "Zmapuj surowe statusy sieci na nasze (oddzielone przecinkami). Działa dla każdej sieci i dotyczy każdego postbacku przychodzącego tej kampanii. Parametry inline w URL mają priorytet.",
  "Forwarding — S2S postbacks": "Przekazywanie — postbacki S2S",
  "Landing click": "Kliknięcie na landing",
  "Time on landing": "Czas na landingu",
  "sec": "sek",
  "OS": "System",
  "ISP / provider": "ISP / dostawca",
  "Proxy": "Proxy",
  "Empty referrer": "Pusty referrer",
  "Bots": "Boty",
  "Only bots": "Tylko boty",
  "Exclude bots": "Wyklucz boty",
  "Proxy / VPN": "Proxy / VPN",
  "Only proxy": "Tylko proxy",
  "Exclude proxy": "Wyklucz proxy",
  "IP version": "Wersja IP",
  "Show 404": "Pokaż 404",
  "Do nothing": "Nic nie rób",
  "Schedule": "Harmonogram",
  "Add interval": "Dodaj przedział",
  "Every day, all day": "Codziennie, cały dzień",
  "Every day": "Codziennie",
  "Error loading affiliate networks": "Błąd wczytywania sieci afiliacyjnych",
  "Quick start from preset": "Szybki start z presetu",
  "Affiliate network name": "Nazwa sieci afiliacyjnej",
  "Vertical": "Vertical",
  "Postback URL template": "Szablon URL postbacku",
  "Outbound postback the tracker calls to notify this network.": "Postback wychodzący, który tracker wywołuje, by powiadomić tę sieć.",
  "Offer parameters": "Parametry oferty",
  "Key": "Klucz",
  "Notes": "Notatki",
  "Internal notes": "Notatki wewnętrzne",
  "Affiliate networks": "Sieci afiliacyjne",
  "Reusable partner networks: postback template, offer params and inbound URL.": "Wielokrotnego użytku sieci partnerskie: szablon postbacku, parametry oferty i URL przychodzący.",
  "Create network": "Utwórz sieć",
  "Create affiliate network": "Utwórz sieć afiliacyjną",
  "Pick a preset or configure a partner network from scratch.": "Wybierz preset lub skonfiguruj sieć partnerską od zera.",
  "Search networks": "Szukaj sieci",
  "No affiliate networks yet": "Nie masz jeszcze żadnych sieci afiliacyjnych",
  "Create one from a preset like TrackBox or Adcombo.": "Utwórz jedną z presetu, np. TrackBox lub Adcombo.",
  "Postback copied": "Postback skopiowany",
  "Inbound postback URL (paste in the network)": "URL postbacku przychodzącego (wklej w sieci)",
  "Inbound URL copied": "URL przychodzący skopiowany",
  "conv.": "konw.",
  "offer parameter(s)": "parametr(y) oferty",
  "Edit affiliate network": "Edytuj sieć afiliacyjną",
  "Update partner network settings": "Aktualizuj ustawienia sieci partnerskiej",
  "Delete affiliate network": "Usuń sieć afiliacyjną",
  "This permanently deletes the network. Offers linked to it keep their other settings.": "To trwale usunie sieć. Oferty z nią powiązane zachowają pozostałe ustawienia.",
  "Affiliate network created": "Sieć afiliacyjna utworzona",
  "Error creating affiliate network": "Błąd podczas tworzenia sieci afiliacyjnej",
  "Affiliate network updated": "Sieć afiliacyjna zaktualizowana",
  "Error updating affiliate network": "Błąd podczas aktualizacji sieci afiliacyjnej",
  "Affiliate network deleted": "Sieć afiliacyjna usunięta",
  "Cannot delete: network is linked to offers": "Nie można usunąć: sieć jest powiązana z ofertami",
  "Error deleting affiliate network": "Błąd podczas usuwania sieci afiliacyjnej",
  "Copy failed": "Nie udało się skopiować",
  "Network (text label)": "Sieć (etykieta tekstowa)",
  "Traffic": "Ruch",
  "A/B Tests": "Testy A/B",
  "Anti-fraud": "Anty-fraud",
  "Analytics": "Analityka",
  "Automation": "Automatyzacja",
  "Integrations": "Integracje",
  "Settings": "Ustawienia",
  "Account": "Konto",
  "My account": "Moje konto",
  "Profile": "Profil",
  "Sign out": "Wyloguj się",
  "User": "Użytkownik",
  "Welcome, {name}.": "Witaj, {name}.",
  "Welcome,": "Witaj,",
  "Real-time overview of your campaigns and stats": "Podgląd kampanii i statystyk w czasie rzeczywistym",
  "Create campaign": "Utwórz kampanię",
  "Clicks": "Kliknięcia",
  "Unique visitors": "Unikalni odwiedzający",
  "Conversions": "Konwersje",
  "Total active campaigns": "Aktywne kampanie łącznie",
  "Total clicks": "Kliknięcia łącznie",
  "Unique clicks": "Unikalne kliknięcia",
  "{rate}% conversion": "{rate}% konwersji",
  "Recent campaigns": "Ostatnie kampanie",
  "Your latest campaigns": "Twoje najnowsze kampanie",
  "You have no campaigns yet": "Nie masz jeszcze żadnych kampanii",
  "Create your first campaign": "Utwórz swoją pierwszą kampanię",
  "Quick actions": "Szybkie akcje",
  "Commonly used features": "Najczęściej używane funkcje",
  "Add a new ad campaign": "Dodaj nową kampanię",
  "View detailed statistics": "Zobacz szczegółowe statystyki",
  "Manage campaigns": "Zarządzaj kampaniami",
  "Edit existing campaigns": "Edytuj istniejące kampanie",
  "Show all campaigns": "Pokaż wszystkie kampanie",
  "More details": "Więcej szczegółów",
  "Active": "Aktywna",
  "Paused": "Wstrzymana",
  "No description": "Brak opisu",
  "{n} clicks": "{n} kliknięć",
  "{n} unique": "{n} unikalnych",
  "{n} conversions": "{n} konwersji",
  "Loading workspace": "Ładowanie przestrzeni roboczej",
  "Loading your data…": "Ładowanie twoich danych…",
  "Sign in": "Zaloguj się",
  "Sign up": "Zarejestruj się",
  "Email": "E-mail",
  "Work email": "Służbowy e-mail",
  "Password": "Hasło",
  "Full name": "Imię i nazwisko",
  "Jane Doe": "Jan Kowalski",
  "Create account": "Utwórz konto",
  "Create new account": "Utwórz nowe konto",
  "Already have an account?": "Masz już konto?",
  "Don't have an account?": "Nie masz konta?",
  "Welcome back": "Witaj ponownie",
  "Sign in to your xpnsr account": "Zaloguj się do swojego konta xpnsr",
  "Attribution,": "Atrybucja,",
  "honest": "uczciwa",
  "Create": "Utwórz",
  "account": "konto",
  "S2S postback · bot shield": "Postback S2S · ochrona przed botami",
  "Remember this device": "Zapamiętaj to urządzenie",
  "Reset": "Resetuj",
  "Access tracker": "Wejdź do trackera",
  "Hide password": "Ukryj hasło",
  "Show password": "Pokaż hasło",
  "At least 6 characters": "Minimum 6 znaków",
  "Signing in…": "Logowanie…",
  "Creating account…": "Tworzenie konta…",
  "Invalid email or password": "Nieprawidłowy e-mail lub hasło",
  "Registration failed. Please try again.": "Rejestracja nie powiodła się. Spróbuj ponownie.",
  "New registrations are disabled. Contact your workspace admin for an invitation.": "Nowe rejestracje są wyłączone. Skontaktuj się z adminem swojego workspace, aby otrzymać zaproszenie.",
  "Home": "Strona główna",
  "Auth": "Autoryzacja",
  "Book Demo": "Umów demo",
  "Search campaigns, streams…": "Szukaj kampanii, streamów…",
  "One visual language for the xpnsr.tech family.": "Jeden wizualny język dla rodziny xpnsr.tech.",
  "Control": "Kontrola",
  "Operations": "Operacje",
  "Precise tracking": "Precyzyjny tracking",
  "KPIs, sources and leads in one panel.": "KPI, źródła ruchu i leady w jednym panelu.",
  "Readable reports": "Czytelne raporty",
  "Data visualization for fast decisions.": "Wizualizacja danych dla szybkich decyzji.",
  "Scale your team": "Skaluj swój zespół",
  "Organize teams, campaigns and sources without friction.": "Organizuj zespoły, kampanie i źródła bez zbędnych przeszkód.",
  "Enter your credentials to continue.": "Podaj dane logowania, aby kontynuować.",
  "Create a new xpnsr.tech account.": "Załóż nowe konto xpnsr.tech.",
  "Campaign management": "Zarządzanie kampaniami",
  "Create, edit and track your ad campaigns in real time": "Twórz, edytuj i śledź swoje kampanie reklamowe w czasie rzeczywistym",
  "Search campaigns…": "Szukaj kampanii…",
  "Create new campaign": "Utwórz nową kampanię",
  "Edit campaign": "Edytuj kampanię",
  "Fill in the details of your new ad campaign": "Uzupełnij szczegóły nowej kampanii reklamowej",
  "Update campaign details": "Zaktualizuj szczegóły kampanii",
  "Campaign name": "Nazwa kampanii",
  "Description (optional)": "Opis (opcjonalnie)",
  "Target URL": "URL docelowy",
  "Traffic source": "Źródło ruchu",
  "Cost model": "Model rozliczeń",
  "Select a traffic source (optional)": "Wybierz źródło ruchu (opcjonalnie)",
  "CPC (per click)": "CPC (za kliknięcie)",
  "CPM (per impression)": "CPM (za wyświetlenie)",
  "CPA (per action)": "CPA (za akcję)",
  "Cancel": "Anuluj",
  "Save changes": "Zapisz zmiany",
  "Edit": "Edytuj",
  "Copy link": "Kopiuj link",
  "Delete": "Usuń",
  "Are you sure you want to delete this campaign?": "Na pewno chcesz usunąć tę kampanię?",
  "Campaign created successfully!": "Kampania utworzona pomyślnie!",
  "Campaign updated successfully!": "Kampania zaktualizowana pomyślnie!",
  "Campaign deleted successfully!": "Kampania usunięta pomyślnie!",
  "No campaigns": "Brak kampanii",
  "Campaigns not found": "Nie znaleziono kampanii",
  "Create your first campaign to start tracking traffic": "Utwórz swoją pierwszą kampanię, aby zacząć śledzić ruch",
  "Try adjusting search criteria": "Spróbuj zmienić kryteria wyszukiwania",
  "Tracking ID": "ID trackingu",
  "Link copied to clipboard!": "Link skopiowany do schowka!",
  "Failed to copy link": "Nie udało się skopiować linku",
  "Error loading campaigns": "Błąd wczytywania kampanii",
  "Error creating campaign": "Błąd tworzenia kampanii",
  "Error updating campaign": "Błąd aktualizacji kampanii",
  "Error deleting campaign": "Błąd usuwania kampanii",
  "For example: Product A ad": "Na przykład: Reklama produktu A",
  "Short campaign description": "Krótki opis kampanii",
  "New landing page": "Nowy landing page",
  "Add landing page": "Dodaj landing page",
  "Add a landing page for use in campaigns and A/B tests": "Dodaj landing page do użycia w kampaniach i testach A/B",
  "Edit landing page": "Edytuj landing page",
  "Edit landing page settings": "Edytuj ustawienia landing page",
  "Search landing pages…": "Szukaj landing page’y…",
  "Create landing pages for use in campaigns": "Twórz landing page’e do użycia w kampaniach",
  "No landing pages": "Brak landing page’y",
  "Nothing found": "Nic nie znaleziono",
  "Landing page created": "Landing page utworzony",
  "Landing page updated": "Landing page zaktualizowany",
  "Landing page deleted": "Landing page usunięty",
  "Delete this landing page?": "Usunąć ten landing page?",
  "Error loading landing pages": "Błąd wczytywania landing page’y",
  "Error creating landing page": "Błąd tworzenia landing page",
  "Error updating landing page": "Błąd aktualizacji landing page",
  "Error deleting landing page": "Błąd usuwania landing page",
  "Please fill in name and URL": "Uzupełnij nazwę i URL",
  "URL copied": "URL skopiowany",
  "My landing": "Mój landing page",
  "Landing page description": "Opis landing page",
  "Lead generation": "Generowanie leadów",
  "Subscription": "Subskrypcja",
  "Download": "Pobieranie",
  "Other": "Inne",
  "Category": "Kategoria",
  "Select category": "Wybierz kategorię",
  "Description": "Opis",
  "Tags": "Tagi",
  "Add tag": "Dodaj tag",
  "Status": "Status",
  "Inactive": "Nieaktywny",
  "Visits": "Wizyty",
  "CR": "CR",
  "Actions": "Akcje",
  "Name": "Nazwa",
  "URL": "URL",
  "Save": "Zapisz",
  "Unique": "Unikalne",
  "Add offer": "Dodaj ofertę",
  "New offer": "Nowa oferta",
  "Edit offer": "Edytuj ofertę",
  "Add an offer to use in campaigns": "Dodaj ofertę do użycia w kampaniach",
  "Change offer parameters": "Zmień parametry oferty",
  "Search offers…": "Szukaj ofert…",
  "No offers": "Brak ofert",
  "Create offers to monetize your traffic": "Twórz oferty, aby zarabiać na swoim ruchu",
  "Offer created": "Oferta utworzona",
  "Offer updated": "Oferta zaktualizowana",
  "Offer deleted": "Oferta usunięta",
  "Delete this offer?": "Usunąć tę ofertę?",
  "Error loading offers": "Błąd wczytywania ofert",
  "Error creating offer": "Błąd tworzenia oferty",
  "Error updating offer": "Błąd aktualizacji oferty",
  "Error deleting offer": "Błąd usuwania oferty",
  "My offer": "Moja oferta",
  "Offer URL": "URL oferty",
  "Offer description": "Opis oferty",
  "Affiliate network": "Sieć afiliacyjna",
  "Network": "Sieć",
  "Payout": "Payout",
  "Currency": "Waluta",
  "Geo": "Geo",
  "Countries (ISO codes, e.g. US, RU)": "Kraje (kody ISO, np. US, RU)",
  "Nutra": "Nutra",
  "Gambling": "Hazard",
  "Dating": "Dating",
  "Finance": "Finanse",
  "Crypto": "Krypto",
  "Sweepstakes": "Sweepstakes",
  "Back": "Wstecz",
  "Streams": "Streamy",
  "Open target URL": "Otwórz docelowy URL",
  "Copy tracking link": "Kopiuj link trackingowy",
  "Tracking link copied!": "Link trackingowy skopiowany!",
  "Campaign not found": "Nie znaleziono kampanii",
  "Successful conversions": "Udane konwersje",
  "Conversion rate": "Współczynnik konwersji",
  "Conversion percentage": "Procent konwersji",
  "Campaign info": "Informacje o kampanii",
  "Tracking link": "Link trackingowy",
  "Created": "Utworzono",
  "Updated": "Zaktualizowano",
  "Recent clicks": "Ostatnie kliknięcia",
  "Recent activity for this campaign": "Ostatnia aktywność tej kampanii",
  "No clicks for this campaign yet": "Brak kliknięć dla tej kampanii",
  "Showing latest 10 clicks": "Pokazuję ostatnie 10 kliknięć",
  "Device breakdown": "Podział wg urządzeń",
  "Browser breakdown": "Podział wg przeglądarek",
  "No data to display": "Brak danych do wyświetlenia",
  "Unknown": "Nieznane",
  "Traffic sources": "Źródła ruchu",
  "Create source": "Utwórz źródło",
  "Create traffic source": "Utwórz źródło ruchu",
  "Edit traffic source": "Edytuj źródło ruchu",
  "Update traffic source settings": "Zaktualizuj ustawienia źródła ruchu",
  "Configure a traffic source for UTM tags and conversion postbacks": "Skonfiguruj źródło ruchu dla tagów UTM i postbacków konwersji",
  "Source template": "Szablon źródła",
  "Pick a template or create your own": "Wybierz szablon lub stwórz własny",
  "Traffic source name": "Nazwa źródła ruchu",
  "Traffic source description": "Opis źródła ruchu",
  "Postback URL": "URL postbacku",
  "Postback URL copied": "URL postbacku skopiowany",
  "UTM parameters": "Parametry UTM",
  "Add parameter": "Dodaj parametr",
  "Enter parameter name:": "Podaj nazwę parametru:",
  "Parameter": "Parametr",
  "Alias": "Alias",
  "Placeholder": "Placeholder",
  "Action": "Akcja",
  "Source macro": "Makro źródła",
  "No parameters added": "Nie dodano żadnych parametrów",
  "Search traffic sources…": "Szukaj źródeł ruchu…",
  "Sources not found": "Nie znaleziono źródeł",
  "No traffic sources": "Brak źródeł ruchu",
  "Create sources to integrate with ad networks": "Twórz źródła, by zintegrować się z sieciami reklamowymi",
  "Spend": "Wydatki",
  "Parameters configured:": "Skonfigurowane parametry:",
  "Traffic source created": "Źródło ruchu utworzone",
  "Traffic source updated": "Źródło ruchu zaktualizowane",
  "Traffic source deleted": "Źródło ruchu usunięte",
  "Are you sure you want to delete this traffic source?": "Na pewno chcesz usunąć to źródło ruchu?",
  "Cannot delete: source is in use by campaigns": "Nie można usunąć: źródło jest używane przez kampanie",
  "Error loading traffic sources": "Błąd podczas wczytywania źródeł ruchu",
  "Error creating traffic source": "Błąd podczas tworzenia źródła ruchu",
  "Error updating traffic source": "Błąd podczas aktualizacji źródła ruchu",
  "Error deleting traffic source": "Błąd podczas usuwania źródła ruchu",
  "Preferences": "Preferencje",
  "Notifications": "Powiadomienia",
  "System": "System",
  "Profile information": "Informacje o profilu",
  "Manage your basic account information": "Zarządzaj podstawowymi informacjami o koncie",
  "Enter your full name": "Podaj swoje imię i nazwisko",
  "Enter your email": "Podaj swój email",
  "Save profile": "Zapisz profil",
  "Change password": "Zmień hasło",
  "Update your password to keep your account secure": "Zaktualizuj hasło, by chronić swoje konto",
  "Current password": "Obecne hasło",
  "New password": "Nowe hasło",
  "Confirm new password": "Potwierdź nowe hasło",
  "Enter current password": "Podaj obecne hasło",
  "Enter new password": "Podaj nowe hasło",
  "New passwords do not match": "Nowe hasła nie są takie same",
  "New password must be at least 6 characters": "Nowe hasło musi mieć co najmniej 6 znaków",
  "Password changed successfully": "Hasło zmienione pomyślnie",
  "Profile updated successfully": "Profil zaktualizowany pomyślnie",
  "Error updating profile": "Błąd podczas aktualizacji profilu",
  "Error changing password": "Błąd podczas zmiany hasła",
  "Error loading settings": "Błąd podczas wczytywania ustawień",
  "Error saving settings": "Błąd podczas zapisywania ustawień",
  "Error saving system settings": "Błąd zapisu ustawień systemu",
  "User settings saved": "Ustawienia użytkownika zapisane",
  "System settings saved": "Ustawienia systemu zapisane",
  "Interface preferences": "Preferencje interfejsu",
  "Customize the look and behavior of the app": "Dostosuj wygląd i działanie aplikacji",
  "Timezone": "Strefa czasowa",
  "Moscow (UTC+3)": "Moskwa (UTC+3)",
  "Kyiv (UTC+2)": "Kijów (UTC+2)",
  "New York (UTC-5)": "Nowy Jork (UTC-5)",
  "Language": "Język",
  "Date format": "Format daty",
  "Dashboard refresh rate (sec)": "Częstotliwość odświeżania dashboardu (sek)",
  "Save settings": "Zapisz ustawienia",
  "Configure how you receive notifications": "Skonfiguruj, jak otrzymujesz powiadomienia",
  "Email notifications": "Powiadomienia email",
  "SMS notifications": "Powiadomienia SMS",
  "Get email notifications about important events": "Otrzymuj powiadomienia email o ważnych zdarzeniach",
  "Get SMS for critical events": "Otrzymuj SMS przy krytycznych zdarzeniach",
  "Save notification settings": "Zapisz ustawienia powiadomień",
  "Tracking domains": "Domeny trackingowe",
  "Configure domains for campaign tracking": "Skonfiguruj domeny do trackingu kampanii",
  "Primary tracking domain": "Główna domena trackingowa",
  "Additional domains": "Dodatkowe domeny",
  "Add domain": "Dodaj domenę",
  "Add": "Dodaj",
  "Save domain settings": "Zapisz ustawienia domeny",
  "Security": "Bezpieczeństwo",
  "Security and access settings": "Ustawienia bezpieczeństwa i dostępu",
  "Security settings": "Ustawienia bezpieczeństwa",
  "Coming in upcoming releases": "Pojawi się w kolejnych wersjach",
  "Active campaigns": "Aktywne kampanie",
  "Clicks today": "Kliknięcia dziś",
  "For the current day": "Za bieżący dzień",
  "Confirmed": "Potwierdzone",
  "Refresh": "Odśwież",
  "Export": "Eksportuj",
  "Report exported": "Raport wyeksportowany",
  "Period:": "Okres:",
  "Today": "Dziś",
  "7 days": "7 dni",
  "14 days": "14 dni",
  "30 days": "30 dni",
  "90 days": "90 dni",
  "Campaign:": "Kampania:",
  "All campaigns": "Wszystkie kampanie",
  "Overview": "Przegląd",
  "Devices": "Urządzenia",
  "Clicks and conversions": "Kliknięcia i konwersje",
  "No data for the selected period": "Brak danych dla wybranego okresu",
  "No data": "Brak danych",
  "Hourly activity": "Aktywność godzinowa",
  "CR% by day": "CR% dziennie",
  "Campaign stats": "Statystyki kampanii",
  "Revenue": "Przychód",
  "No campaign data": "Brak danych kampanii",
  "Total revenue": "Łączny przychód",
  "Total spend": "Łączne wydatki",
  "Profit": "Zysk",
  "Net positive": "Zysk netto",
  "Net loss": "Strata netto",
  "Advanced notification preferences": "Zaawansowane preferencje powiadomień",
  "Push notifications, webhook URL, alert categories": "Powiadomienia push, URL webhooka, kategorie alertów",
  "Configure": "Skonfiguruj",
  "All values shown in": "Wszystkie wartości pokazane w",
  "FX rates unavailable — non-USD revenue is excluded from the totals.": "Kursy walut niedostępne — przychód spoza USD jest wykluczony z sum.",
  "ROI by campaigns": "ROI wg kampanii",
  "No ROI data": "Brak danych ROI",
  "Clicks by country": "Kliknięcia wg kraju",
  "Geo table": "Tabela GEO",
  "No geo data": "Brak danych GEO",
  "Country": "Kraj",
  "Devices table": "Tabela urządzeń",
  "Device type": "Typ urządzenia",
  "Share": "Udział",
  "No device data": "Brak danych o urządzeniach",
  "Failed to load campaign": "Błąd ładowania kampanii",
  "Failed to load streams": "Błąd ładowania streamów",
  "Stream created": "Stream utworzony",
  "Failed to create stream": "Błąd tworzenia streamu",
  "Stream updated": "Stream zaktualizowany",
  "Failed to update stream": "Błąd aktualizacji streamu",
  "Delete this stream?": "Usunąć ten stream?",
  "Stream deleted": "Stream usunięty",
  "Failed to delete stream": "Błąd usuwania streamu",
  "Catch": "Catch",
  "Fallback": "Fallback",
  "Normal": "Normalny",
  "Stream name": "Nazwa streamu",
  "Stream type": "Typ streamu",
  "Position": "Pozycja",
  "Weight (%)": "Waga (%)",
  "Click limit": "Limit kliknięć",
  "No limit": "Bez limitu",
  "Stream action": "Akcja streamu",
  "Action type": "Typ akcji",
  "Redirect": "Przekierowanie",
  "Split test": "Split test",
  "Redirect URL": "URL przekierowania",
  "Landings and offers": "Landing page'e i oferty",
  "Landings": "Landing page'e",
  "No landings available": "Brak dostępnych landing page'y",
  "No offers available": "Brak dostępnych ofert",
  "Traffic filters": "Filtry ruchu",
  "Countries (ISO codes)": "Kraje (kody ISO)",
  "Cities": "Miasta",
  "Browsers": "Przeglądarki",
  "Operating systems": "Systemy operacyjne",
  "Languages": "Języki",
  "Don't filter": "Nie filtruj",
  "Accept only unique": "Akceptuj tylko unikalne",
  "Filter unique": "Filtruj unikalne",
  "Campaign streams": "Streamy kampanii",
  "Create stream": "Utwórz stream",
  "Configure stream for traffic distribution by conditions": "Skonfiguruj stream do dystrybucji ruchu według warunków",
  "No streams": "Brak streamów",
  "Create streams to distribute traffic by conditions": "Utwórz streamy, aby dystrybuować ruch według warunków",
  "Weight": "Waga",
  "Bots filtered": "Boty odfiltrowane",
  "Countries": "Kraje",
  "Limit": "Limit",
  "Edit stream": "Edytuj stream",
  "Modify stream settings": "Zmień ustawienia streamu",
  "Failed to load data": "Nie udało się załadować danych",
  "Failed to load traffic rules": "Nie udało się załadować reguł ruchu",
  "Select a campaign": "Wybierz kampanię",
  "Traffic rule created": "Reguła ruchu utworzona",
  "Failed to create rule": "Nie udało się utworzyć reguły",
  "Rule updated": "Reguła zaktualizowana",
  "Failed to update rule": "Nie udało się zaktualizować reguły",
  "Rule deleted": "Reguła usunięta",
  "Failed to delete rule": "Nie udało się usunąć reguły",
  "Landing created": "Landing utworzony",
  "Failed to create landing": "Nie udało się utworzyć landingu",
  "Failed to create offer": "Nie udało się utworzyć oferty",
  "Traffic management": "Zarządzanie ruchem",
  "Select campaign": "Wybierz kampanię",
  "Traffic rules": "Reguły ruchu",
  "Traffic distribution rules": "Reguły dystrybucji ruchu",
  "Create rule": "Utwórz regułę",
  "Create traffic rule": "Utwórz regułę ruchu",
  "Edit rule": "Edytuj regułę",
  "Configure conditions and actions for traffic distribution": "Skonfiguruj warunki i akcje dla dystrybucji ruchu",
  "Rule name": "Nazwa reguły",
  "Priority": "Priorytet",
  "Rule description": "Opis reguły",
  "Conditions (leave empty for any value)": "Warunki (zostaw puste dla dowolnej wartości)",
  "Update": "Aktualizuj",
  "No traffic rules": "Brak reguł ruchu",
  "Create rules to distribute traffic by conditions": "Utwórz reguły, aby dystrybuować ruch według warunków",
  "Stopped": "Zatrzymany",
  "Any": "Dowolny",
  "Redirects": "Przekierowania",
  "Select a campaign to manage traffic rules": "Wybierz kampanię, aby zarządzać regułami ruchu",
  "Add landing": "Dodaj landing",
  "Add a new landing to the library": "Dodaj nowy landing do biblioteki",
  "Landing name": "Nazwa landingu",
  "Landing description": "Opis landingu",
  "No landings": "Brak landingów",
  "Add landings to use in traffic rules": "Dodaj landingi, aby używać ich w regułach ruchu",
  "Add a new offer to monetize traffic": "Dodaj nową ofertę, aby zmonetyzować ruch",
  "Offer name": "Nazwa oferty",
  "Add offers to monetize traffic": "Dodaj oferty, aby zmonetyzować ruch",
  "A/B Testing": "Testy A/B",
  "Create A/B test": "Utwórz test A/B",
  "Set up split testing to optimize conversions": "Skonfiguruj split testing, aby zoptymalizować konwersje",
  "Test name": "Nazwa testu",
  "Landing page test": "Test landing page",
  "Test description": "Opis testu",
  "Test type": "Typ testu",
  "Traffic paths": "Ścieżki ruchu",
  "Confidence level (%)": "Poziom ufności (%)",
  "Minimum sample size": "Minimalna wielkość próby",
  "Test variants": "Warianty testu",
  "Add variant": "Dodaj wariant",
  "Variant {n}": "Wariant {n}",
  "Variant name": "Nazwa wariantu",
  "URL (or pick below)": "URL (lub wybierz poniżej)",
  "Pick landing page": "Wybierz landing page",
  "Pick offer": "Wybierz ofertę",
  "Traffic weight (%)": "Waga ruchu (%)",
  "Total weight": "Łączna waga",
  "Create test": "Utwórz test",
  "No A/B tests": "Brak testów A/B",
  "Create split tests to optimize conversions": "Utwórz split testy, aby zoptymalizować konwersje",
  "Visitors": "Odwiedzający",
  "Significance": "Istotność",
  "Variants": "Warianty",
  "Progress to minimum sample": "Postęp do minimalnej próby",
  "A/B test results": "Wyniki testu A/B",
  "Variant performance analysis": "Analiza wyników wariantów",
  "Conversion": "Konwersja",
  "Confidence interval": "Przedział ufności",
  "Not enough data for analysis": "Za mało danych do analizy",
  "Close": "Zamknij",
  "Running": "Uruchomiony",
  "Completed": "Zakończony",
  "Draft": "Szkic",
  "Delete this A/B test?": "Usunąć ten test A/B?",
  "A/B test deleted": "Test A/B usunięty",
  "Failed to delete test": "Nie udało się usunąć testu",
  "A/B test created": "Test A/B utworzony",
  "Failed to create A/B test": "Nie udało się utworzyć testu A/B",
  "A/B test started": "Test A/B uruchomiony",
  "Failed to start test": "Nie udało się uruchomić testu",
  "A/B test paused": "Test A/B wstrzymany",
  "Failed to pause test": "Nie udało się wstrzymać testu",
  "Failed to load results": "Nie udało się załadować wyników",
  "Failed to load A/B tests": "Nie udało się załadować testów A/B",
  "At least 2 variants required": "Wymagane są co najmniej 2 warianty",
  "Webhooks": "Webhooki",
  "Import costs and conversions": "Importuj koszty i konwersje",
  "Sync campaigns and conversions": "Synchronizuj kampanie i konwersje",
  "Import ad statistics": "Importuj statystyki reklamowe",
  "VKontakte integration": "Integracja z VKontakte",
  "Automatic traffic import": "Automatyczny import ruchu",
  "Server-to-server postbacks": "Postbacki serwer-serwer",
  "Custom API integration": "Niestandardowa integracja API",
  "Telegram notifications": "Powiadomienia Telegram",
  "Click": "Kliknięcie",
  "Campaign paused": "Kampania wstrzymana",
  "Campaign started": "Kampania uruchomiona",
  "Fraud detected": "Wykryto fraud",
  "Threshold reached": "Osiągnięto próg",
  "Fill in type and name": "Uzupełnij typ i nazwę",
  "Integration created": "Integracja utworzona",
  "Error creating": "Błąd tworzenia",
  "Integration updated": "Integracja zaktualizowana",
  "Error updating": "Błąd aktualizacji",
  "Delete integration?": "Usunąć integrację?",
  "Integration deleted": "Integracja usunięta",
  "Error deleting": "Błąd usuwania",
  "Fill in name and URL": "Uzupełnij nazwę i URL",
  "Webhook created": "Webhook utworzony",
  "Error creating webhook": "Błąd tworzenia webhooka",
  "Webhook updated": "Webhook zaktualizowany",
  "Delete webhook?": "Usunąć webhook?",
  "Webhook deleted": "Webhook usunięty",
  "Test succeeded (HTTP {code})": "Test zakończony sukcesem (HTTP {code})",
  "Test error: {detail}": "Błąd testu: {detail}",
  "Error testing webhook": "Błąd testowania webhooka",
  "Integration type": "Typ integracji",
  "Select type": "Wybierz typ",
  "Configuration (key-value)": "Konfiguracja (klucz-wartość)",
  "Key (e.g. api_key)": "Klucz (np. api_key)",
  "Value": "Wartość",
  "My webhook": "Mój webhook",
  "Secret (optional)": "Sekret (opcjonalnie)",
  "Events": "Zdarzenia",
  "Retry attempts": "Liczba prób ponowienia",
  "Timeout (sec)": "Limit czasu (sek)",
  "Add integration": "Dodaj integrację",
  "New integration": "Nowa integracja",
  "Configure connection to an external service": "Skonfiguruj połączenie z zewnętrznym serwisem",
  "No integrations": "Brak integracji",
  "Connect external services to automate workflows": "Połącz zewnętrzne serwisy, aby zautomatyzować procesy",
  "Connected": "Połączono",
  "Disconnected": "Rozłączono",
  "Last sync": "Ostatnia synchronizacja",
  "Add webhook": "Dodaj webhook",
  "New webhook": "Nowy webhook",
  "Configure a webhook to receive notifications": "Skonfiguruj webhook, aby otrzymywać powiadomienia",
  "No webhooks": "Brak webhooków",
  "Create webhooks to send events to external systems": "Twórz webhooki, aby wysyłać zdarzenia do zewnętrznych systemów",
  "Success": "Sukces",
  "Errors": "Błędy",
  "Test": "Test",
  "Edit integration": "Edytuj integrację",
  "Edit webhook": "Edytuj webhook",
  "Anti-fraud system": "System antyfraudowy",
  "Filter created": "Filtr utworzony",
  "Failed to create filter": "Nie udało się utworzyć filtra",
  "Filter updated": "Filtr zaktualizowany",
  "Failed to update filter": "Nie udało się zaktualizować filtra",
  "Filter deleted": "Filtr usunięty",
  "Failed to delete filter": "Nie udało się usunąć filtra",
  "IP added to blacklist": "IP dodane do czarnej listy",
  "IP added to whitelist": "IP dodane do białej listy",
  "Failed to add IP": "Nie udało się dodać IP",
  "IP removed from blacklist": "IP usunięte z czarnej listy",
  "IP removed from whitelist": "IP usunięte z białej listy",
  "Failed to remove IP": "Nie udało się usunąć IP",
  "Activity marked as resolved": "Aktywność oznaczona jako rozwiązana",
  "Failed to update activity": "Nie udało się zaktualizować aktywności",
  "Filters": "Filtry",
  "IP lists": "Listy IP",
  "Suspicious activity": "Podejrzana aktywność",
  "Statistics": "Statystyki",
  "Fraud filters": "Filtry antyfraudowe",
  "Create filter": "Utwórz filtr",
  "Edit filter": "Edytuj filtr",
  "Create fraud filter": "Utwórz filtr antyfraudowy",
  "Configure automatic filters to block suspicious traffic": "Skonfiguruj automatyczne filtry, aby blokować podejrzany ruch",
  "Filter name": "Nazwa filtra",
  "Filter type": "Typ filtra",
  "Bot detection": "Wykrywanie botów",
  "Click frequency": "Częstotliwość kliknięć",
  "Country block": "Blokada po kraju",
  "ASN block": "Blokada po ASN",
  "Datacenter / hosting block": "Blokada datacenter / hostingu",
  "Proxy / VPN / Tor block": "Blokada proxy / VPN / Tor",
  "External risk score": "Zewnętrzny wskaźnik ryzyka",
  "Filter description": "Opis filtra",
  "Max clicks per minute": "Maks. kliknięć na minutę",
  "Blocked countries (ISO codes)": "Zablokowane kraje (kody ISO)",
  "ASN numbers": "Numery ASN",
  "ASN name substrings": "Fragmenty nazwy ASN",
  "Comma-separated AS numbers (e.g. 16509 = AWS, 24940 = Hetzner).": "Numery AS oddzielone przecinkami (np. 16509 = AWS, 24940 = Hetzner).",
  "Case-insensitive substring match against the ASN label.": "Dopasowanie podciągu do etykiety ASN, bez rozróżniania wielkości liter.",
  "Allowed ASNs (whitelist)": "Dozwolone ASN (biała lista)",
  "Optional. Datacenter IPs that match these ASNs / labels are not blocked.": "Opcjonalnie. IP datacenter pasujące do tych ASN / etykiet nie są blokowane.",
  "Block Tor exit nodes": "Blokuj węzły wyjściowe Tor",
  "Block proxies (requires API key)": "Blokuj proxy (wymaga klucza API)",
  "Block VPNs (requires API key)": "Blokuj VPN (wymaga klucza API)",
  "External provider": "Zewnętrzny dostawca",
  "Set IPQS_API_KEY or FRAUDSCORE_API_KEY in the backend environment.": "Ustaw IPQS_API_KEY lub FRAUDSCORE_API_KEY w środowisku backendu.",
  "Risk score threshold (0-100)": "Próg wskaźnika ryzyka (0-100)",
  "Block when the provider returns a score >= this threshold (default 85).": "Blokuj, gdy dostawca zwróci wynik >= ten próg (domyślnie 85).",
  "Block": "Blokuj",
  "Log only": "Tylko loguj",
  "No active filters": "Brak aktywnych filtrów",
  "Create filters for automatic fraud protection": "Utwórz filtry dla automatycznej ochrony przed fraudem",
  "Blocked": "Zablokowane",
  "False positives": "Fałszywe trafienia",
  "IP blacklist": "Czarna lista IP",
  "IP whitelist": "Biała lista IP",
  "Blacklist is empty": "Czarna lista jest pusta",
  "Whitelist is empty": "Biała lista jest pusta",
  "Blocked: {n} times": "Zablokowano: {n} razy",
  "View blocked samples": "Zobacz zablokowane próbki",
  "Blocked samples": "Zablokowane próbki",
  "Blocked samples: {name}": "Zablokowane próbki: {name}",
  "Most recent traffic caught by this filter. Use it to spot false positives.": "Najnowszy ruch złapany przez ten filtr. Użyj go, żeby znaleźć fałszywe trafienia.",
  "No blocked samples yet": "Brak zablokowanych próbek",
  "Failed to load blocked samples": "Nie udało się wczytać zablokowanych próbek",
  "(empty UA)": "(pusty UA)",
  "Add IP to blacklist": "Dodaj IP do czarnej listy",
  "Add IP to whitelist": "Dodaj IP do białej listy",
  "IP address": "Adres IP",
  "Reason": "Powód",
  "Reason for adding": "Powód dodania",
  "Notes (optional)": "Notatki (opcjonalnie)",
  "Additional information": "Dodatkowe informacje",
  "No suspicious activity detected": "Nie wykryto podejrzanej aktywności",
  "The system automatically tracks suspicious actions": "System automatycznie śledzi podejrzane działania",
  "Resolved": "Rozwiązane",
  "Mark as resolved": "Oznacz jako rozwiązane",
  "User Agent": "User Agent",
  "Time": "Czas",
  "Details": "Szczegóły",
  "Active filters": "Aktywne filtry",
  "Blocked IPs": "Zablokowane IP",
  "Failed to load automation rules": "Nie udało się wczytać reguł automatyzacji",
  "Automation rule created": "Utworzono regułę automatyzacji",
  "Failed to create automation rule": "Nie udało się utworzyć reguły automatyzacji",
  "Automation rule updated": "Zaktualizowano regułę automatyzacji",
  "Failed to update automation rule": "Nie udało się zaktualizować reguły automatyzacji",
  "Are you sure you want to delete this rule?": "Na pewno chcesz usunąć tę regułę?",
  "Automation rule deleted": "Usunięto regułę automatyzacji",
  "Failed to delete automation rule": "Nie udało się usunąć reguły automatyzacji",
  "Rule activated": "Reguła aktywowana",
  "Rule deactivated": "Reguła dezaktywowana",
  "Failed to change rule status": "Nie udało się zmienić statusu reguły",
  "Notification settings saved": "Zapisano ustawienia powiadomień",
  "Failed to save notification settings": "Nie udało się zapisać ustawień powiadomień",
  "Pause campaign": "Wstrzymaj kampanię",
  "Budget alert": "Alert budżetowy",
  "Performance alert": "Alert wydajności",
  "Rules": "Reguły",
  "Automation rules": "Reguły automatyzacji",
  "Create automation rule": "Utwórz regułę automatyzacji",
  "Configure automatic actions based on conditions": "Skonfiguruj automatyczne akcje na podstawie warunków",
  "Rule type": "Typ reguły",
  "Trigger conditions": "Warunki wyzwalające",
  "Maximum cost per click": "Maksymalny koszt kliknięcia",
  "Minimum CR (%)": "Minimalny CR (%)",
  "Budget percentage for alert": "Procent budżetu dla alertu",
  "Execution settings": "Ustawienia wykonania",
  "Interval between executions (min)": "Odstęp między wykonaniami (min)",
  "Maximum executions per day": "Maksymalna liczba wykonań dziennie",
  "No automation rules": "Brak reguł automatyzacji",
  "Create rules to automatically manage campaigns": "Utwórz reguły, żeby automatycznie zarządzać kampaniami",
  "Executions": "Wykonania",
  "Interval": "Odstęp",
  "{n} min": "{n} min",
  "Daily limit": "Dzienny limit",
  "Last execution": "Ostatnie wykonanie",
  "Notification channels": "Kanały powiadomień",
  "Receive notifications by email": "Otrzymuj powiadomienia e-mailem",
  "Receive SMS for critical events": "Otrzymuj SMS-y przy krytycznych zdarzeniach",
  "Push notifications": "Powiadomienia push",
  "Browser notifications": "Powiadomienia przeglądarki",
  "Webhook URL": "URL webhooka",
  "Manage how and when you receive alerts": "Zarządzaj tym, jak i kiedy otrzymujesz alerty",
  "Save preferences": "Zapisz preferencje",
  "Saving…": "Zapisywanie…",
  "Delivery channels": "Kanały dostarczania",
  "Choose how to receive notifications": "Wybierz, jak chcesz otrzymywać powiadomienia",
  "Receive alerts via email": "Otrzymuj alerty e-mailem",
  "Critical alerts via SMS": "Krytyczne alerty przez SMS",
  "In-app and browser push": "Push w aplikacji i przeglądarce",
  "POST JSON payloads to your endpoint": "Wysyłaj żądania POST z JSON na swój endpoint",
  "Alert categories": "Kategorie alertów",
  "Choose which types of events trigger notifications": "Wybierz, jakie zdarzenia wywołują powiadomienia",
  "Campaign alerts": "Alerty kampanii",
  "Paused, resumed, daily cap reached": "Wstrzymanie, wznowienie, osiągnięcie dziennego limitu",
  "Performance alerts": "Alerty wydajności",
  "ROI drop, conversion rate change, EPC decline": "Spadek ROI, zmiana CR, spadek EPC",
  "Fraud alerts": "Alerty fraudu",
  "Suspicious clicks, bot traffic, IP blacklist hits": "Podejrzane kliknięcia, ruch botów, trafienia na czarną listę IP",
  "System alerts": "Alerty systemowe",
  "Domain verification, TLS expiry, billing": "Weryfikacja domeny, wygaśnięcie TLS, rozliczenia",
  "Notification preferences saved": "Preferencje powiadomień zapisane",
  "Failed to load notification settings": "Nie udało się wczytać ustawień powiadomień",
  "CSV exported": "CSV wyeksportowany",
  "Export campaigns to CSV": "Eksportuj kampanie do CSV",
  "Export offers to CSV": "Eksportuj oferty do CSV",
  "No domains yet": "Brak domen",
  "Add a custom domain to serve tracking links from your own branded URL.": "Dodaj własną domenę, aby serwować linki trackingowe z własnego brandowanego URL-a.",
  "Create streams to split traffic by geo, device, OS, or custom conditions.": "Twórz streamy, aby dzielić ruch według GEO, urządzenia, systemu lub własnych warunków.",
  "Create rules to automatically pause, resume, or adjust campaigns based on performance thresholds.": "Twórz reguły, które automatycznie wstrzymają, wznowią lub dostosują kampanie na podstawie progów wydajności.",
  "No members yet": "Brak członków",
  "Invite teammates above to collaborate.": "Zaproś członków zespołu powyżej, żeby zacząć współpracę.",
  "URL for receiving notifications in JSON format": "URL do odbierania powiadomień w formacie JSON",
  "Alert types": "Typy alertów",
  "Campaign start, pause, completion": "Start, wstrzymanie i zakończenie kampanii",
  "Changes in CR, ROI, cost": "Zmiany CR, ROI, kosztu",
  "Suspicious traffic detection": "Wykrywanie podejrzanego ruchu",
  "Updates and technical information": "Aktualizacje i informacje techniczne",
  "Execution history": "Historia wykonań",
  "Execution history is empty": "Historia wykonań jest pusta",
  "Records of automatic rule executions will appear here": "Tutaj pojawią się zapisy automatycznych wykonań reguł",
  "Edit automation rule": "Edytuj regułę automatyzacji",
  "Change automation rule settings": "Zmień ustawienia reguły automatyzacji",
  "Geographic statistics": "Statystyki geograficzne",
  "Loading geographic data...": "Wczytywanie danych geograficznych...",
  "By country": "Wg kraju",
  "By city": "Wg miasta",
  "No country data": "Brak danych o krajach",
  "No city data": "Brak danych o miastach",
  "Click map": "Mapa kliknięć",
  "No data to display on map": "Brak danych do wyświetlenia na mapie",
  "Geographic data will appear after the first clicks with resolvable coordinates": "Dane geograficzne pojawią się po pierwszych kliknięciach z rozpoznawalnymi współrzędnymi",
  "Signed in successfully!": "Zalogowano pomyślnie!",
  "Sign in failed": "Logowanie nieudane",
  "Registration successful!": "Rejestracja zakończona sukcesem!",
  "Registration failed": "Rejestracja nieudana",
  "Signed out": "Wylogowano",
  "One moment…": "Chwileczkę…",
  "Documentation": "Dokumentacja",
  "Help": "Pomoc",
  "Step-by-step guide for every feature": "Przewodnik krok po kroku dla każdej funkcji",
  "Search sections...": "Szukaj sekcji...",
  "Loading documentation...": "Ładowanie dokumentacji...",
  "Back to top": "Powrót do góry",
  "Domains": "Domeny",
  "Tracker domains": "Domeny trackera",
  "Custom domains": "Własne domeny",
  "Bind your own domain to mask tracking links. Point a CNAME to our edge and verify ownership via TXT record.": "Podepnij własną domenę, żeby zamaskować linki trackingowe. Wskaż CNAME na nasz edge i potwierdź własność rekordem TXT.",
  "After adding, configure DNS for your domain (TXT record for verification, CNAME or A record to route traffic), then press Verify.": "Po dodaniu skonfiguruj DNS swojej domeny (rekord TXT do weryfikacji, CNAME lub A do routingu ruchu), a potem kliknij Weryfikuj.",
  "Verified": "Zweryfikowano",
  "Failed": "Błąd",
  "Pending": "Oczekuje",
  "Default": "Domyślna",
  "Set default": "Ustaw jako domyślną",
  "Verify": "Weryfikuj",
  "TXT verification record": "Rekord weryfikacyjny TXT",
  "Routing record (CNAME)": "Rekord routingu (CNAME)",
  "Copy value": "Kopiuj wartość",
  "Copied": "Skopiowano",
  "Tracking links will use": "Linki trackingowe będą używać",
  "Domain added": "Domena dodana",
  "Failed to add domain": "Nie udało się dodać domeny",
  "Domain verified": "Domena zweryfikowana",
  "Verification failed": "Weryfikacja nieudana",
  "Default domain updated": "Domyślna domena zaktualizowana",
  "Domain deleted": "Domena usunięta",
  "Delete this domain?": "Usunąć tę domenę?",
  "Enable HTTPS": "Włącz HTTPS",
  "HTTPS active": "HTTPS aktywny",
  "Check TLS": "Sprawdź TLS",
  "TLS validation records": "Rekordy walidacji TLS",
  "TLS provisioning started": "Aprowizacja TLS rozpoczęta",
  "TLS provisioning failed": "Aprowizacja TLS nieudana",
  "Action failed": "Akcja nieudana",
  "Loading…": "Ładowanie…",
  "Conversion API": "API konwersji",
  "Conversion forwarders": "Przekaźniki konwersji",
  "Forward conversions server-to-server to ad networks (FB CAPI, Google Ads, TikTok). Fires automatically on every postback.": "Przekazuj konwersje serwer-serwer do sieci reklamowych (FB CAPI, Google Ads, TikTok). Uruchamia się automatycznie przy każdym postbacku.",
  "New forwarder": "Nowy przekaźnik",
  "Edit forwarder": "Edytuj przekaźnik",
  "No forwarders yet": "Brak przekaźników",
  "Forwarder created": "Przekaźnik utworzony",
  "Forwarder updated": "Przekaźnik zaktualizowany",
  "Forwarder deleted": "Przekaźnik usunięty",
  "Delete forwarder?": "Usunąć przekaźnik?",
  "Send test": "Wyślij test",
  "Test event sent": "Testowe zdarzenie wysłane",
  "Test failed": "Test nieudany",
  "No events yet": "Brak zdarzeń",
  "Provider": "Dostawca",
  "Event name": "Nazwa zdarzenia",
  "Name is required": "Nazwa jest wymagana",
  "Missing fields": "Brakujące pola",
  "Sent": "Wysłano",
  "Event": "Zdarzenie",
  "Last sent": "Ostatnio wysłano",
  "Public API": "Publiczne API",
  "API keys": "Klucze API",
  "New key": "Nowy klucz",
  "New API key": "Nowy klucz API",
  "Use API keys to call the public /v1 REST API. Pass the key as": "Użyj kluczy API, żeby wywoływać publiczne REST API /v1. Przekaż klucz jako",
  "or": "lub",
  "Copy your key now — it will not be shown again": "Skopiuj klucz teraz — nie zostanie pokazany ponownie",
  "Copy": "Kopiuj",
  "Dismiss": "Zamknij",
  "Quick start": "Szybki start",
  "Docs": "Dokumentacja",
  "No API keys yet": "Brak kluczy API",
  "Scopes": "Zakresy",
  "Delete this key?": "Usunąć ten klucz?",
  "Key deleted": "Klucz usunięty",
  "last used": "ostatnio użyty",
  "never used": "nigdy nie użyty",
  "Team": "Zespół",
  "Workspace": "Przestrzeń robocza",
  "Invite teammates with roles. Owner sees everything; manager/admin can edit; viewer is read-only.": "Zapraszaj współpracowników z rolami. Właściciel widzi wszystko; manager/admin może edytować; viewer ma tylko podgląd.",
  "Invite member": "Zaproś członka",
  "Invite": "Zaproś",
  "Invite sent": "Zaproszenie wysłane",
  "Share this link with the invitee:": "Udostępnij ten link zapraszanej osobie:",
  "Role": "Rola",
  "Members": "Członkowie",
  "Revoke access?": "Cofnąć dostęp?",
  "Revoke access": "Cofnij dostęp",
  "Access revoked": "Dostęp cofnięty",
  "Reset 2FA": "Zresetuj 2FA",
  "Reset this member's 2FA?": "Zresetować 2FA tego członka?",
  "2FA reset — member can re-enrol": "2FA zresetowane — członek może zarejestrować się ponownie",
  "Member had no 2FA configured": "Ten członek nie miał skonfigurowanego 2FA",
  "2FA reset failed": "Reset 2FA nieudany",
  "Workspace currency": "Waluta przestrzeni roboczej",
  "Display currency": "Waluta wyświetlania",
  "Reports and dashboards will be normalised to this currency. FX rates are refreshed hourly.": "Raporty i dashboardy będą przeliczane na tę walutę. Kursy walut odświeżają się co godzinę.",
  "Workspace currency saved": "Waluta przestrzeni roboczej zapisana",
  "Could not save currency": "Nie udało się zapisać waluty",
  "Invited": "Zaproszony",
  "Shared with me": "Udostępnione mi",
  "No shared workspaces": "Brak udostępnionych workspace'ów",
  "Audit log": "Log audytu",
  "Workspace-scoped trail of privileged actions. Retained for 90 days.": "Historia uprzywilejowanych działań w obrębie workspace. Przechowywana przez 90 dni.",
  "Target type": "Typ celu",
  "Actor ID": "ID aktora",
  "Since": "Od",
  "Until": "Do",
  "Apply": "Zastosuj",
  "Actor": "Aktor",
  "Target": "Cel",
  "Payload": "Payload",
  "IP": "IP",
  "Load more": "Załaduj więcej",
  "No audit entries match the current filters.": "Żaden wpis audytu nie pasuje do bieżących filtrów.",
  "Failed to load audit log": "Nie udało się załadować logu audytu",
  "CAPI DLQ": "CAPI DLQ",
  "CAPI dead-letter queue": "Kolejka martwych listów CAPI",
  "Conversions that exhausted the retry budget. Replay re-attempts the forwarder; discard drops the entry permanently.": "Konwersje, które wyczerpały limit ponowień. Powtórz ponownie wysyła do forwardera; odrzuć usuwa wpis na stałe.",
  "Forwarder ID": "ID forwardera",
  "Conversion ID": "ID konwersji",
  "Since (ISO)": "Od (ISO)",
  "Until (ISO)": "Do (ISO)",
  "Apply filters": "Zastosuj filtry",
  "No DLQ entries match these filters.": "Żaden wpis DLQ nie pasuje do tych filtrów.",
  "Forwarder": "Forwarder",
  "Attempts": "Próby",
  "Last error": "Ostatni błąd",
  "Replay": "Powtórz",
  "Discard": "Odrzuć",
  "CAPI replay succeeded": "Powtórzenie CAPI zakończone sukcesem",
  "Replay failed:": "Powtórzenie nieudane:",
  "Replay failed": "Powtórzenie nieudane",
  "DLQ entry discarded": "Wpis DLQ odrzucony",
  "Discard failed": "Nie udało się odrzucić",
  "Permanently discard this DLQ entry?": "Trwale odrzucić ten wpis DLQ?",
  "Failed to load CAPI DLQ": "Nie udało się załadować CAPI DLQ",
  "Activated {n}": "Aktywowane: {n}",
  "Paused {n}": "Wstrzymane: {n}",
  "Deleted {n}": "Usunięte: {n}",
  "Skipped {n} (no access or not found)": "Pominięte: {n} (brak dostępu lub nie znaleziono)",
  "Bulk update failed": "Masowa aktualizacja nieudana",
  "Bulk delete failed": "Masowe usuwanie nieudane",
  "System health": "Stan systemu",
  "System status": "Status systemu",
  "S2S log": "Log S2S",
  "TLS fingerprints": "Odciski TLS",
  "Aggregated CAPI / postback / FX / cost-sync state across the workspaces you administer.": "Zbiorczy stan CAPI / postback / FX / synchronizacji kosztów we wszystkich workspace'ach, którymi zarządzasz.",
  "CAPI delivery": "Dostarczanie CAPI",
  "Conversion API dispatches in the last window.": "Wysyłki Conversion API w ostatnim oknie czasowym.",
  "Total": "Łącznie",
  "Success rate": "Wskaźnik sukcesu",
  "No CAPI events in window.": "Brak zdarzeń CAPI w tym oknie czasowym.",
  "Retry queue": "Kolejka ponowień",
  "Pending CAPI re-attempts.": "Oczekujące ponowienia CAPI.",
  "Due now": "Do wykonania teraz",
  "Oldest": "Najstarszy",
  "Dead-letter queue": "Kolejka martwych listów",
  "Conversions that exhausted the retry budget.": "Konwersje, które wyczerpały limit ponowień.",
  "Postback delivery": "Dostarczanie postbacków",
  "S2S postback callouts in the last window.": "Wywołania postback S2S w ostatnim oknie czasowym.",
  "FX cache": "Cache FX",
  "Per-base exchange-rate snapshot freshness.": "Świeżość snapshotów kursów walut dla każdej waluty bazowej.",
  "Base": "Waluta bazowa",
  "Refreshed": "Odświeżono",
  "FX cache is empty.": "Cache FX jest pusty.",
  "stale": "nieaktualny",
  "fresh": "świeży",
  "Ad cost sync": "Synchronizacja kosztów reklam",
  "Active connections, last sync time, and recent errors.": "Aktywne połączenia, czas ostatniej synchronizacji i ostatnie błędy.",
  "No active ad-cost connections.": "Brak aktywnych połączeń kosztów reklam.",
  "error": "błąd",
  "ok": "ok",
  "Generated at": "Wygenerowano o",
  "Window": "Okno czasowe",
  "Failed to load admin health": "Nie udało się załadować stanu admina",
  "Export CSV": "Eksportuj CSV",
  "Audit log exported": "Log audytu wyeksportowany",
  "Audit export failed": "Eksport audytu nieudany",
  "Billing": "Rozliczenia",
  "Plans & usage": "Plany i wykorzystanie",
  "Current plan": "Aktualny plan",
  "Current": "Aktualny",
  "Clicks this month": "Kliknięcia w tym miesiącu",
  "Plans & billing": "Plany i rozliczenia",
  "Five editions: every plan includes the full tracker — pick your team size, domain scale and automation surface. Clicks are never limited.": "Pięć edycji: każdy plan zawiera pełny tracker — wybierz rozmiar zespołu, skalę domen i zakres automatyzacji. Kliknięcia nigdy nie są limitowane.",
  "Billing is not activated on this server yet — all features are open. Plans below show what will apply once payments go live.": "Płatności nie są jeszcze aktywne na tym serwerze — wszystkie funkcje są dostępne. Plany poniżej pokazują, co będzie obowiązywać, gdy płatności zostaną uruchomione.",
  "Trial": "Okres próbny",
  "day(s) left": "dni pozostało",
  "choose a plan to keep your traffic flowing without interruption.": "wybierz plan, żeby twój ruch płynął bez przerw.",
  "Your subscription is inactive: click processing and entity creation are paused. Choose a plan to resume instantly.": "Twoja subskrypcja jest nieaktywna: przetwarzanie kliknięć i tworzenie elementów są wstrzymane. Wybierz plan, żeby wznowić od razu.",
  "Last payment failed — the tracker keeps working while Stripe retries. Update your card in Manage billing.": "Ostatnia płatność nie powiodła się — tracker nadal działa, a Stripe ponawia próbę. Zaktualizuj kartę w sekcji Zarządzaj płatnościami.",
  "cancels at period end": "anulowana na koniec okresu",
  "unlimited": "bez limitu",
  "months": "miesięcy",
  "month": "miesiąc",
  "billed every": "rozliczenie co",
  "user(s)": "użytkownik(ów)",
  "domain(s)": "domen(a)",
  "Choose plan": "Wybierz plan",
  "Full tracker core": "Pełny rdzeń trackera",
  "Unlimited clicks": "Nielimitowane kliknięcia",
  "Landing page editor": "Edytor landing page",
  "Online support": "Wsparcie online",
  "Click API + API keys": "Click API + klucze API",
  "Facebook CAPI": "Facebook CAPI",
  "All 9 CAPI providers": "Wszystkich 9 dostawców CAPI",
  "Report by conversion date": "Raport wg daty konwersji",
  "White label branding": "Branding white label",
  "Personal manager": "Osobisty opiekun",
  "Priority support": "Priorytetowe wsparcie",
  "Onboarding call": "Rozmowa wdrożeniowa",
  "trialing": "okres próbny",
  "active": "aktywna",
  "past_due": "zaległa płatność",
  "expired": "wygasła",
  "canceled": "anulowana",
  "exempt": "zwolniona",
  "Manage billing": "Zarządzaj płatnościami",
  "Manage": "Zarządzaj",
  "Upgrade": "Ulepsz plan",
  "Free forever": "Zawsze za darmo",
  "clicks/mo": "kliknięć/mies.",
  "campaigns": "kampanii",
  "team members": "członków zespołu",
  "Campaign parameters": "Parametry kampanii",
  "Declare the URL parameters you pass through ad networks. Each row becomes a macro like {key} available in postbacks and CAPI payloads.": "Zadeklaruj parametry URL przekazywane przez sieci reklamowe. Każdy wiersz staje się makrem w postaci {key}, dostępnym w postbackach i payloadach CAPI.",
  "URL key": "Klucz URL",
  "Placeholder / default": "Placeholder / wartość domyślna",
  "Google Ads tag": "Tag Google Ads",
  "No parameters yet": "Brak parametrów",
  "Parameters have unsaved changes — clicks keep using the saved set until you save.": "Parametry mają niezapisane zmiany — kliknięcia nadal korzystają z zapisanego zestawu, dopóki nie zapiszesz.",
  "Value written into the tracking link for this key: an ad-network macro such as {campaignid}, or a fixed value such as MCLV. A fixed value is also stored on clicks that arrive without the key; a macro in braces is not. Leave empty for keys the ad sets per account, such as tm and tml.": "Wartość wpisywana w link śledzący dla tego klucza: makro sieci reklamowej, np. {campaignid}, lub stała wartość, np. MCLV. Stała wartość jest też zapisywana przy kliknięciach bez tego klucza; makro w nawiasach klamrowych — nie. Zostaw puste dla kluczy, które reklama ustawia osobno dla konta, np. tm i tml.",
  "Macro: filled by the ad network, not stored on clicks without this key": "Makro: wypełniane przez sieć reklamową, nie zapisywane przy kliknięciach bez tego klucza",
  "Google Ads conversion keys": "Klucze konwersji Google Ads",
  "Break down clicks and conversions by sub1–sub30 or any parameter declared in a campaign": "Rozbij kliknięcia i konwersje wg sub1–sub30 lub dowolnego parametru zadeklarowanego w kampanii",
  "Sub slot": "Slot sub",
  "Optional: the value is also stored as sub1…sub30 or a named field (external_id, creative_id…). Map the same thing to the same slot in every campaign (e.g. team -> sub8) and one report column and the {sub_id_8} macro cover all buyers; external_id feeds {external_id} in the source postback.": "Opcjonalnie: wartość jest też zapisywana jako sub1…sub30 lub pole nazwane (external_id, creative_id…). Przypisuj to samo zawsze do tego samego slotu w każdej kampanii (np. team -> sub8), a jedna kolumna w raporcie i makro {sub_id_8} obejmą wszystkich mediabuyerów; external_id zasila {external_id} w postbacku źródła.",
  "Source postback": "Postback źródła",
  "This source postback is already added": "Ten postback źródła jest już dodany",
  "Source postback added — check its placeholders (REPLACE, XXXX…) and press Save": "Postback źródła dodany — sprawdź jego placeholdery (REPLACE, XXXX…) i kliknij Zapisz",
  "Sale also fires for deposits (ftd, dep, deposit) and Lead also for registrations (reg, signup), whatever the broker calls them.": "Sale uruchamia się też dla depozytów (ftd, dep, deposit), a Lead dla rejestracji (reg, signup), niezależnie jak nazywa je broker.",
  "Keys without a default value (tm, tml, a…) are left out of the link: pass them in the ad, e.g. in the Google Ads Final URL suffix.": "Klucze bez wartości domyślnej (tm, tml, a…) są pomijane w linku: przekaż je w reklamie, np. w sufiksie Final URL w Google Ads.",
  "= Submit Lead Form label — set this conversion as Primary. Fired from the visitor’s browser after a successful lead.": "= etykieta Submit Lead Form — ustaw tę konwersję jako Primary. Uruchamiana z przeglądarki użytkownika po udanym leadzie.",
  "= Purchase / deposit label — set this conversion as Secondary. Sent by the \"Deposit → Purchase\" S2S rule; do not add an S2S rule for lead.": "= etykieta Purchase / deposit — ustaw tę konwersję jako Secondary. Wysyłana przez regułę S2S \"Deposit → Purchase\"; nie dodawaj reguły S2S dla leada.",
  "Put both in the Final URL suffix of each Google Ads account (tml=AW-…/lead-label&tm=AW-…/purchase-label) and leave their default empty here.": "Umieść obie w sufiksie Final URL każdego konta Google Ads (tml=AW-…/lead-label&tm=AW-…/purchase-label), a tutaj zostaw ich wartość domyślną pustą.",
  "Keys are case-sensitive. Any key (a, b, s, c…) is stored on the click, works as a {key} macro and can be picked as a grouping in Reports and Sub-ID reports, next to sub1…sub30. Map it to a sub slot to line it up across campaigns.": "Klucze rozróżniają wielkość liter. Każdy klucz (a, b, s, c…) jest zapisywany przy kliknięciu, działa jak makro {key} i można go wybrać jako grupowanie w Raportach i raportach Sub-ID, obok sub1…sub30. Przypisz go do slotu sub, żeby zachować spójność między kampaniami.",
  "Use lowercase keys — the tracker does not read:": "Używaj małych liter w kluczach — tracker nie odczyta:",
  "Tracking URL preview": "Podgląd URL trackingowego",
  "Paste this as Final URL (Google Ads) or tracking link (Facebook). Replace {key} placeholders with real ad-network macros as needed.": "Wklej to jako Final URL (Google Ads) lub tracking link (Facebook). W razie potrzeby zamień placeholdery {key} na prawdziwe makra sieci reklamowej.",
  "Fire Google Ads gtag on redirect": "Uruchom gtag Google Ads przy przekierowaniu",
  "When on, /r/ returns a tiny HTML page that calls gtag(\"event\",\"conversion\", …) with your simple-mode tag before redirecting. Use this if you do not configure the Final URL suffix on the Google Ads side.": "Gdy włączone, /r/ zwraca małą stronę HTML, która wywołuje gtag(\"event\",\"conversion\", …) z twoim tagiem w trybie prostym przed przekierowaniem. Użyj tego, jeśli nie konfigurujesz sufiksu Final URL po stronie Google Ads.",
  "S2S postbacks": "Postbacki S2S",
  "Outbound HTTP calls fired whenever a conversion postback is received. Supports macros like {click_id}, {payout}, and every campaign parameter declared above.": "Wychodzące wywołania HTTP wysyłane za każdym razem, gdy otrzymasz postback konwersji. Obsługuje makra takie jak {click_id}, {payout} oraz wszystkie parametry kampanii zadeklarowane powyżej.",
  "No postbacks yet": "Brak postbacków",
  "Method": "Metoda",
  "Statuses": "Statusy",
  "Add postback": "Dodaj postback",
  "Show recent log": "Pokaż ostatni log",
  "Available macros": "Dostępne makra",
  "Campaign saved": "Kampania zapisana",
  "Postback fired": "Postback wysłany",
  "Mode": "Tryb",
  "Simple": "Prosty",
  "Advanced": "Zaawansowany",
  "Conversion tag": "Tag konwersji",
  "Conversion tag is required": "Tag konwersji jest wymagany",
  "Paste the \"send_to\" value from your Google Ads conversion snippet (e.g. AW-123456789/AbCdEf). No OAuth needed. The tracker stores it and fires it via Final URL suffix or on-redirect gtag.": "Wklej wartość \"send_to\" ze snippetu konwersji Google Ads (np. AW-123456789/AbCdEf). OAuth nie jest potrzebny. Tracker zapisuje ją i wysyła przez sufiks Final URL lub gtag przy przekierowaniu.",
  "OAuth-based Click Conversions Upload — requires developer token, customer ID and a refresh token. Use only if you need server-side uploads with gclid.": "Przesyłanie konwersji kliknięć oparte na OAuth — wymaga developer token, customer ID i refresh token. Użyj tylko, jeśli potrzebujesz przesyłania po stronie serwera z gclid.",
  "Campaign": "Kampania",
  "Create a new xpnsr.tech account": "Utwórz nowe konto xpnsr.tech",
  "Already have an account? Sign in": "Masz już konto? Zaloguj się",
  "Only ZIP files are supported": "Obsługiwane są tylko pliki ZIP",
  "Please enter a name for the landing page": "Podaj nazwę landing page",
  "Please select a ZIP file": "Wybierz plik ZIP",
  "Landing page uploaded successfully": "Landing page przesłana pomyślnie",
  "Error uploading landing page": "Błąd podczas przesyłania landing page",
  "Upload ZIP": "Prześlij ZIP",
  "Upload Landing Page": "Prześlij landing page",
  "Upload a ZIP file containing your landing page files (max 50MB)": "Prześlij plik ZIP zawierający pliki twojej landing page (maks. 50 MB)",
  "My landing page": "Moja landing page",
  "tag1, tag2, tag3": "tag1, tag2, tag3",
  "Separate tags with commas": "Oddziel tagi przecinkami",
  "ZIP File": "Plik ZIP",
  "Drag & drop or click to select": "Przeciągnij i upuść lub kliknij, aby wybrać",
  "Select ZIP File": "Wybierz plik ZIP",
  "Uploading...": "Przesyłanie...",
  "Upload": "Prześlij",
  "History": "Historia",
  "Notification settings": "Ustawienia powiadomień",
  "Please fill in name and select ZIP file": "Podaj nazwę i wybierz plik ZIP",
  "Offer uploaded successfully": "Oferta przesłana pomyślnie",
  "Error uploading offer": "Błąd podczas przesyłania oferty",
  "Upload Offer ZIP": "Prześlij ZIP oferty",
  "Upload a ZIP file containing offer files": "Prześlij plik ZIP zawierający pliki oferty",
  "Countries (comma-separated ISO codes, e.g. US,RU,DE)": "Kraje (kody ISO oddzielone przecinkami, np. US,RU,DE)",
  "ZIP File (max 100MB)": "Plik ZIP (maks. 100 MB)",
  "Change": "Zmień",
  "Select ZIP file": "Wybierz plik ZIP",
  "Upload a ZIP file containing HTML pages, images, and other assets. Supported: _preview.png for preview, PHP scripts for processing.": "Prześlij plik ZIP zawierający strony HTML, obrazy i inne zasoby. Obsługiwane: _preview.png jako podgląd, skrypty PHP do przetwarzania.",
  "Upload Offer": "Prześlij ofertę",
  "pages": "strony",
  "Choose entry point": "Wybierz punkt wejścia",
  "Multiple HTML pages detected. Select the main page visitors will land on.": "Wykryto wiele stron HTML. Wybierz główną stronę, na którą trafią odwiedzający.",
  "Skip (use auto-detected)": "Pomiń (użyj wykrytej automatycznie)",
  "Confirm": "Potwierdź",
  "Edit files": "Edytuj pliki",
  "File editor": "Edytor plików",
  "Edit HTML, CSS, JS and other text files inside the uploaded archive": "Edytuj pliki HTML, CSS, JS i inne pliki tekstowe wewnątrz przesłanego archiwum",
  "Files": "Pliki",
  "Select a file from the sidebar to edit": "Wybierz plik z panelu bocznego, aby go edytować",
  "Binary file — not editable": "Plik binarny — nieedytowalny",
  "File saved": "Plik zapisany",
  "Error loading files": "Błąd wczytywania plików",
  "Error loading file": "Błąd wczytywania pliku",
  "Error saving file": "Błąd zapisu pliku",
  "Discard unsaved changes?": "Odrzucić niezapisane zmiany?",
  "Saving...": "Zapisywanie...",
  "Bulk create": "Utwórz masowo",
  "Bulk create Google Ads forwarders": "Masowo utwórz forwardery Google Ads",
  "Conversion tags (one per line)": "Tagi konwersji (jeden na linię)",
  "Paste AW-XXX/YYY tags, one per line. Each creates a separate forwarder.": "Wklej tagi AW-XXX/YYY, jeden na linię. Każdy tworzy osobny forwarder.",
  "Bind to campaigns": "Przypisz do kampanii",
  "Leave empty to fire on all campaigns": "Zostaw puste, aby działało dla wszystkich kampanii",
  "Add campaign…": "Dodaj kampanię…",
  "Create all": "Utwórz wszystkie",
  "Creating…": "Tworzenie…",
  "{count} forwarders created": "Utworzono {count} forwarderów",
  "campaign": "kampania",
  "Linked forwarders": "Powiązane forwardery",
  "Conversion forwarders that fire for this campaign": "Forwardery konwersji, które działają dla tej kampanii",
  "Heatmap": "Mapa cieplna",
  "Funnel": "Lejek",
  "Activity heatmap": "Mapa cieplna aktywności",
  "Day-of-week x hour-of-day breakdown": "Podział wg dnia tygodnia i godziny",
  "Less": "Mniej",
  "More": "Więcej",
  "Peak": "Szczyt",
  "No heatmap data": "Brak danych mapy cieplnej",
  "Conversion funnel": "Lejek konwersji",
  "Click-to-conversion pipeline with status breakdown": "Ścieżka od kliknięcia do konwersji z podziałem na statusy",
  "Status breakdown": "Podział wg statusu",
  "No funnel data": "Brak danych lejka",
  "Mon": "Pon",
  "Tue": "Wt",
  "Wed": "Śr",
  "Thu": "Czw",
  "Fri": "Pt",
  "Sat": "Sob",
  "Sun": "Nd",
  "Ad-Account Connections": "Połączenia kont reklamowych",
  "Connect FB / Google Ads accounts so cost data is pulled into campaigns automatically.": "Połącz konta FB / Google Ads, aby dane o kosztach trafiały do kampanii automatycznie.",
  "Connect with Facebook": "Połącz z Facebookiem",
  "Connect with Google Ads": "Połącz z Google Ads",
  "Ad account connected via OAuth": "Konto reklamowe połączone przez OAuth",
  "OAuth error: ": "Błąd OAuth: ",
  "Failed to start OAuth": "Nie udało się uruchomić OAuth",
  "Token refreshed": "Token odświeżony",
  "Refresh failed": "Odświeżanie nie powiodło się",
  "Refresh token": "Odśwież token",
  "Connect ad account": "Połącz konto reklamowe",
  "Tokens are encrypted at rest. Use OAuth buttons above for FB / Google, or enter tokens manually below.": "Tokeny są szyfrowane w spoczynku. Użyj przycisków OAuth powyżej dla FB / Google albo wpisz tokeny ręcznie poniżej.",
  "Sync now": "Synchronizuj teraz",
  "Connect": "Połącz",
  "Failed to load connections": "Nie udało się wczytać połączeń",
  "Connection created": "Połączenie utworzone",
  "Connection deleted": "Połączenie usunięte",
  "Delete this connection?": "Usunąć to połączenie?",
  "Delete failed": "Usuwanie nie powiodło się",
  "Sync complete": "Synchronizacja zakończona",
  "Sync failed": "Synchronizacja nie powiodła się",
  "No connections yet. Connect FB or Google Ads to start importing cost.": "Brak połączeń. Połącz FB lub Google Ads, aby zacząć importować koszty.",
  "Refresh token (optional)": "Token odświeżania (opcjonalnie)",
  "Display name": "Nazwa wyświetlana",
  "Account ID": "ID konta",
  "Access token": "Token dostępu",
  "Save failed": "Zapis nie powiódł się",
  "Permissions": "Uprawnienia",
  "Permission matrix": "Macierz uprawnień",
  "Permission matrix saved": "Macierz uprawnień zapisana",
  "Failed to load permission matrix": "Nie udało się wczytać macierzy uprawnień",
  "Failed to save permission matrix": "Nie udało się zapisać macierzy uprawnień",
  "Override the minimum role required for each action in this workspace. Only cells that differ from the default are persisted.": "Nadpisz minimalną rolę wymaganą dla każdej akcji w tym workspace. Zapisywane są tylko komórki różniące się od wartości domyślnej.",
  "overrides": "nadpisania",
  "Read-only — only the workspace owner can edit the matrix.": "Tylko do odczytu — macierz może edytować wyłącznie właściciel workspace.",
  "Reset all to defaults": "Przywróć wszystko do domyślnych",
  "Custom": "Niestandardowe",
  "Reset to default": "Przywróć domyślne",
  "owner": "właściciel",
  "admin": "admin",
  "manager": "menedżer",
  "viewer": "widz",
  "Landings & offers": "Landingi i oferty",
  "Reports": "Raporty",
  "Audit": "Audyt",
  "Toggle navigation hints": "Przełącz podpowiedzi nawigacji",
  "Show hints": "Pokaż podpowiedzi",
  "Hide hints": "Ukryj podpowiedzi",
  "Tools": "Narzędzia",
  "Admin": "Administrator",
  "Resources": "Zasoby",
  "Pre-landings": "Prelandery",
  "Book demo": "Zarezerwuj demo",
  "Overview of clicks, conversions and active campaigns": "Przegląd kliknięć, konwersji i aktywnych kampanii",
  "Create ad campaigns and get tracking links": "Twórz kampanie reklamowe i generuj linki trackingowe",
  "Upload landing pages (ZIP) or set a URL for split-tests": "Wgraj landing page (ZIP) albo podaj URL do split-testów",
  "Warm-up pages shown before the offer": "Prelandery wyświetlane przed ofertą",
  "Connect Facebook, Google, TikTok ad accounts": "Połącz konta reklamowe Facebook, Google, TikTok",
  "Two-factor auth, sessions and password": "Uwierzytelnianie dwuskładnikowe, sesje i hasło",
  "Uploaded offers/funnels + API routing to partners (weights, failover) + lead forms": "Wgrane oferty/funnele + routing API do partnerów (wagi, failover) + formularze lead",
  "Traffic sources with presets (Google Ads with tm & macros, etc.)": "Źródła ruchu z gotowymi presetami (Google Ads z tm i makrami itd.)",
  "Manage flows and traffic distribution rules": "Zarządzaj streamami i regułami dystrybucji ruchu",
  "Split-test landings and offers with auto-distribution": "Split-testy landingów i ofert z automatyczną dystrybucją",
  "Block bots, fraud and suspicious clicks": "Blokuj boty, fraud i podejrzane kliknięcia",
  "Detailed reports: charts, geo, devices, ROI": "Szczegółowe raporty: wykresy, geo, urządzenia, ROI",
  "Full click log with IP, UserAgent, GEO and time": "Pełny log kliknięć z IP, UserAgent, GEO i czasem",
  "Auto-rules: pause campaigns on low ROI, etc.": "Reguły automatyczne: pauzuj kampanie przy niskim ROI itd.",
  "Partner CRMs (TrackBox, Custom API) for API lead injection + notifications": "CRM-y partnerów (TrackBox, Custom API) do wysyłki leadów przez API + powiadomienia",
  "Add your own domains for tracking links": "Dodaj własne domeny do linków trackingowych",
  "Online conversions to Google/FB/TikTok (S2S). Google — simple, no OAuth": "Konwersje online do Google/FB/TikTok (S2S). Google — tryb prosty, bez OAuth",
  "Keys to access the tracker REST API": "Klucze dostępu do REST API trackera",
  "Invite your team, assign roles and permissions": "Zaproś zespół, przypisz role i uprawnienia",
  "Action log of all users for 90 days": "Log akcji wszystkich użytkowników z ostatnich 90 dni",
  "Cookie consent banner for GDPR compliance": "Baner zgody na cookies zgodny z RODO",
  "Ready-made templates and integrations": "Gotowe szablony i integracje",
  "Swagger REST API docs (opens in new tab)": "Dokumentacja Swagger REST API (otwiera się w nowej karcie)",
  "Failed conversion dispatches — can be retried": "Nieudane wysyłki konwersji — możesz ponowić",
  "Server, queue and database status": "Status serwerów, kolejek i baz danych",
  "Plan, payment and usage limits": "Plan, płatności i limity użycia",
  "Profile, language, timezone and notifications": "Profil, język, strefa czasowa i powiadomienia",
  "(no label)": "(brak etykiety)",
  "180 days": "180 dni",
  "2FA disabled": "2FA wyłączona",
  "2FA enabled": "2FA włączona",
  "2FA is currently enabled": "2FA jest obecnie włączona",
  "302 redirect (default)": "Przekierowanie 302 (domyślne)",
  "365 days": "365 dni",
  "A campaign groups your traffic sources and tracking links under one name.": "Kampania grupuje twoje źródła ruchu i linki trackingowe pod jedną nazwą.",
  "AI Optimizer": "Optymalizator AI",
  "Accept button label": "Tekst przycisku Akceptuj",
  "Accepted": "Zaakceptowano",
  "Accepting invitation…": "Akceptowanie zaproszenia…",
  "Action on trigger": "Akcja po wyzwoleniu",
  "Activate": "Aktywuj",
  "Activate 2FA": "Aktywuj 2FA",
  "Add a forwarder to push conversions to ad networks automatically.": "Dodaj forwarder, żeby automatycznie wysyłać konwersje do sieci reklamowych.",
  "Add forwarder": "Dodaj forwarder",
  "Add the CNAME record shown on the Domains page, then click verify.": "Dodaj rekord CNAME widoczny na stronie Domeny, a potem kliknij Zweryfikuj.",
  "Add vendor": "Dodaj dostawcę",
  "Aggressive: blocks any click whose JA3/JA4 is missing or not yet classified. Tag corporate-proxy hashes first via Workspace Overrides.": "Agresywny: blokuje każdy klik, dla którego brakuje JA3/JA4 lub nie zostało ono jeszcze sklasyfikowane. Najpierw oznacz hashe proxy firmowych za pomocą Nadpisań obszaru roboczego.",
  "Alert if ROI drops below this %": "Powiadom, gdy ROI spadnie poniżej tego %",
  "Algorithm": "Algorytm",
  "All groups": "Wszystkie grupy",
  "All statuses": "Wszystkie statusy",
  "Allowed metrics": "Dozwolone metryki",
  "Always block these JA3 / JA4 hashes regardless of classification.": "Zawsze blokuj te hashe JA3 / JA4, niezależnie od klasyfikacji.",
  "Anonymous": "Anonimowy",
  "Any type": "Dowolny typ",
  "Anyone with this link will lose access to the shared dashboard immediately.": "Każdy, kto ma ten link, natychmiast straci dostęp do udostępnionego panelu.",
  "Applied {n} weight changes": "Zastosowano {n} zmian wagi",
  "Archive": "Archiwizuj",
  "Archived": "Zarchiwizowane",
  "Auto": "Auto",
  "Auto-refresh every 30s": "Automatyczne odświeżanie co 30s",
  "Available on enterprise plans. Hides the \"Powered by xpnsr\" footer.": "Dostępne w planach enterprise. Ukrywa stopkę „Powered by xpnsr”.",
  "Back to sign-in": "Wróć do logowania",
  "Backup codes (save now)": "Kody zapasowe (zapisz teraz)",
  "Bangkok (UTC+7)": "Bangkok (UTC+7)",
  "Banned": "Zbanowany",
  "Banner copy": "Treść banera",
  "Banner status": "Status banera",
  "Berlin (UTC+1)": "Berlin (UTC+1)",
  "Best cohort": "Najlepsza kohorta",
  "Block classification": "Klasyfikacja do zablokowania",
  "Block fingerprints classified as bad": "Blokuj odciski palców sklasyfikowane jako złe",
  "Block unknown fingerprints": "Blokuj nieznane odciski palców",
  "Block when the blended TLS+UA+IP risk score exceeds this threshold. Default 0.7.": "Blokuj, gdy łączny wynik ryzyka TLS+UA+IP przekroczy ten próg. Domyślnie 0.7.",
  "Body": "Treść",
  "Body (JSON)": "Treść (JSON)",
  "Body copied to clipboard.": "Treść skopiowana do schowka.",
  "Body must be valid JSON.": "Treść musi być poprawnym JSON.",
  "Branding": "Branding",
  "Branding cleared": "Branding wyczyszczony",
  "Branding saved": "Branding zapisany",
  "Break down clicks and conversions by sub-ID parameters (sub1–sub15)": "Rozbij kliki i konwersje według parametrów sub ID (sub1–sub15)",
  "Browse and install community-contributed templates for postbacks, macros, anti-fraud rules, and pre-landings. Submissions auto-publish — the community self-polices via the delete action.": "Przeglądaj i instaluj szablony postbacków, makr, reguł antyfraudowych i prelanderów dodane przez społeczność. Zgłoszenia publikują się automatycznie — społeczność sama się reguluje za pomocą opcji usuwania.",
  "Browser": "Przeglądarka",
  "Build traffic rules, rotate landings and split-test offers for any campaign.": "Twórz reguły ruchu, rotuj landing page'e i testuj oferty A/B dla dowolnej kampanii.",
  "Bundle verified domains into a pool and rotate tracking links across them. Pull a banned domain out of rotation in one click without redeploying ad copies.": "Zgrupuj zweryfikowane domeny w pulę i rotuj między nimi linki śledzące. Usuń zbanowaną domenę z rotacji jednym kliknięciem, bez konieczności ponownego wdrażania kreacji reklamowych.",
  "By browser": "Według przeglądarki",
  "By device": "Według urządzenia",
  "By {author}": "Autor: {author}",
  "CR %": "CR %",
  "CR%": "CR%",
  "Campaign ID": "ID kampanii",
  "Campaign activated": "Kampania aktywowana",
  "Campaign archived": "Kampania zarchiwizowana",
  "Campaign cloned successfully!": "Kampania sklonowana pomyślnie!",
  "Campaign comparison": "Porównanie kampanii",
  "Campaign created": "Kampania utworzona",
  "Campaign dashboard": "Panel kampanii",
  "Campaign restored": "Kampania przywrócona",
  "Cap": "Cap",
  "Cap timezone": "Strefa czasowa capu",
  "Catalog": "Katalog",
  "Chicago (UTC-6)": "Chicago (UTC-6)",
  "Choose a preset and optionally extend it with extra ISO-3166 country codes (comma-separated, e.g. BR, MX, AR).": "Wybierz preset i opcjonalnie rozszerz go o dodatkowe kody krajów ISO-3166 (oddzielone przecinkami, np. BR, MX, AR).",
  "Clear": "Wyczyść",
  "Click ID forward parameter": "Parametr przekazywania click ID",
  "Click detail": "Szczegóły kliku",
  "Click to activate": "Kliknij, aby aktywować",
  "Click to pause": "Kliknij, aby zatrzymać",
  "Clicks log": "Log kliknięć",
  "Clipboard unavailable — copy the URL manually": "Schowek niedostępny — skopiuj URL ręcznie",
  "Cloaked (iframe)": "Cloakowany (iframe)",
  "Cloaked iframe keeps the tracker domain in the address bar — only works for destinations that allow framing.": "Cloakowany iframe zachowuje domenę trackera w pasku adresu — działa tylko dla miejsc docelowych, które pozwalają na framing.",
  "Clone": "Klonuj",
  "Close navigation": "Zamknij nawigację",
  "Cohort": "Kohorta",
  "Cohort retention": "Retencja kohort",
  "Comma-separated list of IPs allowed to send postbacks. Leave empty to allow all.": "Lista adresów IP uprawnionych do wysyłania postbacków, oddzielonych przecinkami. Zostaw puste, by zezwolić wszystkim.",
  "Compare": "Porównaj",
  "Compare current to proposed weights. Apply persists the proposed column to the streams.": "Porównaj aktualne wagi z proponowanymi. Zastosuj zapisuje proponowaną kolumnę w streamach.",
  "Comparing…": "Porównywanie…",
  "Compliance": "Zgodność",
  "Configure UTM templates and conversion postbacks for every ad network you run.": "Skonfiguruj szablony UTM i postbacki konwersji dla każdej sieci reklamowej, z której korzystasz.",
  "Configure offers, payouts and target geos. Upload ZIPs or link external networks.": "Skonfiguruj oferty, wypłaty i docelowe GEO. Wgraj pliki ZIP lub podłącz zewnętrzne sieci.",
  "Configure stream": "Skonfiguruj stream",
  "Configure the GDPR / CCPA cookie banner that runs on your tracker landing pages. The banner is region-aware — visitors outside the configured regions never see it.": "Skonfiguruj baner cookies GDPR / CCPA wyświetlany na landing page'ach twojego trackera. Baner rozpoznaje region — odwiedzający spoza skonfigurowanych regionów nigdy go nie zobaczą.",
  "Confirm action": "Potwierdź akcję",
  "Connect external services and webhooks": "Połącz zewnętrzne usługi i webhooki",
  "Connect external services and webhooks to automate workflows.": "Połącz zewnętrzne usługi i webhooki, by zautomatyzować procesy.",
  "Connection restored": "Połączenie przywrócone",
  "Connections": "Połączenia",
  "Consent banner": "Baner zgody",
  "Consent banner saved": "Baner zgody zapisany",
  "Conv": "Konw",
  "Conv.": "Konw.",
  "Conversion rate comparison": "Porównanie wskaźnika konwersji",
  "Cookieless mode (skip xpnsr_vid first-party cookie)": "Tryb bez cookies (pomija cookie first-party xpnsr_vid)",
  "Copied to clipboard.": "Skopiowano do schowka.",
  "Copy link (/r/)": "Skopiuj link (/r/)",
  "Copy link (/{alias}/)": "Skopiuj link (/{alias}/)",
  "Cost": "Koszt",
  "Cost value": "Wartość kosztu",
  "Could not accept invitation": "Nie udało się zaakceptować zaproszenia",
  "Could not copy — please copy the link manually.": "Nie udało się skopiować — skopiuj link ręcznie.",
  "Could not create public link": "Nie udało się utworzyć publicznego linku",
  "Could not load branding": "Nie udało się wczytać brandingu",
  "Could not load marketplace templates.": "Nie udało się wczytać szablonów z marketplace.",
  "Could not load template detail.": "Nie udało się wczytać szczegółów szablonu.",
  "Could not load the shared dashboard.": "Nie udało się wczytać udostępnionego dashboardu.",
  "Could not reset branding": "Nie udało się zresetować brandingu",
  "Could not save branding": "Nie udało się zapisać brandingu",
  "Country (ISO-2)": "Kraj (ISO-2)",
  "Create a campaign first": "Najpierw utwórz kampanię",
  "Create key": "Utwórz klucz",
  "Create landing page": "Utwórz landing page",
  "Create link": "Utwórz link",
  "Create new landing page": "Utwórz nowy landing page",
  "Create new offer": "Utwórz nową ofertę",
  "Create offer": "Utwórz ofertę",
  "Create pool": "Utwórz pool",
  "Custom domain": "Własna domena",
  "Custom range": "Niestandardowy zakres",
  "Customise the dashboard for your agency or sub-account": "Dostosuj dashboard do swojej agencji lub subkonta",
  "Daily cap": "Dzienny limit",
  "Dashboard hostname": "Hostname dashboardu",
  "Decision": "Decyzja",
  "Default offer URL": "Domyślny URL oferty",
  "Defense": "Obrona",
  "Delete A/B test": "Usuń test A/B",
  "Delete API key": "Usuń klucz API",
  "Delete automation rule": "Usuń regułę automatyzacji",
  "Delete campaign": "Usuń kampanię",
  "Delete campaigns": "Usuń kampanie",
  "Delete connection": "Usuń połączenie",
  "Delete domain": "Usuń domenę",
  "Delete domain pool": "Usuń pool domen",
  "Delete failed.": "Usuwanie nie powiodło się.",
  "Delete forwarder": "Usuń forwarder",
  "Delete integration": "Usuń integrację",
  "Delete landing page": "Usuń landing page",
  "Delete offer": "Usuń ofertę",
  "Delete pre-landing": "Usuń prelander",
  "Delete stream": "Usuń stream",
  "Delete traffic source": "Usuń źródło ruchu",
  "Delete webhook": "Usuń webhook",
  "Delete {n} selected campaign(s)? This cannot be undone.": "Usunąć {n} wybranych kampanii? Tej operacji nie można cofnąć.",
  "Denver (UTC-7)": "Denver (UTC-7)",
  "Deselect all": "Odznacz wszystko",
  "Device": "Urządzenie",
  "Disable 2FA": "Wyłącz 2FA",
  "Disable 2FA — enter a current code": "Wyłącz 2FA — wpisz aktualny kod",
  "Disable auto-refresh": "Wyłącz automatyczne odświeżanie",
  "Disable failed": "Nie udało się wyłączyć",
  "Disabled": "Wyłączone",
  "Discard DLQ entry": "Odrzuć wpis z DLQ",
  "Dismissed": "Odrzucone",
  "Do not block by classification": "Nie blokuj według klasyfikacji",
  "Domain marked healthy": "Domena oznaczona jako sprawna",
  "Domain not verified yet — check the DNS record.": "Domena jeszcze nie zweryfikowana — sprawdź rekord DNS.",
  "Domain pool created": "Pula domen utworzona",
  "Domain pool deleted": "Pula domen usunięta",
  "Domain pools": "Pule domen",
  "Domain pulled from rotation": "Domena wycofana z rotacji",
  "Domain registered. Add the DNS record, then verify.": "Domena zarejestrowana. Dodaj rekord DNS, a potem zweryfikuj.",
  "Done": "Gotowe",
  "Dubai (UTC+4)": "Dubaj (UTC+4)",
  "EPC": "EPC",
  "Each row is a day's first-time visitors. Columns track cumulative conversion rate by day-offset.": "Każdy wiersz to nowi odwiedzający z danego dnia. Kolumny pokazują skumulowany CR według przesunięcia dni.",
  "Earnings per click": "Zarobek na klik",
  "Edit pre-landing": "Edytuj prelander",
  "Enable 2FA": "Włącz 2FA",
  "Enabled": "Włączone",
  "Enter a code from the app to confirm": "Wpisz kod z aplikacji, żeby potwierdzić",
  "Enter a hostname": "Wpisz hostname",
  "Enter an offer URL": "Wpisz URL oferty",
  "Enter the 6-digit code from your authenticator app, or one of your backup codes.": "Wpisz 6-cyfrowy kod z aplikacji uwierzytelniającej albo jeden z kodów zapasowych.",
  "Epsilon (ε)": "Epsilon (ε)",
  "Error archiving campaign": "Błąd podczas archiwizowania kampanii",
  "Error cloning campaign": "Błąd podczas klonowania kampanii",
  "Expires": "Wygasa",
  "Expires after (days)": "Wygasa po (dni)",
  "Explicit blocked fingerprints (comma-separated)": "Jawnie zablokowane fingerprinty (oddzielone przecinkami)",
  "Export JSON": "Eksportuj JSON",
  "Export XLSX": "Eksportuj XLSX",
  "Extra countries (ISO-3166 alpha-2)": "Dodatkowe kraje (ISO-3166 alpha-2)",
  "Failed to accept invite": "Nie udało się zaakceptować zaproszenia",
  "Failed to apply optimization": "Nie udało się zastosować optymalizacji",
  "Failed to compare": "Nie udało się porównać",
  "Failed to copy tracking link": "Nie udało się skopiować linku trackingowego",
  "Failed to create campaign": "Nie udało się utworzyć kampanii",
  "Failed to create pool": "Nie udało się utworzyć puli",
  "Failed to delete key": "Nie udało się usunąć klucza",
  "Failed to load campaigns": "Nie udało się wczytać kampanii",
  "Failed to load clicks log": "Nie udało się wczytać logu kliknięć",
  "Failed to load consent config": "Nie udało się wczytać konfiguracji zgód",
  "Failed to load conversions": "Nie udało się wczytać konwersji",
  "Failed to load pre-landings": "Nie udało się wczytać prelanderów",
  "Failed to load profile": "Nie udało się wczytać profilu",
  "Failed to load sub-ID report": "Nie udało się wczytać raportu sub ID",
  "Failed to preview optimization": "Nie udało się wyświetlić podglądu optymalizacji",
  "Failed to register domain": "Nie udało się zarejestrować domeny",
  "Failed to revoke access": "Nie udało się odebrać dostępu",
  "Failed to save": "Nie udało się zapisać",
  "Failed to update status": "Nie udało się zaktualizować statusu",
  "Fallback offer": "Oferta zapasowa",
  "Filter junk traffic, block malicious IPs and review suspicious activity in one place.": "Filtruj śmieciowy ruch, blokuj złośliwe IP i przeglądaj podejrzaną aktywność w jednym miejscu.",
  "From (ISO-8601)": "Od (ISO-8601)",
  "GDPR: pseudonymize visitor IPs (hash before storage)": "RODO: pseudonimizuj IP odwiedzających (hashuj przed zapisem)",
  "Generate a key to call the public REST API.": "Wygeneruj klucz, żeby korzystać z publicznego API REST.",
  "Go back": "Wróć",
  "Go to Workspace": "Przejdź do obszaru roboczego",
  "Group (optional)": "Grupa (opcjonalnie)",
  "Group by:": "Grupuj według:",
  "Healthy": "Sprawna",
  "Hide xpnsr branding": "Ukryj branding xpnsr",
  "Hosted pages and uploads": "Hostowane strony i pliki",
  "Hostname": "Hostname",
  "Install": "Zainstaluj",
  "Install failed.": "Instalacja nie powiodła się.",
  "Invalid 2FA code": "Nieprawidłowy kod 2FA",
  "Invalid SSO session": "Nieprawidłowa sesja SSO",
  "Invitation accepted!": "Zaproszenie zaakceptowane!",
  "JS redirect (location.replace)": "Przekierowanie JS (location.replace)",
  "Keyboard shortcuts": "Skróty klawiszowe",
  "Keyboard shortcuts (?)": "Skróty klawiszowe (?)",
  "Keyword exclude": "Wykluczenie słów kluczowych",
  "Keyword include": "Uwzględnienie słów kluczowych",
  "Label (operator-only)": "Etykieta (tylko dla operatora)",
  "Last 200 consent records in this workspace. Used as the audit trail for DSAR / regulator inquiries.": "Ostatnie 200 rekordów zgód w tym workspace. Służą jako ślad audytowy dla zapytań DSAR / organów regulacyjnych.",
  "Last viewed": "Ostatnio wyświetlane",
  "Layout": "Układ",
  "Layout & retention": "Układ i retencja",
  "Live": "Na żywo",
  "Live KPIs and breakdowns across campaigns, geos, devices.": "KPI na żywo i podziały wg kampanii, GEO i urządzeń.",
  "Loading marketplace…": "Ładowanie marketplace…",
  "Loading...": "Ładowanie...",
  "Login page subtitle": "Podtytuł strony logowania",
  "Logo URL": "URL loga",
  "London (UTC+0)": "Londyn (UTC+0)",
  "Lookback (days)": "Lookback (dni)",
  "Los Angeles (UTC-8)": "Los Angeles (UTC-8)",
  "Make sure your tracking URLs include {key}=... parameter": "Upewnij się, że Twoje linki trackingowe zawierają parametr {key}=...",
  "Manage profile, preferences, notifications and system configuration.": "Zarządzaj profilem, preferencjami, powiadomieniami i konfiguracją systemu.",
  "Manage your offers and creatives": "Zarządzaj swoimi ofertami i kreacjami",
  "Manual entry secret": "Sekret do ręcznego wpisania",
  "Mark all read": "Oznacz wszystkie jako przeczytane",
  "Mark read": "Oznacz jako przeczytane",
  "Marketplace": "Marketplace",
  "Match if referrer/params contain a keyword": "Dopasuj, jeśli referrer/parametry zawierają słowo kluczowe",
  "Meta refresh": "Meta refresh",
  "Metric": "Metryka",
  "Min clicks per stream": "Min. liczba kliknięć na stream",
  "Minimum ROI (%)": "Minimalny ROI (%)",
  "Missing SSO session token": "Brak tokena sesji SSO",
  "Missing invite token": "Brak tokena zaproszenia",
  "Most clicks": "Najwięcej kliknięć",
  "Most revenue": "Najwięcej przychodu",
  "Mumbai (UTC+5:30)": "Mumbaj (UTC+5:30)",
  "Must be an https:// URL. Leave blank to fall back to the xpnsr logo.": "Musi być adresem https://. Zostaw puste, aby użyć domyślnego logo xpnsr.",
  "Name A→Z": "Nazwa A→Z",
  "Name Z→A": "Nazwa Z→A",
  "Name and target URL are required": "Nazwa i docelowy URL są wymagane",
  "Name is required.": "Nazwa jest wymagana.",
  "New": "Nowy",
  "New pre-landing": "Nowy prelander",
  "New public dashboard link": "Nowy publiczny link do panelu",
  "Newest first": "Od najnowszych",
  "Next": "Dalej",
  "No active streams to optimize.": "Brak aktywnych streamów do optymalizacji.",
  "No clicks match these filters.": "Żadne kliknięcia nie pasują do tych filtrów.",
  "No cohort data": "Brak danych kohortowych",
  "No consent records yet.": "Brak rekordów zgód.",
  "No conversions yet": "Brak konwersji",
  "No data found for {key}": "Nie znaleziono danych dla {key}",
  "No data yet.": "Brak danych.",
  "No description provided.": "Nie podano opisu.",
  "No internet connection": "Brak połączenia z internetem",
  "No notifications yet": "Brak powiadomień",
  "No performance data yet": "Brak danych o wynikach",
  "No pre-landings yet. Create one to start chaining traffic.": "Brak prelanderów. Utwórz jeden, aby zacząć łączyć ruch.",
  "No public links yet. Create one to share read-only stats with advertisers.": "Brak publicznych linków. Utwórz jeden, aby udostępnić statystyki tylko do odczytu reklamodawcom.",
  "No results.": "Brak wyników.",
  "No templates match these filters.": "Żaden szablon nie pasuje do tych filtrów.",
  "No vendors disclosed.": "Nie ujawniono dostawców.",
  "No verified custom domains. Add one in Domains → Settings.": "Brak zweryfikowanych własnych domen. Dodaj jedną w Domeny → Ustawienia.",
  "None": "Brak",
  "Notify only": "Tylko powiadom",
  "Oldest first": "Od najstarszych",
  "Onboarding complete!": "Onboarding zakończony!",
  "Only match if referrer contains one of these": "Dopasuj tylko, jeśli referrer zawiera jedno z tych",
  "Open Campaigns": "Otwórz Kampanie",
  "Open Domains page": "Otwórz stronę Domeny",
  "Open command palette": "Otwórz paletę poleceń",
  "Open landing pages": "Otwórz landing page’y",
  "Open my tracking link": "Otwórz mój link trackingowy",
  "Operators host the static page; the tracker just routes clicks here first.": "Operatorzy hostują stronę statyczną; tracker tylko najpierw przekierowuje tam kliknięcia.",
  "Optimization": "Optymalizacja",
  "Optional": "Opcjonalnie",
  "Pages library": "Biblioteka stron",
  "Parameter name, e.g. sub1": "Nazwa parametru, np. sub1",
  "Pause": "Wstrzymaj",
  "Performance": "Wydajność",
  "Performance overview": "Podsumowanie wydajności",
  "Permanently discard this dead-letter entry? This cannot be undone.": "Trwale usunąć ten wpis dead-letter? Tej operacji nie można cofnąć.",
  "Please sign in first, then open the invite link again.": "Najpierw się zaloguj, a potem otwórz link z zaproszeniem ponownie.",
  "Please wait…": "Czekaj…",
  "Point this hostname at the tracker via DNS. Visitors hitting it will see your branding before they sign in.": "Skieruj ten hostname na tracker przez DNS. Odwiedzający zobaczą Twój branding przed zalogowaniem.",
  "Pool name": "Nazwa puli",
  "Postback IP whitelist": "Biała lista IP dla postbacków",
  "Pre-Landings": "Pre-landing page'y",
  "Pre-landing created": "Pre-landing page utworzona",
  "Pre-landing deleted": "Pre-landing page usunięta",
  "Pre-landing updated": "Pre-landing page zaktualizowana",
  "Pre-landings give you a faster, more compliant entry page before sending visitors to the offer. You can add one any time.": "Prelandery dają Ci szybszą stronę wejściową z lepszą zgodnością, zanim wyślesz ruch do oferty. Możesz dodać ją w dowolnym momencie.",
  "Preview": "Podgląd",
  "Previous": "Wstecz",
  "Primary colour": "Kolor podstawowy",
  "Privacy policy URL": "URL polityki prywatności",
  "Products": "Produkty",
  "Proposed": "Proponowane",
  "Proposed drift": "Proponowany drift",
  "Proposed weights": "Proponowane wagi",
  "Protect your account with a TOTP code from an authenticator app. Backup codes let you log in if you lose your device.": "Zabezpiecz swoje konto kodem TOTP z aplikacji uwierzytelniającej. Kody zapasowe pozwolą Ci się zalogować, jeśli zgubisz urządzenie.",
  "Public link created — copy it now, it won't be shown again.": "Link publiczny utworzony — skopiuj go teraz, nie zostanie pokazany ponownie.",
  "Public link revoked.": "Link publiczny odwołany.",
  "Public read-only links": "Publiczne linki tylko do odczytu",
  "Publish": "Opublikuj",
  "Publishing…": "Publikowanie…",
  "Pull out of rotation": "Wycofaj z rotacji",
  "Purpose (e.g. Analytics)": "Cel (np. Analytics)",
  "Quick start from template": "Szybki start z szablonu",
  "Quiz / review / bonus pages that intercept the click before the final landing or offer.": "Strony quiz / recenzja / bonus, które przechwytują kliknięcie przed finalną landing page lub ofertą.",
  "ROI": "ROI",
  "ROI alert": "Alert ROI",
  "Random seed (optional)": "Ziarno losowe (opcjonalnie)",
  "Read-only public view — generated by xpnsr-tracker.": "Publiczny widok tylko do odczytu — wygenerowany przez xpnsr-tracker.",
  "Rebalance stream weights based on historical conversion rate using a multi-armed bandit.": "Rebalansuj wagi streamów na podstawie historycznego CR, używając multi-armed bandit.",
  "Recent decisions": "Ostatnie decyzje",
  "Record retention (days)": "Retencja rekordów (dni)",
  "Redirect method": "Metoda przekierowania",
  "Redirect mode": "Tryb przekierowania",
  "Referrer / Keyword filters": "Filtry referrer / słowo kluczowe",
  "Referrer exclude": "Wyklucz referrer",
  "Referrer include": "Dołącz referrer",
  "Region preset": "Preset regionu",
  "Region scope": "Zakres regionu",
  "Register a custom hostname so your tracking links resolve under your own brand.": "Zarejestruj własny hostname, aby Twoje linki trackingowe działały pod Twoją marką.",
  "Register hostname": "Zarejestruj hostname",
  "Reject button label": "Etykieta przycisku odrzuć",
  "Rejected": "Odrzucono",
  "Remove": "Usuń",
  "Remove template": "Usuń szablon",
  "Remove this template? This cannot be undone.": "Usunąć ten szablon? Tej operacji nie można cofnąć.",
  "Reset branding": "Zresetuj branding",
  "Reset to defaults": "Przywróć domyślne",
  "Resetting…": "Resetowanie…",
  "Restore": "Przywróć",
  "Restore to rotation": "Przywróć do rotacji",
  "Return on investment": "Zwrot z inwestycji",
  "Rev.": "Przych.",
  "Revenue comparison": "Porównanie przychodów",
  "Revoke": "Odwołaj",
  "Revoke failed": "Odwołanie nie powiodło się",
  "Revoke public link": "Odwołaj link publiczny",
  "Risk score threshold (0.0 – 1.0)": "Próg wyniku ryzyka (0.0 – 1.0)",
  "Round robin": "Round robin",
  "Routing": "Routing",
  "Row-level drill-down into incoming clicks: country, device, stream, and variant.": "Szczegółowy podgląd przychodzących kliknięć: kraj, urządzenie, stream i wariant.",
  "Run a preview to see proposed weights.": "Uruchom podgląd, aby zobaczyć proponowane wagi.",
  "SSO failed": "Błąd SSO",
  "SSO is not configured": "SSO nie jest skonfigurowane",
  "SSO sign-in failed": "Logowanie przez SSO nie powiodło się",
  "Save branding": "Zapisz branding",
  "Scan the QR code with your authenticator app": "Zeskanuj kod QR aplikacją uwierzytelniającą",
  "Search": "Szukaj",
  "Search by name, description, or slug. Filter by type or tag.": "Szukaj po nazwie, opisie lub slugu. Filtruj po typie lub etykiecie.",
  "Search…": "Szukaj…",
  "Secondary colour": "Kolor drugorzędny",
  "Select all": "Zaznacz wszystko",
  "Select at least 2 campaigns": "Wybierz co najmniej 2 kampanie",
  "Select campaigns (2–10)": "Wybierz kampanie (2–10)",
  "Sending…": "Wysyłanie…",
  "Set up rules, notifications and triggered actions for your campaigns.": "Skonfiguruj reguły, powiadomienia i automatyczne akcje dla swoich kampanii.",
  "Set up your tracker": "Skonfiguruj swój tracker",
  "Setup failed": "Konfiguracja nie powiodła się",
  "Share a token-gated dashboard URL with advertisers without giving them an account.": "Udostępnij reklamodawcom URL panelu zabezpieczony tokenem, bez zakładania im konta.",
  "Shareable URL": "URL do udostępnienia",
  "Shared dashboard": "Udostępniony panel",
  "Side-by-side metrics for selected campaigns": "Metryki wybranych kampanii obok siebie",
  "Sign in with Google": "Zaloguj się przez Google",
  "Sign in with Microsoft": "Zaloguj się przez Microsoft",
  "Singapore (UTC+8)": "Singapur (UTC+8)",
  "Size": "Rozmiar",
  "Skip for now": "Pomiń na razie",
  "Skip if referrer contains one of these": "Pomiń, jeśli referrer zawiera jedno z poniższych",
  "Skip if referrer/params contain a keyword": "Pomiń, jeśli referrer/parametry zawierają słowo kluczowe",
  "Skip this step until you have a campaign — you can finish setup from the Campaigns page.": "Pomiń ten krok, dopóki nie masz kampanii — konfigurację dokończysz na stronie Kampanie.",
  "Skipped (below min_clicks_per_stream)": "Pominięto (poniżej min_clicks_per_stream)",
  "Smoothed CR": "Wygładzony CR",
  "Sort by": "Sortuj według",
  "Split traffic across variants to find what converts best.": "Podziel ruch między warianty, aby znaleźć ten, który konwertuje najlepiej.",
  "Step {step} of {total}": "Krok {step} z {total}",
  "Sticky (per-visitor)": "Przypisany na stałe (per odwiedzający)",
  "Stream": "Stream",
  "Stream ID": "ID streamu",
  "Stream configured": "Stream skonfigurowany",
  "Streams decide which offer each visitor lands on. Configure your default stream and you\\'ll have a working tracking link.": "Streamy decydują, na jaką ofertę trafi każdy odwiedzający. Skonfiguruj domyślny stream, a będziesz mieć działający link trackingowy.",
  "Sub-ID drill-down": "Szczegółowy podgląd wg Sub ID",
  "Submission failed.": "Wysyłanie nie powiodło się.",
  "Submissions auto-publish. The slug is derived from the name; if it collides with an existing template, a numeric suffix is appended.": "Zgłoszenia publikują się automatycznie. Slug jest generowany z nazwy; jeśli koliduje z istniejącym szablonem, dodawany jest numeryczny sufiks.",
  "Submit a template": "Zgłoś szablon",
  "Submit template": "Zgłoś szablon",
  "Sydney (UTC+11)": "Sydney (UTC+11)",
  "São Paulo (UTC-3)": "São Paulo (UTC-3)",
  "TLS fingerprint (JA3 / JA4)": "Odcisk TLS (JA3 / JA4)",
  "Tags (comma-separated)": "Tagi (oddzielone przecinkami)",
  "Tags:": "Tagi:",
  "Template": "Szablon",
  "Template body copied to clipboard.": "Treść szablonu skopiowana do schowka.",
  "Template installed. Body shown in detail dialog.": "Szablon zainstalowany. Treść widoczna w oknie szczegółów.",
  "Template marketplace": "Marketplace szablonów",
  "Template published as {slug}.": "Szablon opublikowany jako {slug}.",
  "Template removed.": "Szablon usunięty.",
  "The token will only be shown once after creation — copy it immediately.": "Token zostanie pokazany tylko raz po utworzeniu — skopiuj go od razu.",
  "Third-party processors disclosed to the visitor (max 50).": "Procesorzy zewnętrzni ujawnieni odwiedzającemu (maks. 50).",
  "This link is unauthenticated. Anyone with it can view the selected metrics until it expires or is revoked.": "Ten link nie wymaga uwierzytelnienia. Każdy, kto go ma, może zobaczyć wybrane metryki, dopóki nie wygaśnie lub nie zostanie cofnięty.",
  "This member will lose access to this workspace immediately.": "Ten członek natychmiast straci dostęp do tego workspace'u.",
  "This shared link has expired or been revoked.": "Ten udostępniony link wygasł lub został cofnięty.",
  "This shared link is not valid.": "Ten udostępniony link jest nieprawidłowy.",
  "This will permanently delete \"{name}\" and all associated clicks, conversions and postback events. This cannot be undone.": "To trwale usunie \"{name}\" oraz wszystkie powiązane kliknięcia, konwersje i zdarzenia postback. Tej operacji nie można cofnąć.",
  "This will permanently delete \"{name}\" and all its variants.": "To trwale usunie \"{name}\" oraz wszystkie jego warianty.",
  "This will permanently delete \"{name}\" and remove it from all campaigns.": "To trwale usunie \"{name}\" i usunie go ze wszystkich kampanii.",
  "This will permanently delete \"{name}\".": "To trwale usunie \"{name}\".",
  "This will permanently delete \"{name}\". Campaigns using this domain will fall back to the default domain.": "To trwale usunie \"{name}\". Kampanie korzystające z tej domeny przełączą się na domenę domyślną.",
  "This will permanently delete \"{name}\". Campaigns using this source will lose their tracking parameters.": "To trwale usunie \"{name}\". Kampanie korzystające z tego źródła ruchu stracą swoje parametry trackingowe.",
  "This will permanently delete pool \"{name}\".": "To trwale usunie pulę \"{name}\".",
  "This will permanently delete rule \"{name}\".": "To trwale usunie regułę \"{name}\".",
  "This will permanently delete stream \"{name}\".": "To trwale usunie stream \"{name}\".",
  "This will permanently delete this ad account connection. Cost syncing will stop.": "To trwale usunie to połączenie z kontem reklamowym. Synchronizacja kosztów zostanie zatrzymana.",
  "This will permanently delete this conversion forwarder.": "To trwale usunie ten forwarder konwersji.",
  "This will permanently delete webhook \"{name}\". Events will no longer be forwarded.": "To trwale usunie webhook \"{name}\". Zdarzenia przestaną być przekazywane.",
  "This will permanently revoke this API key. Any integrations using it will stop working.": "To trwale cofnie ten klucz API. Wszystkie integracje, które go używają, przestaną działać.",
  "This will reset all branding settings to defaults. Logo, colors, and custom domain will be removed.": "To zresetuje wszystkie ustawienia brandingu do wartości domyślnych. Logo, kolory i niestandardowa domena zostaną usunięte.",
  "This will reset two-factor authentication for this member. They will need to re-enrol.": "To zresetuje uwierzytelnianie dwuskładnikowe dla tego członka. Będzie musiał skonfigurować je ponownie.",
  "Title": "Tytuł",
  "Title, body, and button labels shown to the visitor.": "Tytuł, treść i etykiety przycisków wyświetlane odwiedzającemu.",
  "To (ISO-8601)": "Do (ISO-8601)",
  "Toggle navigation": "Przełącz nawigację",
  "Tokyo (UTC+9)": "Tokio (UTC+9)",
  "Too many requests — please retry in a moment.": "Zbyt wiele żądań — spróbuj ponownie za chwilę.",
  "Track click usage and switch plans. Billing renews monthly.": "Śledź wykorzystanie kliknięć i zmieniaj plany. Rozliczenia odnawiają się co miesiąc.",
  "Tracking domain": "Domena trackingowa",
  "Tracking link copied to clipboard": "Link trackingowy skopiowany do schowka",
  "Tune the bandit before running a preview. Apply only writes weights to active streams.": "Dostrój bandytę przed uruchomieniem podglądu. Zastosuj zapisuje wagi tylko w aktywnych streamach.",
  "Two-factor authentication": "Uwierzytelnianie dwuskładnikowe",
  "Two-factor code": "Kod dwuskładnikowy",
  "Type": "Typ",
  "Type a command or search…": "Wpisz komendę lub szukaj…",
  "Ungrouped": "Bez grupy",
  "Unlimited": "Bez limitu",
  "Upload a landing-page bundle (.zip) or pick a hosted pre-landing template from the library.": "Prześlij paczkę landing page (.zip) albo wybierz hostowany szablon prelandera z biblioteki.",
  "Upload, organize and reuse landing pages across your campaigns.": "Przesyłaj, porządkuj i wykorzystuj landing page w swoich kampaniach.",
  "Uses the seed list (Python requests, Go net/http, curl, headless Chrome) plus your workspace overrides.": "Używa listy bazowej (Python requests, Go net/http, curl, headless Chrome) plus Twoich ustawień dla workspace'u.",
  "Vendor list": "Lista dostawców",
  "Vendor name (e.g. Google Analytics)": "Nazwa dostawcy (np. Google Analytics)",
  "Verify now": "Zweryfikuj teraz",
  "Verifying…": "Weryfikacja…",
  "View": "Podgląd",
  "Views": "Wyświetlenia",
  "Visible metrics": "Widoczne metryki",
  "Visitor": "Odwiedzający",
  "Visual identity": "Identyfikacja wizualna",
  "Weight floor (%)": "Minimalna waga (%)",
  "Weighted": "Ważone",
  "Welcome to ACME Tracker — sign in to continue": "Witaj w ACME Tracker — zaloguj się, aby kontynuować",
  "When disabled, the public widget responds with required:false so landing pages skip rendering entirely.": "Gdy wyłączone, publiczny widget zwraca required:false, więc landing page całkowicie pomija renderowanie.",
  "When set, the tracker auto-appends ?<param>=<click_id> to redirect URLs. Leave empty to disable. Use {click_id} in the target URL for full control.": "Gdy ustawione, tracker automatycznie dodaje ?<param>=<click_id> do URL-i przekierowań. Zostaw puste, aby wyłączyć. Użyj {click_id} w URL docelowym, żeby mieć pełną kontrolę.",
  "Workflows": "Przepływy pracy",
  "Workspace default domain": "Domyślna domena workspace'u",
  "Your tracking link": "Twój link trackingowy",
  "clear tag": "usuń tag",
  "clicks": "kliknięcia",
  "connections": "połączenia",
  "domains": "domeny",
  "e.g. 185.45.12.1, 91.108.0.0": "np. 185.45.12.1, 91.108.0.0",
  "e.g. Facebook, Google, Tier 1": "np. Facebook, Google, Tier 1",
  "e.g. MaxBounty CPA": "np. MaxBounty CPA",
  "e.g. adcombo, cpa, status": "np. adcombo, cpa, status",
  "group.<key>": "group.<key>",
  "installs": "instalacje",
  "live": "na żywo",
  "logo": "logo",
  "max change": "maks. zmiana",
  "no": "nie",
  "or continue with": "albo kontynuuj z",
  "revoked": "odwołane",
  "rows": "wiersze",
  "to close": "aby zamknąć",
  "to navigate": "aby nawigować",
  "to select": "aby wybrać",
  "weight units": "jednostki wagi",
  "yes": "tak",
  "{count} conversions": "{count} konwersji",
  "{key} breakdown": "Podział wg {key}",
  "{n} selected": "wybrano: {n}",
  "Δ": "Δ",
  "Sub-ID reports": "Raporty sub ID",
  "Ad accounts": "Konta reklamowe",
  "API docs": "Dokumentacja API",
  "Drill-down by sub1–sub15: clicks, conversions, CR": "Szczegóły wg sub1–sub15: kliknięcia, konwersje, CR",
  "Side-by-side metrics for multiple campaigns": "Metryki kilku kampanii obok siebie",
  "Step-by-step user guide for every feature": "Instrukcja krok po kroku dla każdej funkcji",
  "Switch to dark theme": "Przełącz na ciemny motyw",
  "Switch to light theme": "Przełącz na jasny motyw",
  "Page not found": "Strona nie znaleziona",
  "The page you are looking for does not exist or has been moved.": "Strona, której szukasz, nie istnieje albo została przeniesiona.",
  "Access denied": "Brak dostępu",
  "You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.": "Nie masz uprawnień, by zobaczyć tę stronę. Skontaktuj się z administratorem workspace'u, jeśli uważasz, że to pomyłka.",
  "Server error": "Błąd serwera",
  "Something went wrong on our end. Please try again later or contact support.": "Coś poszło nie tak po naszej stronie. Spróbuj ponownie później albo skontaktuj się z pomocą techniczną.",
  "View campaigns": "Zobacz kampanie",
  "List and open campaigns and their stats.": "Wyświetlaj listę kampanii i otwieraj ich statystyki.",
  "Create campaigns": "Twórz kampanie",
  "Add new campaigns and their default streams.": "Dodawaj nowe kampanie i ich domyślne streamy.",
  "Edit campaigns": "Edytuj kampanie",
  "Change campaign settings, target URL, status.": "Zmieniaj ustawienia kampanii, URL docelowy i status.",
  "Permanently remove a campaign and its history.": "Trwale usuwa kampanię i jej historię.",
  "View landings": "Zobacz landing page",
  "Browse the landing-page library.": "Przeglądaj bibliotekę landing page’y.",
  "Edit landings": "Edytuj landingi",
  "Upload, edit, and delete landings.": "Dodawaj, edytuj i usuwaj landingi.",
  "View offers": "Zobacz oferty",
  "Browse the offer library.": "Przeglądaj bibliotekę ofert.",
  "Edit offers": "Edytuj oferty",
  "Create, edit, and delete offers.": "Twórz, edytuj i usuwaj oferty.",
  "View anti-fraud": "Zobacz antyfraud",
  "Read filter list, blocked samples, audit feed.": "Przeglądaj listę filtrów, zablokowane próbki i log audytu.",
  "Edit anti-fraud filters": "Edytuj filtry antyfraud",
  "Create / update / delete fraud filters and IP lists.": "Twórz / aktualizuj / usuwaj filtry fraudowe i listy IP.",
  "Manage TLS fingerprint overrides": "Zarządzaj nadpisaniami fingerprintu TLS",
  "Pin JA3 / JA4 hashes per-workspace (overrides the seed list).": "Przypisz hashe JA3 / JA4 dla danego workspace’a (nadpisuje listę bazową).",
  "View reports": "Zobacz raporty",
  "Open the analytics dashboard and saved reports.": "Otwórz panel analityczny i zapisane raporty.",
  "Export reports": "Eksportuj raporty",
  "Download CSV / JSON report exports.": "Pobieraj eksporty raportów w CSV / JSON.",
  "View automation rules": "Zobacz reguły automatyzacji",
  "Read the rules engine and execution history.": "Przeglądaj silnik reguł i historię wykonań.",
  "Edit automation rules": "Edytuj reguły automatyzacji",
  "Create / update / delete automation rules.": "Twórz / aktualizuj / usuwaj reguły automatyzacji.",
  "View integrations": "Zobacz integracje",
  "Browse integration configurations.": "Przeglądaj konfiguracje integracji.",
  "Edit integrations": "Edytuj integracje",
  "Connect / disconnect ad accounts and webhooks.": "Łącz / odłączaj konta reklamowe i webhooki.",
  "View postbacks": "Zobacz postbacki",
  "Browse postbacks and the CAPI dead-letter queue.": "Przeglądaj postbacki i kolejkę dead-letter CAPI.",
  "Edit postbacks": "Edytuj postbacki",
  "Configure postbacks, replay / discard CAPI DLQ entries.": "Konfiguruj postbacki, ponawiaj / odrzucaj wpisy z DLQ CAPI.",
  "Invite members": "Zapraszaj członków",
  "Send invite links to new teammates.": "Wysyłaj linki zaproszeń do nowych członków zespołu.",
  "Change member role": "Zmień rolę członka",
  "Promote / demote existing members.": "Awansuj / degraduj istniejących członków.",
  "Remove members": "Usuwaj członków",
  "Revoke a teammate's access.": "Odbierz dostęp członkowi zespołu.",
  "Edit workspace settings": "Edytuj ustawienia workspace’a",
  "Change workspace currency, timezone, branding.": "Zmień walutę, strefę czasową i branding workspace’a.",
  "Edit permission matrix": "Edytuj macierz uprawnień",
  "Override the default permission matrix for this workspace.": "Nadpisz domyślną macierz uprawnień dla tego workspace’a.",
  "View billing": "Zobacz rozliczenia",
  "See plan, invoices, payment method.": "Sprawdź plan, faktury i metodę płatności.",
  "Change plan, update payment method.": "Zmień plan, zaktualizuj metodę płatności.",
  "View audit log": "Zobacz log audytu",
  "Read the workspace audit feed.": "Przeglądaj log audytu workspace’a.",
  "View tracking domains": "Zobacz domeny trackingowe",
  "Browse the tracking-domain list.": "Przeglądaj listę domen trackingowych.",
  "Edit tracking domains": "Edytuj domeny trackingowe",
  "Add / remove tracking domains.": "Dodawaj / usuwaj domeny trackingowe.",
  "View API keys": "Zobacz klucze API",
  "List existing API keys (does not reveal the secret).": "Lista istniejących kluczy API (nie pokazuje sekretu).",
  "Manage API keys": "Zarządzaj kluczami API",
  "Create / revoke API keys.": "Twórz / unieważniaj klucze API.",
  "Cloaking — send bots to a safe page": "Cloaking — wysyłaj boty na bezpieczną stronę",
  "Self-hosted cloaking. Bots, ad-network moderators, datacenter/proxy IPs and search crawlers see the safe (white) page; genuine humans go to the real offer. Classification uses the tracker's own bot / IP / crawler-DNS checks — no third-party service.": "Cloaking we własnym zakresie. Boty, moderatorzy sieci afiliacyjnych, IP z datacenter/proxy oraz crawlery wyszukiwarek widzą bezpieczną (white) stronę; prawdziwi ludzie trafiają na realną ofertę. Klasyfikacja opiera się na własnych mechanizmach trackera — sprawdzaniu botów / IP / DNS crawlerów — bez usług zewnętrznych.",
  "Safe page URL": "URL bezpiecznej strony",
  "The compliant page shown to bots/crawlers. Must be an absolute http(s) URL. In SEO mode this is the page verified search crawlers index.": "Zgodna strona pokazywana botom/crawlerom. Musi być absolutnym adresem URL http(s). W trybie SEO to strona indeksowana przez zweryfikowane crawlery wyszukiwarek.",
  "Bots & spoofed crawlers": "Boty i podszywające się crawlery",
  "Verified search crawlers": "Zweryfikowane crawlery wyszukiwarek",
  "Datacenter / Tor IPs": "IP datacenter / Tor",
  "Proxy / VPN IPs": "IP proxy / VPN",
  "Enter a valid http(s) Safe page URL for cloaking": "Podaj poprawny adres URL http(s) Safe page do cloakingu",
  "Cloaked": "Cloakowane",
  "All traffic": "Cały ruch",
  "Cloaked only": "Tylko cloakowane",
  "Real only": "Tylko prawdziwe",
  "Cloaking": "Cloaking",
  "Bots and crawlers sent to the safe page vs humans to the offer": "Boty i crawlery kierowane na safe page vs ludzie na ofertę",
  "last {n} days": "ostatnie {n} dni",
  "Cloaked → safe page": "Cloakowane → safe page",
  "Real → offer": "Prawdziwe → oferta",
  "Cloak rate": "Wskaźnik cloakingu",
  "Spoofed crawlers": "Podszywające się crawlery",
  "Verified crawlers": "Zweryfikowane crawlery",
  "Datacenter / Tor": "Datacenter / Tor",
  "SEO split (crawlers → index, humans → funnel)": "Split SEO (crawlery → indeks, ludzie → funnel)",
  "SEO crawler split on: verified crawlers index the page, humans go to the funnel": "Split SEO crawlerów włączony: zweryfikowane crawlery indeksują stronę, ludzie trafiają do funnela",
  "SEO crawler split off": "Split SEO crawlerów wyłączony",
  "When on, DNS-verified search crawlers get the index page (for ranking) and humans are sent to the bound campaign funnel. Needs an index page + a campaign bound to this domain.": "Gdy włączone, zweryfikowane przez DNS crawlery wyszukiwarek dostają stronę indeksową (do rankingu), a ludzie są kierowani do funnela powiązanej kampanii. Wymaga strony indeksowej + kampanii powiązanej z tą domeną.",
  "Fallback robots/sitemap": "Fallback robots/sitemap",
  "Serve a generated robots.txt / sitemap.xml at the domain root ONLY when your uploaded bundle has none. Your own SEO files always take priority.": "Serwuj wygenerowany robots.txt / sitemap.xml w katalogu głównym domeny TYLKO gdy twój przesłany pakiet żadnego nie zawiera. Twoje własne pliki SEO zawsze mają priorytet.",
  "Fallback robots.txt/sitemap.xml on (only when your bundle has none)": "Fallback robots.txt/sitemap.xml włączony (tylko gdy twój pakiet żadnego nie zawiera)",
  "Fallback robots.txt/sitemap.xml off": "Fallback robots.txt/sitemap.xml wyłączony",
  "Root: stable index": "Root: stabilny indeks",
  "Root: SEO split": "Root: split SEO",
  "Root: funnel": "Root: funnel",
  "Root: 404": "Root: 404",
  "own": "własny",
  "fallback": "fallback",
  "none": "brak",
  "indexable": "indeksowalny",
  "no-index": "no-index",
  "Registration": "Rejestracja",
  "Deposit": "Depozyt",
  "Trash": "Kosz",
  "Hide": "Ukryj",
  "Show": "Pokaż",
  "Import from source": "Importuj ze źródła",
  "Postback token": "Token postbacku",
  "Require postback token": "Wymagaj tokenu postbacku",
  "Network macros": "Makra sieci",
  "FTD · Deposit (sale)": "FTD · Depozyt (sprzedaż)",
  "Chargeback (reject)": "Chargeback (odrzucenie)",
  "This campaign has no source with parameters": "Ta kampania nie ma źródła z parametrami",
  "Macros imported from the source — click Save": "Makra zaimportowane ze źródła — kliknij Zapisz",
  "Save the campaign once to generate the token.": "Zapisz kampanię raz, aby wygenerować token.",
  "When ON, incoming postbacks must carry this campaign's token, otherwise they are rejected (401). Turn OFF if the network (e.g. TrackBox) sends ONE shared postback for all campaigns: remove &token=… from this URL and conversions are matched by click_id.": "Gdy WŁĄCZONE, przychodzące postbacki muszą zawierać token tej kampanii, inaczej są odrzucane (401). Wyłącz, jeśli sieć (np. TrackBox) wysyła JEDEN wspólny postback dla wszystkich kampanii: usuń &token=… z tego URL, a konwersje będą dopasowywane po click_id.",
  "Token check disabled — postbacks are accepted by click_id without a token (remove &token=… from the URL in your network).": "Sprawdzanie tokenu wyłączone — postbacki są akceptowane po click_id bez tokenu (usuń &token=… z URL w swojej sieci).",
  "TrackBox: pass your click_id in the offer link's Affclickid parameter so {affclickid} comes back to this campaign. Method GET.": "TrackBox: przekaż swój click_id w parametrze Affclickid linku oferty, żeby {affclickid} wracał do tej kampanii. Metoda GET.",
  "Generic: pass your click_id in the offer link so it comes back to this campaign as {click_id}. Method GET.": "Generic: przekaż swój click_id w linku oferty, żeby wracał do tej kampanii jako {click_id}. Metoda GET.",
  "Subid: pass your click_id in the offer link's subid parameter so {subid} comes back to this campaign. Method GET.": "Subid: przekaż swój click_id w parametrze subid linku oferty, żeby {subid} wracał do tej kampanii. Metoda GET.",
  "Enter the bot token and chat_id — Lead and Deposit postbacks with a ready-made message (Campaign, Sub1..4, Source, Payout) will be added. Then press Save.": "Wpisz token bota i chat_id — zostaną dodane postbacki Lead i Deposit z gotową wiadomością (Kampania, Sub1..4, Źródło, Payout). Potem kliknij Zapisz.",
  "What is XPNSR Tracker": "Czym jest XPNSR Tracker",
  "Links & aliases": "Linki i aliasy",
  "Postbacks": "Postbacki",
  "Macros": "Makra",
  "Redirect modes": "Tryby przekierowania",
  "A/B tests": "Testy A/B",
  "Glossary": "Słowniczek",
  "Partners & lead forms": "Partnerzy i formularze leadów",
  "Google Ads & conversions": "Google Ads i konwersje",
  "Reports (Report Builder)": "Raporty (Report Builder)",
  "Failed to copy": "Nie udało się skopiować",
  "Domain opened for indexing": "Domena otwarta na indeksowanie",
  "Domain closed from indexing": "Domena zamknięta na indeksowanie",
  "Index page set": "Ustawiono stronę index",
  "Index page cleared": "Usunięto stronę index",
  "Server migration (admin only)": "Migracja serwera (tylko admin)",
  "Current server IP:": "Aktualne IP serwera:",
  "Step 1. Provision a new server": "Krok 1. Przygotuj nowy serwer",
  "Create an EC2 instance in AWS (Ubuntu, open ports 80 and 443), SSH into it and paste this entire command. It prints the new server IP at the end.": "Utwórz instancję EC2 w AWS (Ubuntu, otwarte porty 80 i 443), połącz się przez SSH i wklej całą tę komendę. Na końcu wyświetli IP nowego serwera.",
  "Step 2. Enter the new IP": "Krok 2. Wpisz nowe IP",
  "Paste the IP from Step 1 and press Save. Every client immediately gets the new IP for their A record — no restart needed.": "Wklej IP z Kroku 1 i kliknij Zapisz. Każdy klient od razu dostaje nowe IP dla swojego rekordu A — restart nie jest potrzebny.",
  "Tip: if you reassign the old Elastic IP to the new server in AWS, nothing needs to change here — nor for clients.": "Wskazówka: jeśli przypiszesz starą Elastic IP do nowego serwera w AWS, tutaj nic nie trzeba zmieniać — u klientów też nie.",
  "Open for search engines — click to close": "Otwarte dla wyszukiwarek — kliknij, żeby zamknąć",
  "Closed from search engines — click to open": "Zamknięte dla wyszukiwarek — kliknij, żeby otworzyć",
  "Indexable": "Indeksowalne",
  "No-index": "No-index",
  "Index page (SEO, served at the root with 200):": "Strona index (SEO, serwowana w katalogu głównym z kodem 200):",
  "— none (root opens the funnel) —": "— brak (katalog główny otwiera funnel) —",
  "Custom API (any CRM)": "Custom API (dowolny CRM)",
  "TrackBox account credentials (dashboard → API Testing). Set up once per account — offers will reference this partner.": "Dane logowania do konta TrackBox (dashboard → API Testing). Skonfiguruj raz dla konta — oferty będą odwoływać się do tego partnera.",
  "Username": "Nazwa użytkownika",
  "Signup path": "Ścieżka rejestracji",
  "Pull path": "Ścieżka pull",
  "Pull type": "Typ pull",
  "Auto pull-sync": "Automatyczny pull-sync",
  "Universal integration for any partner CRM. Describe its lead-registration API request — the tracker will send form data there and redirect using the link from the response.": "Uniwersalna integracja z dowolnym CRM-em partnera. Opisz jego request API do rejestracji leadów — tracker wyśle tam dane z formularza i przekieruje na link z odpowiedzi.",
  "API URL (base)": "URL API (bazowy)",
  "Body format": "Format body",
  "Headers": "Nagłówki",
  "(one \"Key: value\" per line, macros allowed)": "(jedna para \"Klucz: wartość\" w linii, makra dozwolone)",
  "Body template (JSON)": "Szablon treści (JSON)",
  "(values are macros in curly braces)": "(wartości to makra w nawiasach klamrowych)",
  "Redirect field": "Pole przekierowania",
  "Success field (optional)": "Pole sukcesu (opcjonalnie)",
  "Success value (optional)": "Wartość sukcesu (opcjonalnie)",
  "plus any form fields and offer parameters. The redirect field is a path in the JSON response (e.g. data.url); if empty, the first http(s) link found in the response is used.": "plus dowolne pola formularza i parametry oferty. Pole przekierowania to ścieżka w odpowiedzi JSON (np. data.url); jeśli puste, użyty zostanie pierwszy znaleziony link http(s) w odpowiedzi.",
  "Set up a partner/CRM here once, then offers reference it. TrackBox / Tigloo is the ready-made adapter; Custom API fits any other CRM. Leads from offer forms are sent to the selected partner.": "Skonfiguruj tu partnera/CRM raz, a oferty będą się do niego odwoływać. TrackBox / Tigloo to gotowy adapter; Custom API pasuje do dowolnego innego CRM-u. Leady z formularzy ofert trafiają do wybranego partnera.",
  "Affiliate routing (form offers)": "Routing do partnerów (oferty z formularzem)",
  "Route this offer to one or more partners with weights (split/rotation). Inactive partners are skipped (e.g. until terms are agreed). The lead goes by weight; on rejection it falls back to the next partner.": "Kieruj tę ofertę do jednego lub wielu partnerów z wagami (split/rotacja). Nieaktywni partnerzy są pomijani (np. do czasu ustalenia warunków). Lead trafia zgodnie z wagą; w razie odrzucenia przechodzi do kolejnego partnera.",
  "Telegram lead alerts": "Powiadomienia o leadach na Telegramie",
  "(sent on EVERY submit — even test/error)": "(wysyłane przy KAŻDYM submicie — nawet testowym/błędnym)",
  "Every lead captured by your form offers lands here — accepted, rejected and test. Filter, export to CSV and resell. Statuses are updated by postbacks and pull sync.": "Każdy lead zebrany przez oferty z formularzem trafia tutaj — zaakceptowane, odrzucone i testowe. Filtruj, eksportuj do CSV i odsprzedawaj. Statusy aktualizowane są przez postbacki i synchronizację pull.",
  "Hint": "Podpowiedź",
  "Cycle language": "Zmień język",
  "Switch to {lang}": "Przełącz na {lang}",
  "Current language: {lang}": "Obecny język: {lang}",
  "Scroll to top": "Przewiń do góry",
  "Something went wrong": "Coś poszło nie tak",
  "An unexpected error occurred.": "Wystąpił nieoczekiwany błąd.",
  "Reload page": "Odśwież stronę",
  "My first campaign": "Moja pierwsza kampania",
  "CPA Network": "Sieć CPA",
  "Main FB pixel": "Główny piksel FB",
  "zapier integration": "integracja z zapier",
  "Bot token": "Token bota",
  "Chat ID": "ID czatu",
  "(no match)": "(brak dopasowania)",
  "+ Upload": "+ Prześlij",
  "A custom conversion type with its own reporting rules and status transitions.": "Niestandardowy typ konwersji z własnymi regułami raportowania i przejściami statusów.",
  "A formula over base metrics rendered as a report column.": "Formuła oparta na metrykach bazowych, wyświetlana jako kolumna raportu.",
  "A/B testing": "Testy A/B",
  "Add a manual cost, or connect an ad account to sync spend automatically.": "Dodaj koszt ręcznie albo połącz konto reklamowe, żeby synchronizować wydatki automatycznie.",
  "Add cost": "Dodaj koszt",
  "Add from preset": "Dodaj z presetu",
  "Add manual cost": "Dodaj koszt ręczny",
  "Add partner route": "Dodaj trasę partnera",
  "Add range": "Dodaj zakres",
  "Add value": "Dodaj wartość",
  "Added to blacklist": "Dodano do czarnej listy",
  "Added to whitelist": "Dodano do białej listy",
  "Adjust the period or campaign filter.": "Dostosuj okres lub filtr kampanii.",
  "Affiliate CRM — push leads via API": "CRM afiliacyjny — wysyłka leadów przez API",
  "Affiliate network postback": "Postback sieci afiliacyjnej",
  "All offers": "Wszystkie oferty",
  "All rows": "Wszystkie wiersze",
  "Allowed next statuses": "Dozwolone kolejne statusy",
  "Amount": "Kwota",
  "Any date": "Dowolna data",
  "Any status": "Dowolny status",
  "Arithmetic over base metrics. Supported: + - * / ( ) and numbers.": "Działania arytmetyczne na metrykach bazowych. Obsługiwane: + - * / ( ) oraz liczby.",
  "Back to streams": "Wróć do streamów",
  "Base metrics": "Metryki bazowe",
  "Bind your own domain to mask tracking links. Point an A record to your tracking server and verify ownership via TXT record.": "Podepnij własną domenę, by zamaskować linki trackingowe. Skieruj rekord A na swój serwer trackingowy i zweryfikuj własność za pomocą rekordu TXT.",
  "Black": "Czarny",
  "Black / white lists": "Czarne / białe listy",
  "Blacklist": "Czarna lista",
  "Blacklisted": "Na czarnej liście",
  "Blank referrer (JS)": "Puste referrer (JS)",
  "Book spend against a campaign. It is folded into the campaign cost used by ROI and dashboards.": "Zaksięguj wydatek na kampanię. Jest wliczany do kosztu kampanii używanego przez ROI i panele.",
  "Bot": "Bot",
  "Bot IP addresses": "Adresy IP botów",
  "Bot User-Agent signatures": "Sygnatury User-Agent botów",
  "Bot lists": "Listy botów",
  "Bot lists saved": "Listy botów zapisane",
  "Breakdown": "Podział",
  "Bucket": "Bucket",
  "Built-in statuses": "Wbudowane statusy",
  "By destination": "Wg miejsca docelowego",
  "By stream": "Wg streamu",
  "CPS (per sale)": "CPS (za sprzedaż)",
  "CPuC (per unique click)": "CPuC (za unikalne kliknięcie)",
  "CRM": "CRM",
  "CRM response": "Odpowiedź CRM",
  "Cadence": "Częstotliwość",
  "Calendar dates when the stream is active (owner timezone). Leave start or end empty for an open-ended side. 'Is not' inverts the range.": "Daty kalendarzowe, w których stream jest aktywny (strefa czasowa właściciela). Zostaw start lub koniec puste dla otwartego zakresu. 'Nie jest' odwraca zakres.",
  "California, Bavaria, Moscow Oblast": "Kalifornia, Bawaria, Obwód moskiewski",
  "Canonical status stored on each conversion. Auto-generated from the name if left blank.": "Kanoniczny status zapisywany przy każdej konwersji. Generowany automatycznie z nazwy, jeśli zostawisz puste.",
  "Click API (server-to-server)": "Click API (server-to-server)",
  "Code (slug)": "Kod (slug)",
  "Column key in reports. Auto-generated from the name if left blank.": "Klucz kolumny w raportach. Generowany automatycznie z nazwy, jeśli zostawisz puste.",
  "Comma-separated email addresses.": "Adresy e-mail oddzielone przecinkami.",
  "Compensates cost for traffic lost between the source and the tracker: real cost = base / (1 − loss%/100).": "Kompensuje koszt za ruch utracony między źródłem a trackerem: koszt rzeczywisty = baza / (1 − strata%/100).",
  "Configure any partner CRM lead API": "Skonfiguruj API leadów dowolnego CRM partnera",
  "Conversion date": "Data konwersji",
  "Conversion statuses": "Statusy konwersji",
  "Conversion type created": "Typ konwersji utworzony",
  "Conversion type deleted": "Typ konwersji usunięty",
  "Conversion type updated": "Typ konwersji zaktualizowany",
  "Conversion types": "Typy konwersji",
  "Cookie (default)": "Cookie (domyślne)",
  "Copy blacklist": "Kopiuj czarną listę",
  "Copy list": "Kopiuj listę",
  "Copy whitelist": "Kopiuj białą listę",
  "Cost entries": "Wpisy kosztów",
  "Cost entry added": "Wpis kosztu dodany",
  "Cost entry deleted": "Wpis kosztu usunięty",
  "Count conversions of this type toward the offer daily cap.": "Wliczaj konwersje tego typu do dziennego capu oferty.",
  "Counts against offer cap": "Liczy się do capu oferty",
  "Counts in conversions": "Liczy się w konwersjach",
  "Counts in revenue": "Liczy się w przychodach",
  "Counts vs cap": "Licznik vs cap",
  "Create conversion type": "Utwórz typ konwersji",
  "Create custom metric": "Utwórz metrykę niestandardową",
  "Create metric": "Utwórz metrykę",
  "Create one like uCR = conversions / unique_clicks * 100.": "Utwórz taką jak uCR = conversions / unique_clicks * 100.",
  "Create one to export campaign performance on demand.": "Utwórz jeden, by eksportować wyniki kampanii na żądanie.",
  "Create one to map partner statuses like FTD or second deposit.": "Utwórz jeden, by mapować statusy partnera, takie jak FTD czy drugi depozyt.",
  "Create one to receive recurring reports by email.": "Utwórz jeden, by otrzymywać cykliczne raporty na e-mail.",
  "Create type": "Utwórz typ",
  "Custom bot IPs/CIDRs and UA signatures for the bot-detection filter": "Niestandardowe IP/CIDR botów i sygnatury UA dla filtra wykrywania botów",
  "Custom bot IPs/CIDRs and User-Agent signatures used by the bot-detection fraud filter.": "Niestandardowe IP/CIDR botów i sygnatury User-Agent używane przez filtr antyfraudowy wykrywania botów.",
  "Custom conversion types: map network statuses, reporting flags and transition rules": "Niestandardowe typy konwersji: mapuj statusy sieci, flagi raportowania i reguły przejść",
  "Custom metric created": "Utworzono niestandardową metrykę",
  "Custom metric deleted": "Usunięto niestandardową metrykę",
  "Custom metric updated": "Zaktualizowano niestandardową metrykę",
  "Custom metrics": "Niestandardowe metryki",
  "DSAR erasure completed": "Usunięcie danych DSAR zakończone",
  "DSAR export ready": "Eksport DSAR gotowy",
  "Daily": "Codziennie",
  "Data subject": "Osoba, której dane dotyczą",
  "Data-subject access (Article 15) and erasure (Article 17) by identifier.": "Dostęp do danych osoby (Artykuł 15) i ich usunięcie (Artykuł 17) według identyfikatora.",
  "Data-subject export (Art. 15) and erasure (Art. 17) by identifier": "Eksport danych osoby (Art. 15) i ich usunięcie (Art. 17) według identyfikatora",
  "Date": "Data",
  "Date range": "Zakres dat",
  "Day": "Dzień",
  "Day of month (1-31)": "Dzień miesiąca (1–31)",
  "Day of week": "Dzień tygodnia",
  "Decimals": "Miejsca dziesiętne",
  "Define a reusable report and its grouping/metrics.": "Zdefiniuj wielokrotnego użytku reporto i jego grupowanie/metryki.",
  "Define custom conversion types, map network statuses and control reporting semantics.": "Definiuj niestandardowe typy konwersji, mapuj statusy sieci i kontroluj semantykę raportowania.",
  "Define formula-based report columns over base metrics (CR, EPC, ROI variants).": "Definiuj kolumny reportu oparte na formułach bazujących na metrykach podstawowych (CR, EPC, warianty ROI).",
  "Delete conversion type": "Usuń typ konwersji",
  "Delete cost entry": "Usuń wpis kosztu",
  "Delete custom metric": "Usuń niestandardową metrykę",
  "Delete file": "Usuń plik",
  "Delete report": "Usuń reporto",
  "Delete schedule": "Usuń harmonogram",
  "Delete this file?": "Usunąć ten plik?",
  "Desktop, Mobile, Tablet": "Desktop, Mobile, Tablet",
  "Destination": "Cel",
  "Distribution": "Dystrybucja",
  "Double meta (hide referrer)": "Podwójna meta (ukryj referrer)",
  "Dry-run clicks through this campaign to test flow logic and filters — no real traffic is recorded.": "Wykonaj testowe kliknięcia przez tę kampanię, by sprawdzić logikę flow i filtry — żaden prawdziwy ruch nie zostanie zapisany.",
  "EPC (sensitive)": "EPC (wrażliwe)",
  "Edge server updated": "Zaktualizowano serwer edge",
  "Edit conversion type": "Edytuj typ konwersji",
  "Edit custom metric": "Edytuj niestandardową metrykę",
  "Enter a valid amount": "Wpisz prawidłową kwotę",
  "Enter at least one identifier": "Wpisz przynajmniej jeden identyfikator",
  "Enter bot token and chat id": "Wpisz token bota i chat id",
  "Enter the text to find": "Wpisz tekst do wyszukania",
  "Equalize weights": "Wyrównaj wagi",
  "Erase": "Usuń",
  "Erase data": "Usuń dane",
  "Erase subject data?": "Usunąć dane osoby?",
  "Erased": "Usunięto",
  "Erasure is a hard delete and cannot be undone. It requires an admin role.": "Usunięcie jest trwałe i nie da się go cofnąć. Wymaga roli administratora.",
  "Error creating conversion type": "Błąd podczas tworzenia typu konwersji",
  "Error creating cost entry": "Błąd podczas tworzenia wpisu kosztu",
  "Error creating custom metric": "Błąd podczas tworzenia niestandardowej metryki",
  "Error creating report": "Błąd podczas tworzenia reporto",
  "Error creating schedule": "Błąd podczas tworzenia harmonogramu",
  "Error deleting conversion type": "Błąd podczas usuwania typu konwersji",
  "Error deleting cost entry": "Błąd podczas usuwania wpisu kosztu",
  "Error deleting custom metric": "Błąd podczas usuwania niestandardowej metryki",
  "Error deleting file": "Błąd podczas usuwania pliku",
  "Error deleting report": "Błąd podczas usuwania reporto",
  "Error deleting schedule": "Błąd podczas usuwania harmonogramu",
  "Error loading bot lists": "Błąd podczas ładowania list botów",
  "Error loading conversion types": "Błąd podczas ładowania typów konwersji",
  "Error loading cost entries": "Błąd podczas ładowania wpisów kosztów",
  "Error loading custom metrics": "Błąd podczas ładowania niestandardowych metryk",
  "Error loading reports": "Błąd podczas ładowania reportów",
  "Error loading scheduled reports": "Błąd podczas ładowania zaplanowanych reportów",
  "Error saving bot lists": "Błąd podczas zapisywania list botów",
  "Error updating conversion type": "Błąd podczas aktualizacji typu konwersji",
  "Error updating custom metric": "Błąd podczas aktualizacji niestandardowej metryki",
  "Error uploading file": "Błąd podczas przesyłania pliku",
  "Every submitted lead is stored here: filter, export (CSV) and resell": "Każdy przesłany lead zapisuje się tutaj: filtruj, eksportuj (CSV) i odsprzedawaj",
  "Export data": "Eksportuj dane",
  "Export flows": "Eksportuj flow",
  "Exported": "Wyeksportowano",
  "Failed to clone stream": "Nie udało się sklonować streamu",
  "Failed to equalize weights": "Nie udało się wyrównać wag",
  "Failed to erase DSAR": "Nie udało się usunąć DSAR",
  "Failed to export DSAR": "Nie udało się wyeksportować DSAR",
  "Failed to export flows": "Nie udało się wyeksportować flow",
  "Failed to export list": "Nie udało się wyeksportować listy",
  "Failed to export report": "Nie udało się uruchomić raportu",
  "Failed to import flows": "Nie udało się zaimportować flow",
  "Failed to insert flow": "Nie udało się wstawić flow",
  "Failed to load leads": "Nie udało się wczytać leadów",
  "Failed to remove": "Nie udało się usunąć",
  "Failed to replace URLs": "Nie udało się zamienić URL-i",
  "Failed to run report": "Nie udało się uruchomić raportu",
  "Failed to update": "Nie udało się zaktualizować",
  "Failed to update list": "Nie udało się zaktualizować listy",
  "Failed to update schedule": "Nie udało się zaktualizować harmonogramu",
  "Favourite": "Ulubione",
  "Favourite flows": "Ulubione flow",
  "Favourites": "Ulubione",
  "Fetched": "Pobrano",
  "File deleted": "Plik usunięty",
  "File uploaded": "Plik przesłany",
  "Filter rule": "Reguła filtra",
  "Find": "Szukaj",
  "Find and replace a substring in flow redirect URLs (never landing/offer URLs).": "Znajdź i zamień podciąg w URL-ach przekierowań flow (nigdy w URL-ach landing page/oferty).",
  "Fire on statuses": "Wyzwalaj przy statusach",
  "First 25 simulated clicks and how each was routed.": "Pierwsze 25 symulowanych kliknięć i sposób ich routingu.",
  "Flag clicks that arrive with no User-Agent header.": "Oznaczaj kliknięcia, które przychodzą bez nagłówka User-Agent.",
  "Flow tools": "Narzędzia flow",
  "Form submit (POST)": "Wysłanie formularza (POST)",
  "Format": "Format",
  "Formula": "Formuła",
  "Formula is required": "Formuła jest wymagana",
  "Formula-based report columns over base metrics (CR, EPC, ROI variants)": "Kolumny raportu oparte na formułach wykorzystujących podstawowe metryki (CR, EPC, warianty ROI)",
  "Friday": "Piątek",
  "From": "Od",
  "GDPR / DSAR": "GDPR / DSAR",
  "Group by": "Grupuj według",
  "Has label": "Ma etykietę",
  "Headless click registration and the JS adapter for landing pages.": "Rejestracja kliknięć headless i adapter JS dla landing page'y.",
  "Hour": "Godzina",
  "Hour (0-23)": "Godzina (0-23)",
  "How returning visitors are identified for unique-click detection: Cookie (default), IP, IP+UA, or Parameter — identify by a GET parameter (e.g. external_id) so the same user is recognised across IP/cookie changes.": "Jak identyfikowani są powracający użytkownicy do wykrywania unikalnych kliknięć: Cookie (domyślnie), IP, IP+UA lub Parametr — identyfikacja po parametrze GET (np. external_id), dzięki czemu ten sam użytkownik jest rozpoznawany mimo zmian IP/cookies.",
  "IP + User-Agent": "IP + User-Agent",
  "IP of your tracking server": "IP twojego serwera trackingowego",
  "IPs": "IP",
  "ISP / carrier": "ISP / operator",
  "Import flows": "Importuj flow",
  "Imported": "Zaimportowano",
  "In conversions": "W konwersjach",
  "In revenue": "W przychodzie",
  "Include this type in the conversions column.": "Uwzględnij ten typ w kolumnie konwersji.",
  "Include this type in the revenue column.": "Uwzględnij ten typ w kolumnie przychodu.",
  "Insert": "Wstaw",
  "Integration": "Integracja",
  "JS adapter snippet": "Fragment kodu adaptera JS",
  "Key (e.g. price)": "Klucz (np. price)",
  "Key metrics over time buckets. Toggle to attribute conversions to their arrival date.": "Kluczowe metryki w przedziałach czasowych. Przełącz, aby przypisać konwersje do daty ich wystąpienia.",
  "Keys": "Klucze",
  "Label color": "Kolor etykiety",
  "Last run": "Ostatnie uruchomienie",
  "Lead export failed": "Eksport leadów nie powiódł się",
  "Lead storage": "Przechowywanie leadów",
  "Leads": "Leady",
  "Leads exported": "Wyeksportowano leady",
  "Leave empty to count every conversion.": "Zostaw puste, aby liczyć każdą konwersję.",
  "Leave the period blank to record spend as of now.": "Zostaw okres pusty, aby zapisać wydatek od teraz.",
  "Lists": "Listy",
  "Manager": "Manager",
  "Manual": "Ręcznie",
  "Manually record campaign spend the ad-account sync can’t see — flat fees, offline media, corrections.": "Ręcznie rejestruj wydatki kampanii, których synchronizacja konta reklamowego nie widzi — stałe opłaty, media offline, korekty.",
  "Manually record campaign spend — flat fees, offline media, corrections": "Ręcznie zapisuj wydatki kampanii — stałe opłaty, media offline, korekty",
  "Marked values are reusable as report filters and copyable for ad networks.": "Oznaczone wartości możesz ponownie wykorzystać jako filtry raportów i skopiować dla sieci reklamowych.",
  "Match the X-Requested-With header for webview / in-app browser detection. Substring match — e.g. com.android targets Android webviews; @empty targets clicks with no header.": "Dopasuj nagłówek X-Requested-With do wykrywania webview / przeglądarki in-app. Dopasowanie podciągu — np. com.android celuje w webview Androida; @empty celuje w kliknięcia bez nagłówka.",
  "Match the search engine derived from the se / se_referrer params or the referrer host — e.g. google, bing, yandex.": "Dopasuj wyszukiwarkę na podstawie parametrów se / se_referrer lub hosta referrera — np. google, bing, yandex.",
  "Match the visitor's ISP / ASN organisation name (from the offline IP-intel table). Masks, /regex/ and @empty supported — e.g. AMAZON*, *Comcast*.": "Dopasuj nazwę organizacji ISP / ASN odwiedzającego (z offline'owej tabeli IP-intel). Obsługiwane maski, /regex/ i @empty — np. AMAZON*, *Comcast*.",
  "Matched": "Dopasowano",
  "Metrics": "Metryki",
  "Metrics over time buckets (hour/day/weekday/month) + conversion-date view": "Metryki w przedziałach czasu (godzina/dzień/dzień tygodnia/miesiąc) + widok wg daty konwersji",
  "Monday": "Poniedziałek",
  "Monthly": "Miesięcznie",
  "Moscow, New York": "Moskwa, Nowy Jork",
  "Moscow, New York, London": "Moskwa, Nowy Jork, Londyn",
  "Named key/value pairs injected into landing/offer/postback URLs via the {offer_value:NAME} macro.": "Nazwane pary klucz/wartość wstrzykiwane do URL-i landing page'a/oferty/postbacku przez makro {offer_value:NAME}.",
  "Network preset…": "Preset sieci…",
  "Network status values": "Wartości statusu sieci",
  "New report": "Nowy raport",
  "New saved report": "Nowy zapisany raport",
  "New schedule": "Nowy harmonogram",
  "New scheduled report": "Nowy zaplanowany raport",
  "No cost entries yet": "Brak wpisów kosztów",
  "No custom conversion types yet": "Brak niestandardowych typów konwersji",
  "No custom metrics yet": "Brak niestandardowych metryk",
  "No data for this period": "Brak danych dla tego okresu",
  "No favourite flows yet. Star a flow to reuse it here.": "Brak ulubionych flow. Oznacz flow gwiazdką, żeby użyć go tutaj ponownie.",
  "No label": "Brak etykiety",
  "No leads yet": "Brak leadów",
  "No list entries yet. Use the thumbs buttons on report rows.": "Brak wpisów na liście. Użyj przycisków kciuka w wierszach raportu.",
  "No match": "Brak dopasowania",
  "No offer values. Add a key like price, then use {offer_value:price} in URLs.": "Brak wartości oferty. Dodaj klucz, np. price, a następnie użyj {offer_value:price} w URL-ach.",
  "No partner routes — this is a plain redirect/upload offer.": "Brak tras partnera — to zwykła oferta z przekierowaniem/uploadem.",
  "No recipients set": "Nie ustawiono odbiorców",
  "No saved reports yet": "Brak zapisanych raportów",
  "No scheduled reports yet": "Brak zaplanowanych raportów",
  "No status values added": "Nie dodano wartości statusu",
  "Not accepted": "Nie zaakceptowano",
  "Note": "Notatka",
  "Offer": "Oferta",
  "Offer values": "Wartości oferty",
  "One exact IP or CIDR block per line (e.g. 203.0.113.7 or 10.0.0.0/8).": "Jeden dokładny adres IP lub blok CIDR na linię (np. 203.0.113.7 lub 10.0.0.0/8).",
  "One per line: substring, mask (*) or /regex/.": "Jedno na linię: podciąg, maska (*) lub /regex/.",
  "One value per line (or comma-separated). Each simulated query samples one value from each list.": "Jedna wartość na linię (lub oddzielone przecinkami). Każde symulowane zapytanie losuje jedną wartość z każdej listy.",
  "Only these conversion statuses are sent to the ad platform. Default: sale.": "Tylko te statusy konwersji są wysyłane do platformy reklamowej. Domyślnie: sale.",
  "Open Domains": "Otwórz Domeny",
  "Overrides": "Overrides",
  "Owner": "Właściciel",
  "POST /v1/click with an API key (write scope). Returns the routing decision without a browser redirect.": "POST /v1/click z kluczem API (scope zapisu). Zwraca decyzję routingu bez przekierowania w przeglądarce.",
  "Parameter name, e.g. external_id": "Nazwa parametru, np. external_id",
  "Parameters": "Parametry",
  "Paste on a landing page to auto-append the click id and forward the visitor.": "Wklej na landing page, aby automatycznie dodawać click ID i przekierowywać odwiedzającego.",
  "Per-query trace": "Ślad per zapytanie",
  "Period": "Okres",
  "Period end": "Koniec okresu",
  "Period start": "Początek okresu",
  "Phone": "Telefon",
  "Pick a report, cadence and recipients.": "Wybierz raport, częstotliwość i odbiorców.",
  "Postback added from preset": "Postback dodany z presetu",
  "Postback macro": "Makro postbacku",
  "Provide at least one identifier. Matching clicks and conversions across your accessible workspaces are affected.": "Podaj co najmniej jeden identyfikator. Dotyczy to pasujących kliknięć i konwersji we wszystkich dostępnych ci workspace'ach.",
  "Pull lead statuses and deposits from TrackBox (last 7 days) and update stored leads. Set the Pull x-api-key on the integration first.": "Pobierz statusy leadów i depozyty z TrackBox (ostatnie 7 dni) i zaktualizuj zapisane leady. Najpierw ustaw Pull x-api-key w integracji.",
  "Pull lead statuses from OpenAFF for the number of days set on the integration and update stored leads. Set the status API token on the integration first.": "Pobierz statusy leadów z OpenAFF za liczbę dni ustawioną w integracji i zaktualizuj zapisane leady. Najpierw ustaw w integracji token API statusów.",
  "Pull sync": "Synchronizacja pull",
  "Pull sync (statuses/deposits)": "Synchronizacja pull (statusy/depozyty)",
  "Pull sync done": "Synchronizacja pull zakończona",
  "Queries": "Zapytania",
  "ROI %": "ROI %",
  "ROI (sensitive)": "ROI (wrażliwe)",
  "Raw status strings partner networks send that should map to this type (case-insensitive).": "Surowe ciągi statusów wysyłane przez sieci afiliacyjne, które mają być mapowane na ten typ (wielkość liter nie ma znaczenia).",
  "Raw statuses to treat as TRASH (recorded but excluded from payouts). E.g. trash, invalid.": "Surowe statusy traktowane jako TRASH (rejestrowane, ale wykluczone z wypłat). Np. trash, invalid.",
  "Raw statuses to treat as a DEPOSIT (first-class conversion type). E.g. dep, ftd, deposit.": "Surowe statusy traktowane jako DEPOSIT (podstawowy typ konwersji). Np. dep, ftd, deposit.",
  "Raw statuses to treat as a REGISTRATION (first-class conversion type). E.g. reg, signup.": "Surowe statusy traktowane jako REGISTRATION (podstawowy typ konwersji). Np. reg, signup.",
  "Read-only — only the workspace owner can edit the matrix": "Tylko do odczytu — macierz może edytować wyłącznie właściciel workspace'u",
  "Recipients": "Odbiorcy",
  "Recurring reports emailed on a daily/weekly/monthly cadence": "Cykliczne raporty wysyłane mailem codziennie/co tydzień/co miesiąc",
  "Recurring reports emailed to recipients on a daily/weekly/monthly cadence.": "Cykliczne raporty wysyłane mailem do odbiorców codziennie/co tydzień/co miesiąc.",
  "Removed": "Usunięto",
  "Replace": "Zamień",
  "Replace URL": "Zamień URL",
  "Replace with": "Zamień na",
  "Report deleted": "Raport usunięty",
  "Report queued": "Raport w kolejce",
  "Report saved": "Raport zapisany",
  "Report type": "Typ raportu",
  "Request": "Żądanie",
  "Response sample": "Przykładowa odpowiedź",
  "Reusable partner networks: postback, offer params, inbound URL": "Wielokrotnego użytku sieci afiliacyjne: postback, parametry oferty, URL przychodzący",
  "Reusable report definitions you can export to CSV or XLSX on demand.": "Wielokrotnego użytku definicje raportów, które możesz eksportować do CSV lub XLSX na żądanie.",
  "Reusable report definitions, exportable to CSV/XLSX on demand": "Wielokrotnego użytku definicje raportów, eksportowalne do CSV/XLSX na żądanie",
  "RevShare (% of payout)": "RevShare (% payoutu)",
  "Revenue (sensitive)": "Przychód (wrażliwe)",
  "Routing record (A record)": "Rekord routingu (rekord A)",
  "Run now": "Uruchom teraz",
  "Run pull sync": "Uruchom synchronizację pull",
  "Run simulation": "Uruchom symulację",
  "Runs a rolling 7-day sync. Use this to verify the response before enabling auto pull-sync.": "Uruchamia synchronizację z ostatnich 7 dni. Użyj tego, żeby zweryfikować odpowiedź przed włączeniem automatycznej synchronizacji pull.",
  "Sample datasets": "Przykładowe zestawy danych",
  "Saturday": "Sobota",
  "Saved reports": "Zapisane raporty",
  "Schedule created": "Harmonogram utworzony",
  "Schedule deleted": "Harmonogram usunięty",
  "Scheduled reports": "Zaplanowane raporty",
  "Search conversion types": "Szukaj typów konwersji",
  "Search custom metrics": "Szukaj niestandardowych metryk",
  "Search engines": "Wyszukiwarki",
  "Search presets": "Szukaj presetów",
  "Send a synthetic lead to the CRM and inspect the response. A throwaway email/phone is used unless you override below.": "Wyślij syntetyczny lead do CRM i sprawdź odpowiedź. Jeśli nie nadpiszesz poniżej, użyty zostanie jednorazowy e-mail/telefon.",
  "Send test lead": "Wyślij testowy lead",
  "Set another entry page first": "Najpierw ustaw inną stronę wejściową",
  "Show shortcuts": "Pokaż skróty",
  "Simulate": "Symuluj",
  "Simulating…": "Symulowanie…",
  "Simulation failed": "Symulacja nie powiodła się",
  "Source": "Źródło",
  "Starred flows from any campaign. Insert a copy into this campaign.": "Oznaczone gwiazdką flowy z dowolnej kampanii. Wstaw kopię do tej kampanii.",
  "Stored form leads: name/email/phone/geo/status, filter + CSV export for resale": "Zapisane leady z formularzy: imię/e-mail/telefon/GEO/status, filtr + eksport CSV do odsprzedaży",
  "Stream cloned": "Stream sklonowany",
  "Streams changed": "Streamy zmienione",
  "Streams decide which offer each visitor lands on. Configure your default stream and you'll have a working tracking link.": "Streamy decydują, na jaką ofertę trafia każdy odwiedzający. Skonfiguruj domyślny stream, a będziesz mieć działający link trackingowy.",
  "Submitted leads from your offer forms will appear here.": "Tu pojawią się leady wysłane z formularzy twoich ofert.",
  "Sunday": "Niedziela",
  "Synced": "Zsynchronizowano",
  "Telegram postbacks added — press Save to apply": "Dodano postbacki Telegram — kliknij Zapisz, aby zastosować",
  "Google Ads postbacks added — press Save to apply": "Dodano postbacki Google Ads — kliknij Zapisz, aby zastosować",
  "Google Ads preset applied — press Save to apply": "Zastosowano preset Google Ads — kliknij Zapisz, aby zastosować",
  "Also add the standard Google Ads parameters (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) as defaults": "Dodaj też standardowe parametry Google Ads (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) jako domyślne",
  "Google Ads postbacks added + click-time gtag turned off — press Save to apply": "Dodano postbacki Google Ads + wyłączono gtag w momencie kliknięcia — kliknij Zapisz, aby zastosować",
  "Adding these also turns OFF the click-time gtag (fire on redirect) for this campaign, so the same Google conversion is not counted twice.": "Dodanie tego wyłącza też gtag w momencie kliknięcia (uruchamiany przy przekierowaniu) dla tej kampanii, dzięki czemu ta sama konwersja Google nie zostanie policzona dwa razy.",
  "Tracking params (campaignid, adgroupid, keyword, tm, tml, sub1–3) are declared once on the Google Ads traffic source — use \"Import from source\" to add them to a campaign.": "Parametry trackingowe (campaignid, adgroupid, keyword, tm, tml, sub1–3) deklarujesz raz w źródle ruchu Google Ads — użyj \"Importuj ze źródła\", aby dodać je do kampanii.",
  "Google Ads conversions": "Konwersje Google Ads",
  "Outbound only: these HTTP calls notify another system after XPNSR records a conversion. Affiliate-network presets and inbound URLs belong on the Affiliate networks page and must be pasted into the partner dashboard — they are not forwarding rules.": "Tylko wychodzące: te wywołania HTTP informują inny system po zarejestrowaniu konwersji przez XPNSR. Presety sieci afiliacyjnych i adresy URL przychodzące znajdziesz na stronie Sieci afiliacyjne — trzeba je wkleić w panelu partnera, to nie są reguły przekazywania.",
  "Inbound partner setup: click-ID offer parameters, status mapping, and the postback URL to paste into the partner dashboard. This does not send leads to a CRM and is not campaign S2S forwarding.": "Konfiguracja przychodząca partnera: parametry click ID oferty, mapowanie statusów oraz URL postbacku do wklejenia w panelu partnera. To nie wysyła leadów do CRM ani nie jest przekazywaniem S2S kampanii.",
  "Inbound postback URL template": "Szablon URL postbacku przychodzącego",
  "Inbound URL for the partner network to call when it reports lead, sale, reject, or another status. Copy this into the partner dashboard; XPNSR does not call this URL as an outgoing campaign postback.": "Przychodzący URL, który sieć afiliacyjna wywołuje, zgłaszając lead, sprzedaż, odrzucenie lub inny status. Skopiuj go do panelu partnera; XPNSR nie wywołuje tego URL-a jako wychodzący postback kampanii.",
  "Pick an inbound postback preset or configure the partner contract from scratch. For form-to-CRM lead delivery, create an Integration and attach it to the offer instead.": "Wybierz gotowy szablon postbacku przychodzącego albo skonfiguruj ustalenia z partnerem od zera. Do przekazywania leadów z formularza do CRM-a utwórz zamiast tego Integrację i podepnij ją pod ofertę.",
  "Google Ads deposit postback added + click-time gtag kept off — press Save to apply": "Dodano postback depozytu Google Ads + gtag przy kliknięciu pozostaje wyłączony — kliknij Zapisz, aby zastosować",
  "Legacy click-time conversion: fires on /r/ before any registration or deposit. Keep this disabled for lead/deposit optimization. Real leads are sent automatically from hosted landings after a successful /api/lead response.": "Stara konwersja przy kliknięciu: uruchamia się na /r/ zanim dojdzie do rejestracji czy depozytu. Trzymaj ją wyłączoną przy optymalizacji pod leady/depozyty. Prawdziwe leady są wysyłane automatycznie z hostowanych landing page po poprawnej odpowiedzi /api/lead.",
  "Keep this OFF for real conversion optimization. Leads fire online from the hosted landing only after /api/lead succeeds; deposits can be forwarded below by S2S on the broker sale postback. Enabling this makes Google optimize on clicks and can double-count conversions.": "Zostaw to WYŁĄCZONE, jeśli optymalizujesz pod realne konwersje. Leady wysyłają się online z hostowanej landing page dopiero po powodzeniu /api/lead; depozyty możesz przekazywać poniżej przez S2S na postbacku sprzedaży brokera. Włączenie tego sprawi, że Google będzie optymalizować pod kliknięcia i może podwójnie liczyć konwersje.",
  "Adds only the deposit/Purchase S2S postback. It fires on the broker sale postback and matches the Google click by {gclid}. The account id and deposit label come from the per-click {tm} tag (AW-<account>/<deposit-label>) in the ad Final URL suffix.": "Dodaje tylko postback S2S dla depozytu/Purchase. Uruchamia się na postbacku sprzedaży brokera i dopasowuje kliknięcie Google po {gclid}. ID konta i etykieta depozytu pochodzą z tagu {tm} przypisanego do kliknięcia (AW-<account>/<deposit-label>) w sufiksie Final URL reklamy.",
  "Deposit → Purchase (with payout value) — fires on sale": "Depozyt → Purchase (z wartością wypłaty) — uruchamia się przy sprzedaży",
  "Lead S2S is intentionally not added: the hosted landing already sends the Lead conversion online via client-side gtag after the CRM accepts /api/lead. Adding a lead S2S rule would risk double-counting the same lead.": "S2S dla leada celowo nie jest dodawany: hostowana landing page już wysyła konwersję Lead online przez gtag po stronie klienta, gdy CRM zaakceptuje /api/lead. Dodanie reguły S2S dla leada groziłoby podwójnym policzeniem tego samego leada.",
  "For online leads, pass tml=AW-<account>/<lead-label> in each ad account Final URL suffix. Keep \"Fire Google Ads gtag on redirect\" OFF: the tracker injects a separate lead gtag into hosted landings and fires it only after a successful lead submission. Configure Lead as Primary when bidding on leads; keep Purchase secondary until deposit reporting is verified, then adjust goals to your bidding strategy.": "Dla leadów online przekaż tml=AW-<account>/<lead-label> w sufiksie Final URL każdego konta reklamowego. Zostaw \"Wywołaj gtag Google Ads przy przekierowaniu\" WYŁĄCZONE: tracker wstrzykuje osobny gtag dla leada do hostowanych landing page'y i wywołuje go dopiero po udanym zgłoszeniu leada. Ustaw Lead jako Primary, gdy licytujesz na leady; trzymaj Purchase jako secondary, aż zweryfikujesz raportowanie depozytów, a potem dostosuj cele do swojej strategii licytacji.",
  "Sends the Google Ads conversion server-side on the broker postback, matched by {gclid} — no gtag on the landing and no API. Account id and label are read from the {tm} tag (AW-<account>/<label>) you already put in the ad Final URL suffix.": "Wysyła konwersję Google Ads po stronie serwera przy postbacku brokera, dopasowaną po {gclid} — bez gtag na landing page i bez API. Id konta i label są odczytywane z tagu {tm} (AW-<account>/<label>), który już masz w sufiksie Final URL reklamy.",
  "Deposit → Purchase (primary, with value) — fires on sale": "Deposit → Purchase (primary, z wartością) — wywoływane przy sprzedaży",
  "Registration → Lead (secondary) — fires on lead": "Registration → Lead (secondary) — wywoływane przy leadzie",
  "For the Lead tag add its label to the ad Final URL suffix as tml=<label> (same AW account). If tml is empty the Lead beacon is skipped automatically. Keep Lead as Secondary in Google so optimization stays on deposits.": "Dla tagu Lead dodaj jego label do sufiksu Final URL reklamy jako tml=<label> (to samo konto AW). Jeśli tml jest puste, beacon Lead jest automatycznie pomijany. Trzymaj Lead jako Secondary w Google, żeby optymalizacja pozostała na depozytach.",
  "Test integration": "Testuj integrację",
  "Test lead accepted": "Testowy lead zaakceptowany",
  "Test lead not accepted": "Testowy lead niezaakceptowany",
  "This permanently deletes all matching clicks and conversions. This cannot be undone.": "To trwale usunie wszystkie pasujące kliknięcia i konwersje. Tej operacji nie można cofnąć.",
  "This permanently deletes the conversion type. Existing conversions keep their stored status.": "To trwale usunie typ konwersji. Istniejące konwersje zachowają zapisany status.",
  "This permanently deletes the metric column from reports.": "To trwale usunie kolumnę metryki z raportów.",
  "This permanently deletes the saved report definition.": "To trwale usunie zapisaną definicję raportu.",
  "This permanently deletes the scheduled report.": "To trwale usunie zaplanowany raport.",
  "This removes the manual cost and reverses its contribution to the campaign spend.": "To usunie ręczny koszt i cofnie jego wpływ na wydatki kampanii.",
  "Thursday": "Czwartek",
  "To": "Do",
  "Total leads": "Łącznie leadów",
  "Tracking domains are managed on the Domains page — add and verify a custom domain there.": "Domenami do trackingu zarządzasz na stronie Domeny — tam dodasz i zweryfikujesz własną domenę.",
  "Traffic Simulation": "Symulacja ruchu",
  "Traffic loss %": "% utraty ruchu",
  "Traffic trends": "Trendy ruchu",
  "Transition rules: which statuses a conversion in this type may move to. Leave all unchecked to allow any transition.": "Reguły przejść: do jakich statusów może przejść konwersja tego typu. Zostaw wszystko odznaczone, żeby zezwolić na dowolne przejście.",
  "Treat empty User-Agent as bot": "Traktuj pusty User-Agent jako bota",
  "Trends": "Trendy",
  "Tuesday": "Wtorek",
  "US, CA, GB": "US, CA, GB",
  "US, CA, GB, RU": "US, CA, GB, RU",
  "US, GB, DE": "US, GB, DE",
  "US,RU,DE": "US,RU,DE",
  "Uniqueness method": "Metoda unikalności",
  "Update reporting semantics and status transitions.": "Zaktualizuj semantykę raportowania i przejścia statusów.",
  "Update the formula, format or decimals.": "Zaktualizuj formułę, format lub liczbę miejsc dziesiętnych.",
  "Use a negative amount to book a correction.": "Użyj ujemnej kwoty, aby zaksięgować korektę.",
  "Viewer": "Przeglądający",
  "Visitor ID": "ID odwiedzającego",
  "Wednesday": "Środa",
  "Weekly": "Tygodniowo",
  "Weights equalized": "Wagi wyrównane",
  "White": "Biały",
  "Whitelist": "Biała lista",
  "Whitelisted": "Na białej liście",
  "X-Requested-With": "X-Requested-With",
  "analyst": "analityk",
  "box/goal id": "id boxa/goala",
  "buy, cheap, discount": "kup, tanio, rabat",
  "cpa, nutra, en": "cpa, nutra, en",
  "day": "dzień",
  "days": "dni",
  "e.g. Q3 influencer flat fee": "np. stała stawka za influencera Q3",
  "e.g. Second deposit": "np. Drugi depozyt",
  "e.g. Unique CR": "np. Unikalny CR",
  "e.g. Weekly digest": "np. Cotygodniowe podsumowanie",
  "e.g. Weekly performance": "np. Wyniki tygodniowe",
  "email / phone / name": "email / telefon / imię",
  "free, demo": "free, demo",
  "redirect": "redirect",
  "statuses on schedule": "statusy wg harmonogramu",
  "Remove variant": "Usuń wariant",
  "Start test": "Uruchom test",
  "Pause test": "Wstrzymaj test",
  "View test results": "Zobacz wyniki testu",
  "Remove parameter": "Usuń parametr",
  "Remove status mapping": "Usuń mapowanie statusu",
  "Copy postback URL template": "Kopiuj szablon URL postbacku",
  "Copy inbound postback URL": "Kopiuj przychodzący URL postbacku",
  "Remove IP from blacklist": "Usuń IP z czarnej listy",
  "Remove IP from whitelist": "Usuń IP z białej listy",
  "Copy curl command": "Kopiuj polecenie curl",
  "Copy JS snippet": "Kopiuj fragment JS",
  "Copy snippet": "Kopiuj fragment kodu",
  "Remove postback": "Usuń postback",
  "Campaign actions": "Akcje kampanii",
  "Remove vendor": "Usuń dostawcę",
  "Remove campaign": "Usuń kampanię",
  "Remove value": "Usuń wartość",
  "Remove field": "Usuń pole",
  "Copy webhook URL": "Kopiuj URL webhooka",
  "Copy landing page URL": "Kopiuj URL landing page",
  "Open landing page": "Otwórz landing page",
  "Remove partner route": "Usuń trasę partnera",
  "Copy lead-form URL": "Kopiuj URL formularza lead",
  "Copy offer URL": "Kopiuj URL oferty",
  "Delete list entry": "Usuń wpis z listy",
  "Copy secret": "Kopiuj sekret",
  "Remove time range": "Usuń zakres czasu",
  "Remove date range": "Usuń zakres dat",
  "Pause stream": "Wstrzymaj stream",
  "Resume stream": "Wznów stream",
  "Open redirect URL": "Otwórz URL przekierowania",
  "Open offer URL": "Otwórz URL oferty",
  "Copy postback URL": "Kopiuj URL postbacku",
  "Delete rule": "Usuń regułę",
  "Delete filter": "Usuń filtr",
  "Delete traffic rule": "Usuń regułę ruchu",
  "This permanently deletes the traffic rule. Traffic will fall through to the remaining rules or the campaign default.": "To trwale usunie regułę ruchu. Ruch trafi do pozostałych reguł lub do domyślnego ustawienia kampanii.",
  "Delete fraud filter": "Usuń filtr antyfraudowy",
  "This permanently deletes the fraud filter. Traffic it currently blocks or scores will no longer be evaluated by this rule.": "To trwale usunie filtr antyfraudowy. Ruch, który obecnie blokuje lub ocenia, nie będzie już sprawdzany przez tę regułę.",
  "Action (no page — hand off to the offer)": "Action (bez strony — przekazanie do oferty)",
  "After click (at redirect)": "Po kliknięciu (przy przekierowaniu)",
  "Before click (at landing — enables offer macros)": "Przed kliknięciem (na landing page — włącza makra oferty)",
  "Match the mobile carrier from the edge X-Carrier header. Masks, /regex/ and @empty supported — e.g. Vodafone*, /^T-Mobile/.": "Dopasuj operatora mobilnego na podstawie nagłówka X-Carrier z edge'a. Obsługiwane maski, /regex/ i @empty — np. Vodafone*, /^T-Mobile/.",
  "Mobile operator / carrier": "Operator mobilny / carrier",
  "Offer selection moment": "Moment wyboru oferty",
  "Preload (serve the page from the tracker domain)": "Preload (serwuj stronę z domeny trackera)",
  "Preload fetches the page server-side and serves it under your tracker domain; Action shows nothing and lets the stream pick an offer.": "Preload pobiera stronę po stronie serwera i serwuje ją pod twoją domeną trackera; Action nic nie pokazuje i pozwala streamowi wybrać ofertę.",
  "QR code": "Kod QR",
  "Redirect (send visitor to the URL)": "Redirect (wyślij odwiedzającego pod URL)",
  "Remote rotator (fetch target)": "Rotator zdalny (pobiera cel)",
  "Scan to open the tracking link on a device.": "Zeskanuj, aby otworzyć link trackingowy na urządzeniu.",
  "Transparent (server-side fetch)": "Przezroczysty (pobieranie po stronie serwera)",
  "When to pick the offer for this stream. After (default): at redirect time. Before: at landing-serve time, so {offer_name} / {offer_value:*} macros render on the landing page.": "Kiedy wybrać ofertę dla tego streamu. Po (domyślnie): w momencie przekierowania. Przed: w momencie serwowania landing page, dzięki czemu makra {offer_name} / {offer_value:*} wyrenderują się na landing page.",
  "Added to favourites": "Dodano do ulubionych",
  "Credentials and settings for this partner. Fields marked * are required.": "Dane dostępowe i ustawienia tego partnera. Pola oznaczone * są wymagane.",
  "Key created": "Klucz utworzony",
  "Removed from favourites": "Usunięto z ulubionych",
  "Affiliate network archived": "Sieć afiliacyjna zarchiwizowana",
  "Archive affiliate network": "Archiwizuj sieć afiliacyjną",
  "Archive landing page": "Archiwizuj landing page",
  "Archive offer": "Archiwizuj ofertę",
  "Archive stream": "Archiwizuj stream",
  "Archive traffic source": "Archiwizuj źródło ruchu",
  "Archived at": "Zarchiwizowano",
  "Archived items are hidden from your lists. Restore them or delete them permanently.": "Zarchiwizowane elementy są ukryte na twoich listach. Przywróć je lub usuń na stałe.",
  "Delete permanently": "Usuń na stałe",
  "Deleted permanently": "Usunięto na stałe",
  "Error loading archive": "Błąd wczytywania archiwum",
  "Error restoring": "Błąd przywracania",
  "Landing page archived": "Landing page zarchiwizowany",
  "No archived items": "Brak zarchiwizowanych elementów",
  "Offer archived": "Oferta zarchiwizowana",
  "Restored": "Przywrócono",
  "Stream archived": "Stream zarchiwizowany",
  "This will move \"{name}\" to the archive. You can restore it or delete it permanently from the Archive page.": "To przeniesie \"{name}\" do archiwum. Możesz to przywrócić lub usunąć na stałe ze strony Archiwum.",
  "This will permanently delete \"{name}\". This action cannot be undone.": "To usunie \"{name}\" na stałe. Tej operacji nie można cofnąć.",
  "Traffic source archived": "Źródło ruchu zarchiwizowane",
  "View archived": "Pokaż zarchiwizowane",
  "Start date is required": "Data rozpoczęcia jest wymagana",
  "Enter a valid cost": "Podaj prawidłowy koszt",
  "Updated {n} clicks": "Zaktualizowano {n} kliknięć",
  "Failed to update costs": "Nie udało się zaktualizować kosztów",
  "Statistics deleted": "Statystyki usunięte",
  "Failed to delete statistics": "Nie udało się usunąć statystyk",
  "Maintenance & costs": "Konserwacja i koszty",
  "Retroactively rewrite click costs, reset statistics, or grab an alternative tracking link.": "Retroaktywnie nadpisz koszty kliknięć, zresetuj statystyki lub pobierz alternatywny link trackingowy.",
  "Update costs": "Aktualizuj koszty",
  "Retroactively (re)write per-click cost for clicks in a time range. Total mode spreads the amount across matched clicks; per-click applies it to each.": "Retroaktywnie (nad)pisz koszt za kliknięcie dla kliknięć w danym przedziale czasu. Tryb Całość rozkłada kwotę na dopasowane kliknięcia; za kliknięcie stosuje ją do każdego z osobna.",
  "Start date": "Data rozpoczęcia",
  "End date": "Data zakończenia",
  "Total (spread across clicks)": "Całość (rozłożona na kliknięcia)",
  "Per click": "Za kliknięcie",
  "Only unique clicks": "Tylko unikalne kliknięcia",
  "Skip bot clicks": "Pomiń kliknięcia botów",
  "Clean statistics": "Wyczyść statystyki",
  "Alternative link prefixes": "Alternatywne prefiksy linków",
  "Any of these path prefixes route the same tracking id — rotate them across sources to dodge blocklists.": "Każdy z tych prefiksów ścieżki prowadzi do tego samego tracking id — rotuj je między źródłami, aby omijać blacklisty.",
  "Delete statistics": "Usuń statystyki",
  "This permanently deletes all clicks and conversions for this campaign. The campaign configuration is kept. This cannot be undone.": "To trwale usuwa wszystkie kliknięcia i konwersje tej kampanii. Konfiguracja kampanii zostaje zachowana. Tej operacji nie można cofnąć.",
  "Error loading S2S log": "Błąd wczytywania logu S2S",
  "S2S postback log": "Log postbacków S2S",
  "Every outbound conversion postback fired across your campaigns — filter by campaign, status or result.": "Każdy wysłany postback konwersji ze wszystkich kampanii — filtruj po kampanii, statusie lub wyniku.",
  "Any result": "Dowolny wynik",
  "Outbound conversion postbacks will appear here once your campaigns start forwarding conversions.": "Wysyłane postbacki konwersji pojawią się tutaj, gdy twoje kampanie zaczną przekazywać konwersje.",
  "Result": "Wynik",
  "HTTP": "HTTP",
  "Error loading system status": "Błąd wczytywania stanu systemu",
  "Paste the Tor exit list first": "Najpierw wklej listę węzłów wyjściowych Tor",
  "Tor exit list updated": "Lista węzłów wyjściowych Tor zaktualizowana",
  "Failed to update Tor exit list": "Nie udało się zaktualizować listy węzłów wyjściowych Tor",
  "Process uptime, database size, data-processing queue and host metrics.": "Czas działania procesu, rozmiar bazy danych, kolejka przetwarzania danych i metryki hosta.",
  "Process": "Proces",
  "Uptime": "Czas działania",
  "Started": "Uruchomiono",
  "Python": "Python",
  "Platform": "Platforma",
  "Database": "Baza danych",
  "Total documents": "Łączna liczba dokumentów",
  "Data processing": "Przetwarzanie danych",
  "Analytics backend": "Backend analityki",
  "Ingest mode": "Tryb przyjmowania danych",
  "Queue depth": "Długość kolejki",
  "Click uniqueness": "Unikalność kliknięć",
  "Redis ping": "Ping Redis",
  "Host": "Host",
  "Load average": "Średnie obciążenie",
  "Disk used": "Użyty dysk",
  "Disk free": "Wolny dysk",
  "Cron": "Cron",
  "Last cost sync": "Ostatnia synchronizacja kosztów",
  "FX rates": "Kursy walut",
  "No FX rates cached.": "Brak kursów walut w pamięci podręcznej.",
  "Tor exit list": "Lista węzłów wyjściowych Tor",
  "Paste a newline-delimited Tor exit-node dump (e.g. from torbulkexitlist) to refresh the in-memory block list.": "Wklej listę węzłów wyjściowych Tor oddzielonych znakiem nowej linii (np. z torbulkexitlist), aby odświeżyć listę blokad w pamięci.",
  "Replace list": "Zastąp listę",
  "Error loading fingerprints": "Błąd wczytywania odcisków",
  "Fingerprint updated": "Odcisk zaktualizowany",
  "Failed to update fingerprint": "Nie udało się zaktualizować odcisku",
  "JA3 / JA4 fingerprint overrides — mark a fingerprint as good or bad to steer bot detection.": "Nadpisania odcisków JA3 / JA4 — oznacz odcisk jako dobry lub zły, aby wpłynąć na wykrywanie botów.",
  "All classifications": "Wszystkie klasyfikacje",
  "All kinds": "Wszystkie rodzaje",
  "No fingerprint overrides yet": "Brak nadpisań odcisków",
  "As traffic arrives, JA3/JA4 fingerprints appear here so you can mark known-good or known-bad clients.": "Gdy napływa ruch, odciski JA3/JA4 pojawiają się tutaj, dzięki czemu możesz oznaczać znane dobre lub złe klienty.",
  "Fingerprint": "Odcisk",
  "Kind": "Rodzaj",
  "Label": "Etykieta",
  "Hits": "Trafienia",
  "Last seen": "Ostatnio widziano",
  "Classification": "Klasyfikacja",
  "Telegram alerts": "Alerty na Telegramie",
  "Deploy + server-error notifications for the operator.": "Powiadomienia o wdrożeniach i błędach serwera dla operatora.",
  "Configured": "Skonfigurowane",
  "Not configured": "Nie skonfigurowano",
  "Topic": "Temat",
  "Topic ID (optional)": "ID tematu (opcjonalnie)",
  "Leave the token empty to keep the saved one.": "Zostaw token pusty, aby zachować zapisany.",
  "Save & send test": "Zapisz i wyślij test",
  "Test message delivered": "Wiadomość testowa dostarczona",
  "Send failed": "Błąd wysyłania",
  "Chat ID is required": "Chat ID jest wymagane",
  "Nightly DB backups": "Nocne kopie bazy danych",
  "A full copy of the database every night, kept on the persistent volume.": "Pełna kopia bazy danych co noc, przechowywana na trwałym wolumenie.",
  "Daily at": "Codziennie o",
  "Copies kept": "Przechowywane kopie",
  "Stored": "Zapisano",
  "Latest": "Najnowsza",
  "No backups yet": "Brak kopii zapasowych",
  "Run backup now": "Wykonaj kopię teraz",
  "Backup started — the result will arrive in the monitoring topic.": "Kopia zapasowa rozpoczęta — wynik pojawi się w temacie monitoringu.",
  "Platform admin": "Administrator platformy",
  "Operator": "Operator",
  "Cross-tenant back-office: accounts, access and platform health.": "Back-office dla wszystkich kont: dostępy, konta i stan platformy.",
  "Accounts": "Konta",
  "New sign-ups": "Nowe rejestracje",
  "Last 30 days": "Ostatnie 30 dni",
  "Clicks (24h)": "Kliknięcia (24h)",
  "Clicks (30d)": "Kliknięcia (30d)",
  "Conversions (30d)": "Konwersje (30d)",
  "Platform state": "Stan platformy",
  "Self-signup": "Samodzielna rejestracja",
  "Open": "Otwarta",
  "Closed": "Zamknięta",
  "Controlled by the DISABLE_REGISTRATION variable on Railway.": "Kontrolowane przez zmienną DISABLE_REGISTRATION w Railway.",
  "Root admins": "Admini root",
  "From PLATFORM_ADMIN_EMAILS — manage the list on Railway.": "Z PLATFORM_ADMIN_EMAILS — listą zarządzasz w Railway.",
  "Granted admins": "Nadani admini",
  "Every registered account. Block access or grant platform admin.": "Wszystkie zarejestrowane konta. Zablokuj dostęp albo nadaj admina platformy.",
  "Search by email or name…": "Szukaj po emailu lub nazwie…",
  "Plan": "Plan",
  "Last click": "Ostatni klik",
  "No accounts found": "Nie znaleziono kont",
  "Root admin": "Admin root",
  "Client": "Klient",
  "Managed on Railway": "Zarządzane w Railway",
  "Grant platform admin": "Nadaj admina platformy",
  "Grant platform admin?": "Nadać admina platformy?",
  "Make admin": "Nadaj admina",
  "Revoke platform admin": "Odbierz admina platformy",
  "Revoke platform admin?": "Odebrać admina platformy?",
  "Revoke admin": "Odbierz admina",
  "Block account": "Zablokuj konto",
  "Block this account?": "Zablokować to konto?",
  "The user loses access immediately — every session is rejected until you unblock them. Their campaigns and tracking links keep serving traffic.": "Użytkownik od razu traci dostęp — każda sesja jest odrzucana, dopóki go nie odblokujesz. Jego kampanie i linki trackingowe nadal obsługują ruch.",
  "Reason (optional)": "Powód (opcjonalnie)",
  "Visible to admins only": "Widoczne tylko dla adminów",
  "Unblock": "Odblokuj",
  "Unblock account": "Odblokuj konto",
  "Unblock this account?": "Odblokować to konto?",
  "The user will be able to sign in again immediately.": "Użytkownik od razu znów będzie mógł się zalogować.",
  "This user gets operator access: the platform back-office, every account, and platform settings. The grant is audit-logged.": "Ten użytkownik otrzymuje dostęp operatora: zaplecze platformy, wszystkie konta i ustawienia platformy. Nadanie trafia do dziennika audytu.",
  "The user keeps their account but loses operator access.": "Użytkownik zachowuje konto, ale traci dostęp operatora.",
  "Account blocked": "Konto zablokowane",
  "Account unblocked": "Konto odblokowane",
  "Platform admin granted": "Admin platformy nadany",
  "Platform admin revoked": "Admin platformy odebrany",
  "Failed to load platform overview": "Nie udało się wczytać przeglądu platformy",
  "Failed to load users": "Nie udało się wczytać użytkowników",
  "{count} accounts": "{count} kont",
  "Page {page} of {total}": "Strona {page} z {total}",
  "Change plan": "Zmień plan",
  "Plan updated": "Plan zaktualizowany",
  "Sets the edition directly (status \"active\", no trial) — for manual and comp accounts. Accounts with a live Stripe subscription must change plans through Stripe.": "Ustawia edycję bezpośrednio (status „active”, bez triala) — dla kont ręcznych i gratisowych. Konta z aktywną subskrypcją Stripe muszą zmieniać plan przez Stripe.",
  "Account deleted": "Konto usunięte",
  "Delete account": "Usuń konto",
  "Delete this account permanently?": "Usunąć to konto na stałe?",
  "This wipes the account and ALL of its data — campaigns, clicks, conversions, offers, landings, domains, reports. It cannot be undone.": "To kasuje konto i WSZYSTKIE jego dane — kampanie, kliki, konwersje, oferty, landingi, domeny, raporty. Tego nie da się cofnąć.",
  "We sent a confirmation link to {email}. Open it to activate your account — the link is valid for 24 hours.": "Wysłaliśmy link potwierdzający na {email}. Otwórz go, by aktywować konto — link jest ważny przez 24 godziny.",
  "Check your spam folder if it doesn't arrive within a minute.": "Jeśli nie dotrze w ciągu minuty, sprawdź folder spam.",
  "Resend the email": "Wyślij email ponownie",
  "Sent — check your inbox": "Wysłano — sprawdź skrzynkę",
  "Could not resend the email — try again.": "Nie udało się wysłać emaila ponownie — spróbuj jeszcze raz.",
  "Back to sign in": "Wróć do logowania",
  "Confirming your email…": "Potwierdzamy twój email…",
  "This takes a second.": "To chwila.",
  "Email confirmed — welcome aboard!": "Email potwierdzony — witaj na pokładzie!",
  "Taking you to your dashboard…": "Przenosimy cię do panelu…",
  "Verification failed — the link may have expired.": "Weryfikacja nie powiodła się — link mógł wygasnąć.",
  "The verification link is incomplete — open the link from the email again.": "Link weryfikacyjny jest niekompletny — otwórz ponownie link z e-maila.",
  "Use 8–128 characters; long passphrases are recommended": "Użyj 8–128 znaków; zalecane są długie frazy hasła",
  "Users": "Użytkownicy",
  "Error": "Błąd",
  "Failed to load documentation.": "Nie udało się wczytać dokumentacji.",
  "Production readiness": "Gotowość do produkcji",
  "Ready": "Gotowe",
  "Attention required": "Wymaga uwagi",
  "Secret-free checks for runtime configuration and isolation controls.": "Sprawdzenia konfiguracji środowiska i izolacji bez ujawniania sekretów.",
  "Environment": "Środowisko",
  "production": "produkcja",
  "development": "deweloperskie",
  "Rate limiter": "Limiter zapytań",
  "Access token TTL": "Czas ważności tokenu dostępu",
  "Backend root": "Backend jako root",
  "Blocking checks": "Sprawdzenia blokujące",
  "Failed to load integrity status": "Nie udało się wczytać stanu integralności",
  "Traffic suspended": "Ruch wstrzymany",
  "Traffic resumed": "Ruch wznowiony",
  "Data integrity": "Integralność danych",
  "Mandatory unique indexes protect click attribution, conversions and billing idempotency.": "Obowiązkowe unikalne indeksy chronią atrybucję kliknięć, konwersje i idempotentność rozliczeń.",
  "All mandatory indexes are present and unique.": "Wszystkie wymagane indeksy istnieją i są unikalne.",
  "Do not ignore this warning. Review backend startup logs before changing indexes.": "Nie ignoruj tego ostrzeżenia. Sprawdź logi uruchomienia backendu przed zmianą indeksów.",
  "Missing": "Brak",
  "Not unique": "Nieunikalny",
  "Resume campaign traffic": "Wznów ruch kampanii",
  "Resume traffic": "Wznów ruch",
  "Suspend campaign traffic": "Wstrzymaj ruch kampanii",
  "Suspend traffic": "Wstrzymaj ruch",
  "Suspend all campaign traffic for this account?": "Wstrzymać cały ruch kampanii na tym koncie?",
  "Public tracking links will return the same inactive-campaign response. Campaign settings stay unchanged, and traffic can be resumed instantly.": "Publiczne linki śledzące będą zwracać odpowiedź dla nieaktywnej kampanii. Ustawienia kampanii pozostają bez zmian, a ruch możesz wznowić natychmiast.",
  "Resume campaign traffic for this account?": "Wznowić ruch kampanii na tym koncie?",
  "Existing active campaigns and tracking links will start serving again.": "Aktywne kampanie i linki śledzące znów zaczną działać.",
  "Password changed — other devices have been signed out": "Hasło zmienione — na innych urządzeniach wylogowano sesje",
  "Sign out of every device, including this one? You will need to sign in again.": "Wylogować się ze wszystkich urządzeń, łącznie z tym? Będziesz musiał zalogować się ponownie.",
  "All sessions signed out": "Wszystkie sesje wylogowane",
  "Error signing out sessions": "Błąd podczas wylogowywania sesji",
  "Changing your password also signs out every other device.": "Zmiana hasła wylogowuje też wszystkie inne urządzenia.",
  "Active sessions": "Aktywne sesje",
  "Lost a laptop, or think someone else has your password? End every session at once.": "Zgubiłeś laptopa albo podejrzewasz, że ktoś zna twoje hasło? Zakończ wszystkie sesje naraz.",
  "This signs out every device, including this one. Signing back in takes one password.": "Spowoduje to wylogowanie na wszystkich urządzeniach, łącznie z tym. Żeby wrócić, wystarczy hasło.",
  "Sign out everywhere": "Wyloguj wszędzie",
  "Pages": "Strony",
  "Copy path": "Kopiuj ścieżkę",
  "Choose your plan": "Wybierz plan",
  "Every plan includes the whole tracker.": "Każdy plan zawiera pełny tracker.",
  "{n} days free": "{n} dni za darmo",
  "Billed today": "Płatność dziś",
  "Continue": "Dalej",
  "Start and Pro: {n} days free, card required. Charged automatically on day {next} unless you cancel. One free trial per account.": "Start i Pro: {n} dni za darmo, wymagana karta. Automatyczna płatność w dniu {next}, chyba że anulujesz. Jedna darmowa wersja próbna na konto.",
  "Could not load plans.": "Nie udało się wczytać planów.",
  "Try again": "Spróbuj ponownie",
  "Opening secure payment…": "Otwieranie bezpiecznej płatności…",
  "Could not open the payment page. Choose a plan to continue.": "Nie udało się otworzyć strony płatności. Wybierz plan, aby kontynuować.",
  "Start and Pro come with {n} days free. A card is required up front: Stripe checks it but charges nothing until day {next}, then the plan renews automatically. Cancel any time before the trial ends and you pay nothing. Team and Network are billed on the day you subscribe. One free trial per account.": "Start i Pro mają {n} dni za darmo. Karta jest wymagana od razu: Stripe ją weryfikuje, ale nic nie pobiera aż do dnia {next}, potem plan odnawia się automatycznie. Anuluj w dowolnym momencie przed końcem okresu próbnego, a nic nie zapłacisz. Team i Network są płatne w dniu subskrypcji. Jedna darmowa wersja próbna na konto.",
  "Choose a plan to open your workspace.": "Wybierz plan, aby otworzyć swój workspace.",
  "Payment was not completed. Choose a plan to continue.": "Płatność nie została zakończona. Wybierz plan, aby kontynuować.",
  "Confirming your payment…": "Potwierdzanie płatności…",
  "Payment received, but confirmation is taking longer than usual. Refresh this page in a minute.": "Płatność przyjęta, ale potwierdzenie trwa dłużej niż zwykle. Odśwież tę stronę za minutę.",
  "Payment confirmed. Welcome aboard!": "Płatność potwierdzona. Witaj na pokładzie!",
  "Free trial until {date}. Your card will be charged automatically on that day — nothing to do. Cancel before then in Manage billing and you pay nothing.": "Darmowy okres próbny do {date}. Tego dnia karta zostanie obciążona automatycznie — nic nie musisz robić. Anuluj wcześniej w Zarządzaj płatnościami, a nic nie zapłacisz.",
  "Start {n}-day free trial": "Zacznij {n}-dniowy okres próbny",
  "Subscribe": "Subskrybuj",
  "Your free trial has already been used, so this plan is billed today.": "Twój darmowy okres próbny został już wykorzystany, więc ten plan jest płatny dziś.",
  "To switch plans, contact support — we move you without losing paid days.": "Aby zmienić plan, napisz do supportu — przeniesiemy cię bez utraty opłaconych dni.",
  "Everything in Network, on your own server or cloud, installed with one command. Unlimited users, domains and history.": "Wszystko z Network, na twoim własnym serwerze lub w chmurze, zainstalowane jedną komendą. Bez limitu użytkowników, domen i historii.",
  "After payment you issue your licence key on the page Self-hosted and install the tracker yourself with one command, following the step-by-step guide. If you prefer, we set it up for you or move you off your old tracker. The hosting is billed to you by your provider.": "Po płatności wygenerujesz swój klucz licencyjny na stronie Self-hosted i zainstalujesz tracker sam, jedną komendą, postępując według instrukcji krok po kroku. Jeśli wolisz, skonfigurujemy to za ciebie albo przeniesiemy cię ze starego trackera. Za hosting płacisz bezpośrednio swojemu dostawcy.",
  "Install on your own server": "Instalacja na własnym serwerze",
  "Or we set it up for you, on request": "Albo skonfigurujemy to za ciebie, na życzenie",
  "Your own server or a dedicated cloud, with a licence key.": "Twój własny serwer lub dedykowana chmura, z kluczem licencyjnym.",
  "Monthly or 12 months": "Miesięcznie lub 12 miesięcy",
  "Cannot reach the server. Check your connection and try again.": "Nie można połączyć się z serwerem. Sprawdź połączenie i spróbuj ponownie.",
  "Clicks are never counted": "Kliknięcia nigdy nie są liczone",
  "However much traffic you send, the invoice does not move.": "Niezależnie od tego, ile ruchu wyślesz, faktura się nie zmienia.",
  "Bots filtered on arrival": "Boty filtrowane od razu",
  "Datacenter, VPN and proxy traffic is handled before a page loads.": "Ruch z datacenter, VPN i proxy jest obsługiwany, zanim załaduje się strona.",
  "First link in five minutes": "Pierwszy link w pięć minut",
  "Add a source, create a campaign, copy the link.": "Dodaj źródło ruchu, stwórz kampanię, skopiuj link.",
  "Your workspace": "Twój workspace",
  "Everything is already running": "Wszystko już działa",
  "Your workspace, your campaigns, your numbers.": "Twoja przestrzeń, twoje kampanie, twoje liczby.",
  "Confirm your email": "Potwierdź e-mail",
  "Open the link we sent and your workspace is ready.": "Otwórz link, który wysłaliśmy, a twoja przestrzeń będzie gotowa.",
  "Enter your code": "Wpisz swój kod",
  "Six digits from your authenticator app.": "Sześć cyfr z twojej aplikacji uwierzytelniającej.",
  "Create your account": "Utwórz konto",
  "Two fields and a password. Tracking is live in minutes.": "Dwa pola i hasło. Tracking działa w kilka minut.",
  "We sent a confirmation link to": "Wysłaliśmy link potwierdzający na",
  "Check spam if it is not there within a minute. The link lasts 24 hours.": "Jeśli nie dotrze w ciągu minuty, sprawdź spam. Link jest ważny 24 godziny.",
  "Sent again. Give it a moment.": "Wysłano ponownie. Daj mu chwilę.",
  "Sending": "Wysyłanie",
  "Use a different account": "Użyj innego konta",
  "Verification code": "Kod weryfikacyjny",
  "Checking": "Sprawdzanie",
  "Signing in": "Logowanie",
  "Your name": "Twoje imię",
  "At least 8 characters.": "Co najmniej 8 znaków.",
  "Creating": "Tworzenie",
  "Continue with": "Kontynuuj przez",
  "No account yet?": "Nie masz jeszcze konta?",
  "Create one": "Utwórz je",
  "New accounts are closed at the moment.": "Nowe konta są obecnie zamknięte.",
  "Terms": "Regulamin",
  "and": "i",
  "Privacy": "Prywatność",
  "History kept forever": "Historia przechowywana na zawsze",
  "Light theme": "Jasny motyw",
  "Dark theme": "Ciemny motyw",
  "Match system": "Zgodnie z systemem",
  "Theme": "Motyw",
  "Navigate": "Nawigacja",
  "Not included on your plan. Open Billing to upgrade.": "Niedostępne w twoim planie. Otwórz Płatności, aby ulepszyć plan.",
  "Talk to us": "Porozmawiaj z nami",
  "Automatic flow optimiser": "Automatyczny optymalizator flow",
  "Learning bot detection": "Wykrywanie botów z uczeniem się",
  "Lead forms into a CRM": "Formularze leadów do CRM",
  "Roles and 31 permissions": "Role i 31 uprawnień",
  "Single sign on": "Jednokrotne logowanie (SSO)",
  "We move you off your old tracker": "Przenosimy cię ze starego trackera",
  "90 days of history": "90 dni historii",
  "1 year of history": "1 rok historii",
  "2 years of history": "2 lata historii",
  "History kept": "Przechowywana historia",
  "Your first campaigns, with nothing to set up.": "Twoje pierwsze kampanie, bez niczego do konfigurowania.",
  "Everything that makes the work run itself.": "Wszystko, dzięki czemu praca dzieje się sama.",
  "A team, with roles and a paper trail.": "Zespół, z rolami i historią zmian.",
  "A network, under your own brand.": "Sieć, pod twoją własną marką.",
  "Run the tracker on your own server or in a dedicated cloud. Your licence key activates one production server and one test server.": "Uruchom tracker na własnym serwerze lub w dedykowanej chmurze. Twój klucz licencyjny aktywuje jeden serwer produkcyjny i jeden testowy.",
  "Self-hosted installs come with the Enterprise plan. Servers activated earlier stop once their current licence runs out.": "Instalacja na własnym serwerze jest dostępna w planie Enterprise. Serwery aktywowane wcześniej przestają działać po wygaśnięciu obecnej licencji.",
  "This is the only time the key is shown. Store it somewhere safe: you enter it when you install the tracker.": "To jedyny moment, w którym klucz jest widoczny. Zapisz go w bezpiecznym miejscu: podasz go podczas instalacji trackera.",
  "A new key replaces the current one at once. Servers that still use the old key cannot renew their licence and stop within {days} days unless you enter the new key on them.": "Nowy klucz od razu zastępuje obecny. Serwery, które nadal używają starego klucza, nie odnowią licencji i przestaną działać w ciągu {days} dni, jeśli nie wprowadzisz na nich nowego klucza.",
  "The server loses its slot right away and stops within {days} days. Use this when you move the tracker to another server.": "Serwer od razu traci swoje miejsce i przestaje działać w ciągu {days} dni. Użyj tego, gdy przenosisz tracker na inny serwer.",
  "Each server checks in with us once a day and receives a licence valid for {days} days. If it cannot check in, or the subscription ends, it keeps working until that licence runs out and then stops. A test server is limited to {clicks} clicks a day. Only technical data is sent: licence, server id and version, never data about your traffic or your clients.": "Każdy serwer łączy się z nami raz dziennie i otrzymuje licencję ważną przez {days} dni. Jeśli nie może się połączyć albo subskrypcja się skończy, działa dalej aż do wygaśnięcia licencji, a potem się zatrzymuje. Serwer testowy jest ograniczony do {clicks} kliknięć dziennie. Wysyłane są tylko dane techniczne: licencja, ID serwera i wersja – nigdy dane o twoim ruchu czy klientach.",
  "Run this command as root on a fresh server. In about ten minutes it installs everything (Kubernetes, HTTPS certificates, the database and the tracker). Running it again upgrades the install and keeps the data.": "Uruchom tę komendę jako root na czystym serwerze. W około dziesięć minut instaluje wszystko (Kubernetes, certyfikaty HTTPS, bazę danych i tracker). Ponowne uruchomienie aktualizuje instalację i zachowuje dane.",
  "Self-hosted": "Własny serwer",
  "Enterprise": "Enterprise",
  "Licence key": "Klucz licencyjny",
  "Issue licence key": "Wydaj klucz licencyjny",
  "Rotate key": "Wymień klucz",
  "Rotate licence key?": "Wymienić klucz licencyjny?",
  "Licence key issued": "Klucz licencyjny wydany",
  "Server deactivated": "Serwer dezaktywowany",
  "Deactivate this server?": "Dezaktywować ten serwer?",
  "Servers": "Serwery",
  "Production": "Produkcja",
  "Revoked": "Unieważniona",
  "Deactivated": "Dezaktywowany",
  "Deactivate": "Dezaktywuj",
  "Issued": "Wydana",
  "Version": "Wersja",
  "See plans": "Zobacz plany",
  "No servers activated yet.": "Nie masz jeszcze aktywowanych serwerów.",
  "Transfers left (30 days)": "Pozostałe transfery (30 dni)",
  "Could not load this page.": "Nie udało się załadować tej strony.",
  "Licensing is temporarily unavailable. Try again later.": "Licencjonowanie jest chwilowo niedostępne. Spróbuj ponownie później.",
  "Your server: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu or Debian (x86-64). The tracker installs with one command.": "Twój serwer: 4 rdzenie CPU, 8 GB RAM, 50 GB SSD, Ubuntu lub Debian (x86-64). Tracker instalujesz jedną komendą.",
  "Put your licence key in place of the X: it is shown once, when you issue or rotate it.": "Wstaw swój klucz licencyjny w miejsce X: jest pokazywany tylko raz, przy wydaniu lub wymianie.",
  "The first account signed up with this email gets administrator rights on the server.": "Pierwsze konto zarejestrowane na ten e-mail otrzymuje uprawnienia administratora na serwerze.",
  "Without --domain the tracker starts on an address like 1-2-3-4.sslip.io. For your own domain, first point tracker.example.com and api.tracker.example.com at the server, then add --domain tracker.example.com.": "Bez --domain tracker startuje pod adresem w stylu 1-2-3-4.sslip.io. Dla własnej domeny najpierw skieruj tracker.example.com i api.tracker.example.com na serwer, a potem dodaj --domain tracker.example.com.",
  "Install on your server": "Instalacja na twoim serwerze",
  "Server requirements": "Wymagania serwera",
  "Production server": "Serwer produkcyjny",
  "Test server": "Serwer testowy",
  "Operating system": "System operacyjny",
  "Disk space": "Miejsce na dysku",
  "Connection": "Połączenie",
  "Ubuntu 22.04 / 24.04 or Debian 12, x86-64": "Ubuntu 22.04 / 24.04 lub Debian 12, x86-64",
  "4 cores (2 at least)": "4 rdzenie (minimum 2)",
  "8 GB (4 GB at least)": "8 GB (minimum 4 GB)",
  "50 GB SSD (30 GB free at least)": "SSD 50 GB (minimum 30 GB wolnego miejsca)",
  "Public IP address, ports 80 and 443 open": "Publiczny adres IP, otwarte porty 80 i 443",
  "After the install": "Po instalacji",
  "Server state and licence": "Stan serwera i licencji",
  "Upgrade to the newest signed release": "Zaktualizuj do najnowszej podpisanej wersji",
  "Back up the database to /var/backups/xpnsr": "Kopia zapasowa bazy w /var/backups/xpnsr",
  "Copy command": "Kopiuj komendę",
  "Install the tracker on your own server in about 15 minutes. You do not need to know Kubernetes or Linux: you copy one command and the installer does the rest.": "Zainstaluj tracker na własnym serwerze w około 15 minut. Nie musisz znać Kubernetesa ani Linuksa: kopiujesz jedną komendę, a instalator robi resztę.",
  "Install guide": "Przewodnik instalacji",
  "Step-by-step guide": "Przewodnik krok po kroku",
  "Back to Self-hosted": "Wróć do Własny serwer",
  "Step": "Krok",
  "Get a server": "Zdobądź serwer",
  "Optional: your own domain": "Opcjonalnie: własna domena",
  "Issue your licence key": "Wygeneruj klucz licencyjny",
  "Connect to the server": "Połącz się z serwerem",
  "Run the install command": "Uruchom komendę instalacyjną",
  "Open your tracker": "Otwórz swój tracker",
  "Keep it running": "Utrzymanie",
  "Rent a VPS or cloud server from any provider, for example Hetzner, DigitalOcean, OVH, Vultr or AWS Lightsail: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu 24.04 (x86-64). It usually costs 15–60 USD a month, billed to you by the provider.": "Wynajmij VPS lub serwer w chmurze u dowolnego dostawcy, na przykład Hetzner, DigitalOcean, OVH, Vultr lub AWS Lightsail: 4 rdzenie CPU, 8 GB RAM, 50 GB SSD, Ubuntu 24.04 (x86-64). Zwykle kosztuje to 15–60 USD miesięcznie, rozliczane przez dostawcę.",
  "Take a fresh server with nothing else installed, and make sure ports 80 and 443 are open in the provider's firewall.": "Weź czysty serwer bez niczego innego zainstalowanego i upewnij się, że porty 80 i 443 są otwarte w firewallu dostawcy.",
  "Note the server's IP address and the root password or SSH key from the provider's panel.": "Zapisz adres IP serwera oraz hasło root lub klucz SSH z panelu dostawcy.",
  "For your own address, create two DNS records of type A that point at the server's IP address, for example tracker.example.com and api.tracker.example.com. Skip this to start on a free address like 1-2-3-4.sslip.io; you can switch later.": "Dla własnego adresu utwórz dwa rekordy DNS typu A, które wskazują na adres IP serwera, na przykład tracker.example.com i api.tracker.example.com. Możesz to pominąć i zacząć od darmowego adresu jak 1-2-3-4.sslip.io; później możesz to zmienić.",
  "On the page Self-hosted click Issue licence key and save the key somewhere safe: it is shown only once.": "Na stronie Własny serwer kliknij Wygeneruj klucz licencyjny i zapisz klucz w bezpiecznym miejscu: wyświetla się tylko raz.",
  "On Mac or Linux open Terminal, on Windows open PowerShell, and type the command below with your server's IP address. Answer yes to the first question and enter the password.": "Na Macu lub Linuksie otwórz Terminal, na Windowsie otwórz PowerShell i wpisz poniższą komendę z adresem IP twojego serwera. Na pierwsze pytanie odpowiedz yes i wpisz hasło.",
  "Copy the command from the page Self-hosted (your key and email are already in it), paste it into the terminal and press Enter. For your own domain add --domain tracker.example.com to it.": "Skopiuj komendę ze strony Własny serwer (twój klucz i e-mail są już w niej uwzględnione), wklej ją do terminala i naciśnij Enter. Dla własnej domeny dodaj do niej --domain tracker.example.com.",
  "The install takes about 10 minutes. If the connection drops, the install keeps going: reconnect and follow it with the command below.": "Instalacja trwa około 10 minut. Jeśli połączenie się urwie, instalacja działa dalej: połącz się ponownie i śledź ją poniższą komendą.",
  "At the end the installer prints the address of your workspace. Open it and sign up with the administrator email from the command: that account gets administrator rights. The licence activates on its own.": "Na koniec instalator wyświetli adres Twojego workspace. Otwórz go i zarejestruj się na adres e-mail administratora podany w komendzie: to konto dostanie uprawnienia administratora. Licencja aktywuje się sama.",
  "To check everything, run the command below: the licence line should say \"state\":\"active\".": "Żeby wszystko sprawdzić, uruchom komendę poniżej: linia licencji powinna pokazywać \"state\":\"active\".",
  "Updates: the command below installs the newest signed release and keeps your data.": "Aktualizacje: komenda poniżej instaluje najnowsze podpisane wydanie i zachowuje Twoje dane.",
  "Backups: the command below saves the database to /var/backups/xpnsr. Copy it off the server regularly and turn on your provider's snapshots.": "Kopie zapasowe: komenda poniżej zapisuje bazę danych w /var/backups/xpnsr. Regularnie kopiuj ją poza serwer i włącz snapshoty u swojego dostawcy.",
  "Test server: install a second server the same way, choosing Test server on the page Self-hosted.": "Serwer testowy: zainstaluj drugi serwer w ten sam sposób, wybierając Serwer testowy na stronie Self-hosted.",
  "If something goes wrong": "Jeśli coś pójdzie nie tak",
  "ports 80/443 are already in use": "ports 80/443 are already in use (porty 80/443 zajęte)",
  "Another web server runs on this machine. Use a fresh server or stop that web server, then run the command again.": "Na tej maszynie działa już inny serwer WWW. Użyj czystego serwera albo zatrzymaj ten serwer WWW i uruchom komendę ponownie.",
  "The browser says the connection is not private": "Przeglądarka mówi, że połączenie nie jest prywatne",
  "The HTTPS certificate is issued a few minutes after DNS points at the server. Wait five minutes; the command below should show READY True.": "Certyfikat HTTPS jest wydawany kilka minut po tym, jak DNS zacznie wskazywać na serwer. Poczekaj pięć minut; komenda poniżej powinna pokazać READY True.",
  "The licence says the slot is in use": "Licencja mówi, że slot jest zajęty",
  "The key is already active on another server. Deactivate that server on the page Self-hosted, then enter the key on the licence screen of your workspace, or wait up to an hour.": "Ten klucz jest już aktywny na innym serwerze. Dezaktywuj tamten serwer na stronie Self-hosted, a potem wpisz klucz na ekranie licencji w swoim workspace, albo poczekaj do godziny.",
  "licence key not recognised": "licence key not recognised (klucz nierozpoznany)",
  "Paste the key again exactly as saved, or rotate it on the page Self-hosted and use the new one.": "Wklej klucz jeszcze raz dokładnie tak, jak go zapisałeś, albo wygeneruj nowy na stronie Self-hosted i użyj go.",
  "Anything else": "Coś innego",
  "Run the install command again: it is always safe and continues where it stopped. If that does not help, send us the last lines of /var/log/xpnsr-install.log and the output of xpnsr status.": "Uruchom komendę instalacyjną jeszcze raz: zawsze jest bezpieczna i kontynuuje od miejsca, w którym się zatrzymała. Jeśli to nie pomoże, wyślij nam ostatnie linie z /var/log/xpnsr-install.log oraz wynik xpnsr status.",
  "Prefer that we do it?": "Wolisz, żebyśmy zrobili to za Ciebie?",
  "We install the tracker for you, or move you off your old tracker with your campaigns. You open the server in your own hosting account and give us temporary access; it is included in Enterprise.": "Zainstalujemy Ci tracker albo przeniesiemy Cię ze starego trackera razem z kampaniami. Ty zakładasz serwer na swoim własnym hostingu i dajesz nam tymczasowy dostęp; to jest wliczone w Enterprise.",
  "Write to us": "Napisz do nas",
  "Fallback rules": "Reguły zapasowe",
  "Used only when a click matches none of the campaign streams. Set up routing in streams; keep these for rare catch-all cases.": "Używane tylko wtedy, gdy klik nie pasuje do żadnego streamu kampanii. Routing ustawiasz w streamach — tu zostaw rzadkie przypadki awaryjne.",
  "Add the banner to your landing page": "Dodaj baner do swojej landing page",
  "Paste this line into the <head> of every landing page of the campaign. The banner shows only while it is enabled above, and only to visitors from the chosen regions.": "Wklej tę linijkę do <head> każdej landing page kampanii. Baner pojawia się tylko, gdy jest włączony powyżej, i tylko dla odwiedzających z wybranych regionów.",
  "Copy code": "Kopiuj kod",
  "No campaigns yet": "Nie masz jeszcze żadnej kampanii",
  "Audience": "Odbiorcy",
  "Updated at {time}": "Zaktualizowano o {time}",
  "Download ZIP": "Pobierz ZIP",
  "Download failed": "Pobieranie nie powiodło się",
  "Enter the licence key from your account (page Self-hosted). It activates this server, which then renews its licence once a day on its own.": "Wpisz klucz licencyjny ze swojego konta (strona Self-hosted). Aktywuje on ten serwer, który potem sam odnawia licencję raz dziennie.",
  "The licence of this installation has run out or is no longer valid, so the tracker is stopped. Check the Enterprise subscription and the key, then activate again.": "Licencja tej instalacji wygasła lub jest już nieważna, więc tracker został zatrzymany. Sprawdź subskrypcję Enterprise i klucz, a potem aktywuj ponownie.",
  "The licence could not be renewed. The tracker keeps working until {date} and then stops unless a renewal succeeds.": "Nie udało się odnowić licencji. Tracker działa do {date}, a potem się zatrzyma, jeśli odnowienie się nie powiedzie.",
  "Test server: limited to {n} clicks a day.": "Serwer testowy: limit {n} kliknięć dziennie.",
  "This installation is not licensed. Ask the administrator to activate it.": "Ta instalacja nie ma licencji. Poproś administratora o jej aktywację.",
  "Licence activated": "Licencja aktywowana",
  "Licence expired": "Licencja nieważna",
  "Activate this installation": "Aktywuj tę instalację",
  "Licensed to {who} · licence {id}": "Licencja: {who} · {id}",
  "Live clicks": "Kliknięcia na żywo",
  "Open clicks log": "Otwórz log kliknięć",
  "Could not load clicks": "Nie udało się załadować kliknięć",
  "No clicks yet": "Jeszcze brak kliknięć",
  "Send traffic to a tracking link and every click shows up here as it happens.": "Wyślij ruch na link trackingowy, a każde kliknięcie pojawi się tu na żywo.",
  "cloaked": "cloaking",
  "proxy": "proxy",
  "human": "człowiek",
  "{n}s ago": "{n} s temu",
  "Trend": "Trend",
  "Clicks, last 14 days": "Kliknięcia, ostatnie 14 dni",
  "Add level": "Dodaj poziom",
  "Remove level": "Usuń poziom",
  "Last {n} days": "Ostatnie {n} dni",
  "All time": "Cały czas",
  "JA3 / JA4 fingerprint overrides for bot detection": "Ręczna klasyfikacja odcisków JA3 / JA4 do wykrywania botów",
  "Uptime, DB size, data-processing queue and host metrics": "Uptime, rozmiar bazy, kolejka przetwarzania danych i metryki serwera",
  "Outbound conversion postbacks fired across your campaigns": "Wychodzące postbacki konwersji wysyłane ze wszystkich kampanii",
  "Normal — a regular stream with filters. Catch (intercepting) — checked before Normal streams and takes a matching click first, e.g. bots or a test GEO. Fallback — the last stream; it gets traffic that matched nothing else.": "Normalny — zwykły stream z filtrami. Catch (przechwytujący) — sprawdzany przed streamami Normal, przechwytuje pasujący klik jako pierwszy, np. boty albo testowe GEO. Fallback — ostatni stream; trafia do niego ruch, który nie pasował do niczego innego.",
  "Interface: search, shortcuts and language": "Interfejs: wyszukiwanie, skróty i język",
  "CAPI": "CAPI",
  "FAQ": "FAQ",
  "Cost, integrations & ops": "Koszty, integracje i operacje",
  "New campaign": "Nowa kampania",
  "Command palette": "Paleta poleceń",
  "Pre-landing page": "Prelander",
  "good": "dobry",
  "bad": "zły",
  "unknown": "nieznany",
  "Error reports": "Raporty błędów",
  "Server and browser errors grouped by cause. Resolve hides a report until the error happens again; Ignore keeps it quiet.": "Błędy serwera i przeglądarki pogrupowane według przyczyny. Rozwiąż ukrywa raport do czasu, aż błąd wystąpi ponownie; Ignoruj go wycisza.",
  "Unresolved": "Nierozwiązane",
  "Ignored": "Zignorowane",
  "All": "Wszystkie",
  "All sources": "Wszystkie źródła",
  "Server": "Serwer",
  "Search by error text": "Szukaj po treści błędu",
  "Count": "Liczba",
  "First seen": "Pierwsze wystąpienie",
  "No error reports": "Brak raportów błędów",
  "Could not load error reports": "Nie udało się wczytać raportów błędów",
  "Could not load the report": "Nie udało się wczytać raportu",
  "Report updated": "Raport zaktualizowany",
  "Could not update the report": "Nie udało się zaktualizować raportu",
  "Seen {n} times": "Widziano {n} razy",
  "Mark resolved": "Oznacz jako rozwiązane",
  "Reopen": "Otwórz ponownie",
  "Datacenter / hosting VPN / Tor IPs": "IP centrów danych / VPN hostingowych / Tor",
  "Visitors from cloud and hosting networks, VPNs that run on them, and Tor exits get the safe page. Residential proxies cannot be recognised without a paid IP database.": "Odwiedzający z sieci chmurowych i hostingowych, działających na nich VPN-ów oraz węzłów wyjściowych Tor otrzymują bezpieczną stronę. Proxy rezydencjalnych nie da się rozpoznać bez płatnej bazy IP.",
  "Offer only with a Google Ads click ID": "Oferta tylko z click ID z Google Ads",
  "Real Google Ads clicks always carry gclid, gbraid or wbraid; reviewers and link checkers open the link without one. Visitors without a valid click ID get the safe page. Leave off if auto-tagging is disabled or the campaign gets other traffic.": "Prawdziwe kliknięcia z Google Ads zawsze mają gclid, gbraid lub wbraid; recenzenci i sprawdzarki linków otwierają link bez niego. Odwiedzający bez prawidłowego click ID otrzymują bezpieczną stronę. Zostaw wyłączone, jeśli auto-tagowanie jest nieaktywne albo kampania dostaje inny ruch.",
  "Show white page": "Pokaż white page",
  "Shows the campaign white page (the page bots get) instead of an offer. Put it in a Default stream with no filters to send visitors that no other stream accepts to the white page instead of the target URL.": "Pokazuje white page kampanii (stronę, którą widzą boty) zamiast oferty. Umieść to w streamie Default bez filtrów, aby wysyłać na white page, a nie na docelowy URL, odwiedzających, których nie przyjmie żaden inny stream.",
  "Transparent mode fetches the page from our server, so the visitor IP and cookies never reach it. Use it only for your own landing pages, not for affiliate offer links, or conversions may not be counted.": "Tryb transparentny pobiera stronę z naszego serwera, więc IP i cookies odwiedzającego nigdy do niej nie docierają. Używaj tylko dla własnych landing page'y, nie dla linków ofert afiliacyjnych, bo konwersje mogą się nie liczyć.",
  "Check failed": "Sprawdzanie nie powiodło się",
  "Can be shown in iframe mode": "Może być wyświetlana w trybie iframe",
  "Blocked: visitors will see an empty screen in iframe mode": "Zablokowana: w trybie iframe odwiedzający zobaczą pusty ekran",
  "Could not confirm: test it on a real phone before launch": "Nie udało się potwierdzić: przetestuj na prawdziwym telefonie przed startem",
  "Check that the page allows framing. Paste the final offer or landing URL your streams send visitors to.": "Sprawdź, czy strona pozwala na wyświetlanie we frame'ie. Wklej docelowy URL oferty lub landing page, na który twoje streamy wysyłają ruch.",
  "Checking…": "Sprawdzanie…",
  "Check framing": "Sprawdź frame",
};

export default pl;
